/* eslint-disable max-len */

/* eslint-disable quotes  */

/* eslint-disable object-curly-newline */
import { ISelectData } from 'components/atoms/SelectComponent';

export const leiElfKodyPermanent: ISelectData[] = [
    {
        value: '8888',
        labelcz: 'JINY_PRAVNI_KOD'
    }
];

export const leiElfKodySelect = {
    AE: [
        {
            value: 'VTIP',
            labelcz: 'Close Ended Investment Company'
        },
        {
            value: 'GQ8F',
            labelcz: 'Company Limited By Guarantee'
        },
        {
            value: 'QJVN',
            labelcz: 'Company Limited By Shares'
        },
        {
            value: 'MKAG',
            labelcz: 'Cooperative Society'
        },
        {
            value: 'Z2OV',
            labelcz: 'DLT Foundation'
        },
        {
            value: 'VKZD',
            labelcz: 'Foundation'
        },
        {
            value: '375P',
            labelcz: 'Foundation'
        },
        {
            value: 'F3UE',
            labelcz: 'General Partnership'
        },
        {
            value: 'RLB2',
            labelcz: 'General Partnership'
        },
        {
            value: '35BX',
            labelcz: 'Intellectual Property Holding Company '
        },
        {
            value: 'F8VX',
            labelcz: 'Joint Liability Company'
        },
        {
            value: 'RWVW',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '9U6F',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'V2PA',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'H8MU',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'AIR0',
            labelcz: 'Limited Partnership'
        },
        {
            value: '3P03',
            labelcz: 'Open Ended Investment Company'
        },
        {
            value: 'R2YL',
            labelcz: 'Private Company Limited by Guarantee'
        },
        {
            value: 'OSE2',
            labelcz: 'Private Company Limited by Shares'
        },
        {
            value: '70EO',
            labelcz: 'Private Company Limited by Shares'
        },
        {
            value: 'KAEM',
            labelcz: 'Private Company Unlimited with Shares'
        },
        {
            value: '9I58',
            labelcz: 'Private Company Unlimited without Shares'
        },
        {
            value: 'WR09',
            labelcz: 'Private Joint Stock Company'
        },
        {
            value: 'GORM',
            labelcz: 'Professional Company'
        },
        {
            value: 'RWX4',
            labelcz: 'Protected Cell Company'
        },
        {
            value: 'GU5E',
            labelcz: 'Public Company Limited by Shares'
        },
        {
            value: '46QC',
            labelcz: 'Public Company Limited by Shares'
        },
        {
            value: 'VAQS',
            labelcz: 'Public Corporate'
        },
        {
            value: 'JGNU',
            labelcz: 'Public Joint Stock Company'
        },
        {
            value: 'HNPH',
            labelcz: 'Restricted Purposes Company'
        },
        {
            value: 'B13W',
            labelcz: 'Restricted Scope Company'
        },
        {
            value: 'FHRL',
            labelcz: 'Segregated Portfolio Company'
        },
        {
            value: 'LOL8',
            labelcz: 'Simple Commandite Company'
        },
        {
            value: 'MV4S',
            labelcz: 'Sole Proprietor'
        },
        {
            value: 'Z3P8',
            labelcz: 'Unlimited Company'
        }
    ],
    AG: [
        {
            value: 'CDOV',
            labelcz: 'International Business Corporation'
        }
    ],
    AM: [
        { value: '2PRK', labelcz: 'Liakatar enkeraktsʿutʿyun' },
        { value: 'BDYL', labelcz: 'Petakan liazorutʿyunnerov ozhdvats iravabanakan andz' },
        { value: 'GBI5', labelcz: 'Sahmanapʿak patasxanatvutʿyan enkerutʿyun' },
        { value: 'ILEX', labelcz: 'Himnadram' },
        { value: 'J4QX', labelcz: 'Naxararutʿyun ' },
        { value: 'JEMR', labelcz: 'Iravabanakan andzants miutʿyun' },
        { value: 'OLTR', labelcz: 'Bacʿ bazhnetirakan enkerutʿyun' },
        { value: 'PAVK', labelcz: 'Hasarakakan Kazmakepʿutʿyun' },
        { value: 'S8ZK', labelcz: 'Lracʿucʿič patasxanatvutʿyan enkerutʿyun' },
        { value: 'UGWE', labelcz: 'Vstahutʿyan vra himnvats enkeraktsʿutʿyun' },
        { value: 'W9K6', labelcz: 'Pʿak bazhnetirakan enkerutʿyun' }
    ],
    AR: [
        {
            value: 'F0A6',
            labelcz: 'Sociedad Anonima'
        },
        {
            value: 'WUAZ',
            labelcz: 'Sociedad Anonima Unipersonal'
        },
        {
            value: 'HZ6C',
            labelcz: 'Sociedad Cooperativa'
        }
    ],
    AT: [
        {
            value: 'EQOV',
            labelcz: 'Aktiengesellschaft'
        },
        {
            value: 'G3R6',
            labelcz: 'Einzelkaufmann'
        },
        {
            value: 'ECWU',
            labelcz: 'Einzelunternehmer'
        },
        {
            value: 'NIJH',
            labelcz: 'Erwerbs- und Wirtschaftsgenossenschaft'
        },
        {
            value: '69H1',
            labelcz: 'Europäische Genossenschaft (SCE)'
        },
        {
            value: 'O65B',
            labelcz: 'Europäische Gesellschaft (SE)'
        },
        {
            value: 'DM88',
            labelcz: 'Europäische wirtschaftliche Interessenvereinigung'
        },
        {
            value: 'BCSV',
            labelcz: 'Flexible Kapitalgesellschaft'
        },
        {
            value: 'E9OX',
            labelcz: 'Gemeinnützige Stiftung'
        },
        {
            value: '8XDW',
            labelcz: 'Genossenschaft'
        },
        {
            value: 'UI81',
            labelcz: 'Gesellschaft des bürgerlichen Rechts'
        },
        {
            value: 'AXSB',
            labelcz: 'Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'AAL7',
            labelcz: 'Kommandit-Erwerbsgesellschaft'
        },
        {
            value: 'ONF1',
            labelcz: 'Kommanditgesellschaft'
        },
        {
            value: 'JJYT',
            labelcz: 'Körperschaft öffentlichen Rechts'
        },
        {
            value: 'JUHG',
            labelcz: 'Offene Erwerbsgesellschaft'
        },
        {
            value: 'JTAV',
            labelcz: 'Offene Gesellschaft'
        },
        {
            value: 'GVPD',
            labelcz: 'Offene Handelsgesellschaft'
        },
        {
            value: '5WWO',
            labelcz: 'Privatstiftung'
        },
        {
            value: '1NOX',
            labelcz: 'Sonstiger Rechtsträger'
        },
        {
            value: 'JQOI',
            labelcz: 'Sparkasse'
        },
        {
            value: 'NNLI',
            labelcz: 'stille Gesellschaft'
        },
        {
            value: 'DX6Z',
            labelcz: 'Verein'
        },
        {
            value: 'CAQ1',
            labelcz: 'Versicherungsverein auf Gegenseitigkeit'
        }
    ],
    AU: [
        {
            value: '6W6X',
            labelcz: 'Co-operative'
        },
        {
            value: 'ADXG',
            labelcz: 'Fund'
        },
        {
            value: 'BC38',
            labelcz: 'Incorporated association'
        },
        {
            value: 'XHCV',
            labelcz: 'Indigenous Corporation'
        },
        {
            value: 'J4JC',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'TXVC',
            labelcz: 'Limited Proprietary Company'
        },
        {
            value: 'PQHL',
            labelcz: 'No Liability Company'
        },
        {
            value: 'LZFR',
            labelcz: 'Public Company limited by guarantee'
        },
        {
            value: 'R4KK',
            labelcz: 'Public Company limited by shares'
        },
        {
            value: '7TPC',
            labelcz: 'Trust'
        },
        {
            value: 'Q82Q',
            labelcz: 'Unlimited Proprietary Company'
        }
    ],
    AW: [
        {
            value: 'REUP',
            labelcz: 'Aruba vrijgestelde vennootschap'
        },
        {
            value: 'M27U',
            labelcz: 'Besloten vennootschap'
        },
        {
            value: 'GAJN',
            labelcz: 'Commanditaire vennootschap (1)'
        },
        {
            value: 'YCV2',
            labelcz: 'Commanditaire vennootschap (1+)'
        },
        {
            value: 'PCRJ',
            labelcz: 'Cooperatieve vereniging'
        },
        {
            value: 'PT6C',
            labelcz: 'Eenmanszaak'
        },
        {
            value: 'UV8T',
            labelcz: 'Maatschap'
        },
        {
            value: 'P65N',
            labelcz: 'Naamloze vennootschap'
        },
        {
            value: 'CRL9',
            labelcz: 'Stichting'
        },
        {
            value: 'T5RL',
            labelcz: 'Vennootschap buitenlands recht'
        },
        {
            value: 'V905',
            labelcz: 'Vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'CYW2',
            labelcz: 'Vennootschap onder firma'
        },
        {
            value: 'OLAI',
            labelcz: 'Vereniging'
        }
    ],
    AZ: [
        {
            value: 'K81Q',
            labelcz: 'Açıq səhmdar cəmiyyəti'
        },
        {
            value: 'SLXJ',
            labelcz: 'Asılı təsərrüfat cəmiyyəti'
        },
        {
            value: 'HKL3',
            labelcz: 'Əlavə məsuliyyətli cəmiyyət'
        },
        {
            value: 'ZD74',
            labelcz: 'Fondlar'
        },
        {
            value: 'PITR',
            labelcz: 'Hüquqi şəxslərin ittifaqları'
        },
        {
            value: 'U0SP',
            labelcz: 'İctimai birliklər'
        },
        {
            value: 'TD56',
            labelcz: 'Komandit ortaqlıq'
        },
        {
            value: 'DWEA',
            labelcz: 'Kooperativlər'
        },
        {
            value: '6JHZ',
            labelcz: 'Məhdud məsuliyyətli cəmiyyəti'
        },
        {
            value: 'M4LU',
            labelcz: 'Qapalı səhmdar cəmiyyəti'
        },
        {
            value: 'MEJT',
            labelcz: 'Tam ortaqlıq'
        },
        {
            value: '52TH',
            labelcz: 'Törəmə təsərrüfat cəmiyyəti'
        }
    ],
    BE: [
        {
            value: '4L1X',
            labelcz: 'Autonome Gemeinderegie'
        },
        {
            value: '3W7E',
            labelcz: 'Besloten Vennootschap'
        },
        {
            value: 'N5NT',
            labelcz: 'Besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'JNAD',
            labelcz: 'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: 'L05H',
            labelcz: 'Besloten Vennootschap van publiek recht'
        },
        {
            value: '3LMA',
            labelcz: 'Buitenlandse onderneming'
        },
        {
            value: 'V8L7',
            labelcz: 'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'KLBO',
            labelcz: 'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen'
        },
        {
            value: 'O5HQ',
            labelcz: 'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'WTLP',
            labelcz:
                'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid'
        },
        {
            value: 'T922',
            labelcz: 'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap'
        },
        {
            value: 'UCT9',
            labelcz: 'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)'
        },
        {
            value: 'XQZX',
            labelcz: 'Burgerlijke vennootschap onder vorm van naamloze vennootschap'
        },
        {
            value: 'U5KF',
            labelcz: 'Burgerlijke vennootschap onder vorm van vennootschap onder firma'
        },
        {
            value: 'MQH3',
            labelcz: 'Commanditaire vennootschap'
        },
        {
            value: 'U2PN',
            labelcz: 'Commanditaire vennootschap op aandelen'
        },
        {
            value: '1TX8',
            labelcz: 'Commanditaire vennootschap op aandelen met een sociaal oogmerk'
        },
        {
            value: '28FE',
            labelcz: 'Coöperatieve vennootschap'
        },
        {
            value: '8E2A',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: '2QSA',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: 'X8ZK',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht'
        },
        {
            value: 'LWHF',
            labelcz: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid'
        },
        {
            value: '4E5P',
            labelcz: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: 'EXY8',
            labelcz:
                'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht'
        },
        {
            value: 'JAM3',
            labelcz: 'Coöperatieve vennootschap van publiek recht'
        },
        {
            value: 'J5OU',
            labelcz: 'Economisch samenwerkingsverband'
        },
        {
            value: 'O59C',
            labelcz: 'Economisch samenwerkingsverband met een sociaal oogmerk'
        },
        {
            value: 'C609',
            labelcz: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'PVT3',
            labelcz: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: '7SJP',
            labelcz: 'Europees economisch samenwerkingsverband'
        },
        {
            value: 'YBHM',
            labelcz: 'Europese Coöperatieve Vennootschap'
        },
        {
            value: '36KV',
            labelcz: 'Europese vennootschap (Societas Europaea)'
        },
        {
            value: 'PKAN',
            labelcz: 'Fonds für Existenzsicherheit'
        },
        {
            value: 'LWV6',
            labelcz: 'Gewone commanditaire vennootschap'
        },
        {
            value: 'XLEO',
            labelcz: 'Gewone commanditaire vennootschap met een sociaal oogmerk'
        },
        {
            value: '8YLB',
            labelcz: 'Instelling zonder winstoogmerk'
        },
        {
            value: 'V03J',
            labelcz: 'Internationale vereniging zonder winstoogmerk'
        },
        {
            value: 'ZOK2',
            labelcz: 'Landbouwvennootschap'
        },
        {
            value: 'KM6O',
            labelcz: 'Maatschap'
        },
        {
            value: 'R85P',
            labelcz: 'Naamloze vennootschap'
        },
        {
            value: 'V7FT',
            labelcz: 'Naamloze vennootschap met een sociaal oogmerk'
        },
        {
            value: 'ZSFX',
            labelcz: 'Naamloze vennootschap met een sociaal oogmerk'
        },
        {
            value: 'TPTU',
            labelcz: 'Naamloze vennootschap van publiek recht'
        },
        {
            value: '3N94',
            labelcz: 'Onderneming-natuurlijk persoon'
        },
        {
            value: 'QZIS',
            labelcz: 'Openbare instelling'
        },
        {
            value: 'Y1Q4',
            labelcz: 'Private stichting'
        },
        {
            value: 'ZUHK',
            labelcz: 'Stichting van openbaar nut'
        },
        {
            value: 'CFH5',
            labelcz: 'Vennootschap of vereniging zonder rechtspersoonlijkheid'
        },
        {
            value: 'UW1Y',
            labelcz: 'Vennootschap onder firma'
        },
        {
            value: 'B910',
            labelcz: 'Vennootschap onder firma met een sociaal oogmerk'
        },
        {
            value: 'W3WH',
            labelcz: 'Vereniging zonder winstoogmerk'
        },
        {
            value: 'EDMK',
            labelcz: 'Vereniging zonder winstoogmerk van publiek recht'
        }
    ],
    BG: [
        {
            value: 'WTK4',
            labelcz: 'Aktsionerno druzhestvo'
        },
        {
            value: 'PW3Y',
            labelcz: 'Aktsionerno druzhestvo sas spetsialna investitsionna tsel'
        },
        {
            value: 'VJ3G',
            labelcz: 'Druzhestvo s ogranichena otgovornost'
        },
        {
            value: 'TCGV',
            labelcz: 'Druzhestvo uchredeno po Zakona za zadalzheniyata i dogovorite'
        },
        {
            value: '946C',
            labelcz: 'Ednolichen targovets'
        },
        {
            value: 'EJ06',
            labelcz: 'Ednolichno aktsionerno druzhestvo'
        },
        {
            value: 'QZAU',
            labelcz: 'Ednolichno aktsionerno druzhestvo sas spetsialna investitsionna tsel'
        },
        {
            value: 'WVIN',
            labelcz: 'Ednolichno druzhestvo s ogranichena otgovornost'
        },
        {
            value: 'SZW0',
            labelcz: 'Evropeysko druzhestvo'
        },
        {
            value: 'U8LM',
            labelcz: 'Evropeysko kooperativno druzhestvo'
        },
        {
            value: '3FUP',
            labelcz: 'Evropeysko kooperativno druzhestvo s ogranichena otgovornost'
        },
        {
            value: 'RYDY',
            labelcz: 'Evropeysko obedinenie po ikonomicheski interesi'
        },
        {
            value: 'UFG8',
            labelcz: 'Fondatsia'
        },
        {
            value: '9F78',
            labelcz: 'Chuzhdestranno druzhestvo - fizichesko litse'
        },
        {
            value: 'O15N',
            labelcz: 'Chuzhdestranno druzhestvo - yuridichesko litse'
        },
        {
            value: '45D7',
            labelcz: 'Klon na chuzhdestranen targovets'
        },
        {
            value: 'S94S',
            labelcz: 'Komanditno druzhestvo'
        },
        {
            value: 'HN63',
            labelcz: 'Komanditno druzhestvo s aktsii'
        },
        {
            value: 'CTCH',
            labelcz: 'Kooperatsia'
        },
        {
            value: '3HLJ',
            labelcz: 'Podelenie na evropeysko obedinenie po ikonomicheski interesi'
        },
        {
            value: 'FPP2',
            labelcz: 'Sabiratelno druzhestvo (SD)/Sadruzhie'
        },
        {
            value: 'LECS',
            labelcz: 'Sdruzhenie v chastna polza'
        },
        {
            value: '3SHX',
            labelcz: 'Sdruzhenie v obshtestvena polza'
        }
    ],
    BJ: [
        {
            value: 'B2N4',
            labelcz: 'Entreprise Individuelle'
        },
        {
            value: '5F9K',
            labelcz: "Groupement d'intérêt Économique"
        },
        {
            value: 'KUHK',
            labelcz: 'Société à Responsabilité Limitée'
        },
        {
            value: 'CSUT',
            labelcz: 'Société Anonyme'
        },
        {
            value: '6X4Q',
            labelcz: 'Société en Commandite Simple'
        },
        {
            value: 'XXQQ',
            labelcz: 'Société en Nom Collectif'
        },
        {
            value: 'T3IW',
            labelcz: 'Société par Actions Simplifiées'
        },
        {
            value: 'EZHS',
            labelcz: 'Société Unipersonnelle à Responsabilité Limitée'
        }
    ],
    BM: [
        {
            value: '7AS7',
            labelcz: 'Exempted Companies Limited by Shares'
        },
        {
            value: 'LC2L',
            labelcz: 'Exempted Company Limited by Guarantee'
        },
        {
            value: '7MGJ',
            labelcz: 'Exempted Limited Partnership'
        },
        {
            value: '7HCE',
            labelcz: 'Exempted LLC'
        },
        {
            value: 'ASR5',
            labelcz: 'Exempted Partnership'
        },
        {
            value: 'MBVS',
            labelcz: 'Exempted Unlimited Company'
        },
        {
            value: 'CW38',
            labelcz: 'Local Company Limited by Guarantee'
        },
        {
            value: 'NAQG',
            labelcz: 'Local Company Limited by Shares'
        },
        {
            value: 'UZWE',
            labelcz: 'Local LLC'
        },
        {
            value: 'EURM',
            labelcz: 'Local Unlimited Company'
        },
        {
            value: '9TCY',
            labelcz: 'Mutual Company (Part XII)'
        },
        {
            value: 'VFXJ',
            labelcz: 'Mutual Fund Company'
        },
        {
            value: 'ZLTD',
            labelcz: 'Overseas (Permit) Partnership'
        },
        {
            value: 'WF3Q',
            labelcz: 'Permit (Overseas) Company'
        }
    ],
    BN: [
        {
            value: 'J98R',
            labelcz: 'Partnership'
        },
        {
            value: 'EULU',
            labelcz: 'Private Limited Company'
        },
        {
            value: '2DGO',
            labelcz: 'Public Company'
        },
        {
            value: 'VHOW',
            labelcz: 'Sole-Proprietorship'
        }
    ],
    BO: [
        {
            value: '70BS',
            labelcz: 'Empresa Estatal '
        },
        {
            value: 'JYAN',
            labelcz: 'Empresa Estatal Intergubernamental     '
        },
        {
            value: 'RXJN',
            labelcz: 'Empresa Estatal Mixta                  '
        },
        {
            value: 'MGOU',
            labelcz: 'Empresa Mixta                         '
        },
        {
            value: '38JQ',
            labelcz: 'Empresa Unipersonal'
        },
        {
            value: 'LN9O',
            labelcz: 'Entidad Financiera De Vivienda'
        },
        {
            value: 'DSML',
            labelcz: 'Institución Financiera De Desarrollo   '
        },
        {
            value: '5T3W',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'LJYQ',
            labelcz: 'Sociedad Anónima Mixta                 '
        },
        {
            value: 'TNHO',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: 'PM48',
            labelcz: 'Sociedad de Responsabilidad Limitada.'
        },
        {
            value: 'PJ29',
            labelcz: 'Sociedad en Comandita por Acciones. '
        },
        {
            value: 'XTCQ',
            labelcz: 'Sociedad en Comandita Simple.'
        }
    ],
    BQ: [
        {
            value: '56MU',
            labelcz: 'Aandeelhouder bestuurde Besloten vennootschap'
        },
        {
            value: '1A0A',
            labelcz: 'Besloten vennootschap'
        },
        {
            value: '3Y5C',
            labelcz: 'Besloten vennootschap naar Nederlands recht'
        },
        {
            value: 'JFQ5',
            labelcz: 'Buitenlandse rechtsvorm hoofdvestiging op Bonaire'
        },
        {
            value: 'XL51',
            labelcz: 'Commanditaire vennootschap met één beherend vennoot'
        },
        {
            value: '4S4Z',
            labelcz: 'Commanditaire vennootschap met meerdere beherende vennoten'
        },
        {
            value: 'KSHL',
            labelcz: 'Commanditaire vennootschap op aandelen'
        },
        {
            value: 'VHIY',
            labelcz: 'Cooperatie'
        },
        {
            value: 'NPFB',
            labelcz: 'Eenmanszaak'
        },
        {
            value: 'IPTQ',
            labelcz: 'Eenmanszaak met meerdere eigenaren'
        },
        {
            value: '4ZBE',
            labelcz: 'Maatschap'
        },
        {
            value: 'DQMJ',
            labelcz: 'Naamloze vennootschap'
        },
        {
            value: 'B2UK',
            labelcz: 'Nevenvestiging met hoofdvestiging buiten bonaire'
        },
        {
            value: '92JZ',
            labelcz: 'Stichting'
        },
        {
            value: 'AS4W',
            labelcz: 'Stichting particulier fonds'
        },
        {
            value: 'SNRI',
            labelcz: 'Vennootschap onder Firma'
        },
        {
            value: '51WZ',
            labelcz: 'Vereniging met beperkte rechtsbevoegdheid'
        },
        {
            value: 'FCPM',
            labelcz: 'Vereniging met volledige rechtsbevoegdheid'
        },
        {
            value: 'X088',
            labelcz: 'Vereniging zonder rechtsbevoegdheid'
        }
    ],
    BR: [
        {
            value: 'J7G9',
            labelcz: 'Associação'
        },
        {
            value: '4LKN',
            labelcz: 'Empresa Pública'
        },
        {
            value: 'I4T1',
            labelcz: 'Fundação'
        },
        {
            value: '9BIS',
            labelcz: 'Organização Religiosa'
        },
        {
            value: 'ANHM',
            labelcz: 'Partido Político'
        },
        {
            value: 'X0SD',
            labelcz: 'Sociedade Anônima'
        },
        {
            value: 'PC5A',
            labelcz: 'Sociedade Cooperativa'
        },
        {
            value: 'X2ZT',
            labelcz: 'Sociedade em Comandita por Ações'
        },
        {
            value: 'WBEC',
            labelcz: 'Sociedade em Comdandita Simples'
        },
        {
            value: 'XQRI',
            labelcz: 'Sociedade em Conta de Participação'
        },
        {
            value: '529B',
            labelcz: 'Sociedade em Nome Coletivo'
        },
        {
            value: 'QHW1',
            labelcz: 'Sociedade Limitada'
        },
        {
            value: 'AL8W',
            labelcz: 'Sociedade Limitada Unipessoal'
        },
        {
            value: '8GEA',
            labelcz: 'Sociedade Simples'
        }
    ],
    BS: [
        {
            value: 'TFNS',
            labelcz: 'Bahamas Executive Entity'
        },
        {
            value: 'HP0B',
            labelcz: 'Company Limited both by Shares and by Guarantee'
        },
        {
            value: 'PB7W',
            labelcz: 'Company Limited by Guarantee'
        },
        {
            value: '98A8',
            labelcz: 'Company Limited by Shares'
        },
        {
            value: 'SQ8U',
            labelcz: 'Exempted Limited Partnership'
        },
        {
            value: 'VVOW',
            labelcz: 'Foundation'
        },
        {
            value: 'A9N4',
            labelcz: 'International Business Company'
        },
        {
            value: '1W6I',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'PICJ',
            labelcz: 'Non-Profit Company'
        },
        {
            value: '78QF',
            labelcz: 'Partnership'
        },
        {
            value: 'HNSU',
            labelcz: 'Public Company Limited by Shares'
        },
        {
            value: 'XDKS',
            labelcz: 'Sole Proprietor'
        },
        {
            value: 'DAEG',
            labelcz: 'Unlimited Liability Company'
        }
    ],
    BW: [
        {
            value: '4IXL',
            labelcz: 'Close Companies '
        },
        {
            value: 'Y2L3',
            labelcz: 'Companies limited by Guarantee'
        },
        {
            value: '771I',
            labelcz: 'Private Limited Liability Companies'
        },
        {
            value: 'QK1F',
            labelcz: 'Public Limited Liability Companies'
        }
    ],
    BY: [
        {
            value: 'MR85',
            labelcz: 'Adkrytae akcyyanernae tavarystva'
        },
        {
            value: 'AABD',
            labelcz: 'Tavarystva z abmezhavanaj adkaznascyu'
        },
        {
            value: 'JLR3',
            labelcz: 'Tavarystva z dadatkovaj adkaznascyu'
        },
        {
            value: '9X63',
            labelcz: 'Unіtarnae pradpryemstva'
        },
        {
            value: '106J',
            labelcz: 'Zakrytae akcyyanernae tavarystva'
        },
        {
            value: 'SMCI',
            labelcz: 'Учреждение'
        }
    ],
    BZ: [
        {
            value: 'GJKF',
            labelcz: 'Association'
        },
        {
            value: 'ZHT0',
            labelcz: 'Company Limited by Guarantee'
        },
        {
            value: 'EAD0',
            labelcz: 'Company Limited by Shares'
        },
        {
            value: '84DD',
            labelcz: 'International Business Company'
        },
        {
            value: 'D1SL',
            labelcz: 'Partnership'
        },
        {
            value: 'AO0O',
            labelcz: 'Unlimited Company'
        }
    ],
    CA: [
        {
            value: '3M14',
            labelcz:
                'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)'
        },
        {
            value: 'TY0S',
            labelcz:
                'A company formed under the Companies Act may seek designation as a Private Investment Holding Company'
        },
        {
            value: '56KZ',
            labelcz: 'agricultural fair association'
        },
        {
            value: 'TRO6',
            labelcz: 'agricultural society'
        },
        {
            value: 'GLX2',
            labelcz: 'agricultural society'
        },
        {
            value: '8ZH8',
            labelcz: 'Alberta Business Corporation'
        },
        {
            value: 'BASA',
            labelcz: 'Alberta cooperative'
        },
        {
            value: 'G65S',
            labelcz: 'Alberta credit union'
        },
        {
            value: 'U938',
            labelcz: 'Alberta limited liability partnership'
        },
        {
            value: 'RN4K',
            labelcz: 'Alberta limited partnership'
        },
        {
            value: 'DK7L',
            labelcz: 'Alberta loan corporation'
        },
        {
            value: 'B69V',
            labelcz: 'Alberta private non-profit company'
        },
        {
            value: 'C9KZ',
            labelcz: 'Alberta professional corporation'
        },
        {
            value: 'K1QX',
            labelcz: 'Alberta society'
        },
        {
            value: '60MF',
            labelcz: 'Alberta trust corporation'
        },
        {
            value: 'J3C5',
            labelcz: 'Alberta unlimited liability corporation'
        },
        {
            value: 'ZY4E',
            labelcz: 'appellation commerciale - propriétaire unique'
        },
        {
            value: 'TWLR',
            labelcz: 'Association'
        },
        {
            value: 'AW80',
            labelcz: 'Association (includes housing cooperative and community service cooperative)'
        },
        {
            value: 'FGSL',
            labelcz: 'association condominiale'
        },
        {
            value: '64XG',
            labelcz: 'association coopérative'
        },
        {
            value: 'TSQ7',
            labelcz: 'association de foires agricoles'
        },
        {
            value: '59T2',
            labelcz: 'board of trade'
        },
        {
            value: 'UDLA',
            labelcz: 'business corporation'
        },
        {
            value: 'UWMY',
            labelcz: 'Business Corporations'
        },
        {
            value: 'O90R',
            labelcz: 'Business corporations (which includes professional corporations)'
        },
        {
            value: 'GF6X',
            labelcz: 'business name - sole proprietor'
        },
        {
            value: 'QR4F',
            labelcz: 'business name/sole proprietorship'
        },
        {
            value: '456Q',
            labelcz: 'business name/sole proprietorship'
        },
        {
            value: '9XHE',
            labelcz: 'business names'
        },
        {
            value: 'ILON',
            labelcz: 'caisse populaire'
        },
        {
            value: 'KAM9',
            labelcz: 'co-operative'
        },
        {
            value: 'IKMB',
            labelcz: 'co-operative association'
        },
        {
            value: 'FBQL',
            labelcz: 'Co-operative Corporation'
        },
        {
            value: '3Y5V',
            labelcz: 'co-operatives'
        },
        {
            value: 'JNCJ',
            labelcz: 'Co-operatives'
        },
        {
            value: 'GPG0',
            labelcz: 'compagnie'
        },
        {
            value: 'IDBS',
            labelcz: 'compagnie de fiducie'
        },
        {
            value: '4M62',
            labelcz: 'compagnie de prêt'
        },
        {
            value: 'JBBW',
            labelcz: 'company'
        },
        {
            value: 'YG5M',
            labelcz: 'Company (includes community contribution company and unlimited liability company)'
        },
        {
            value: 'GG0S',
            labelcz: 'company limited by guarantee'
        },
        {
            value: 'ULJ1',
            labelcz: 'company limited by shares (limited company)'
        },
        {
            value: 'LV28',
            labelcz: 'Condominium Corporation'
        },
        {
            value: '6U2Q',
            labelcz: 'condominium corporation'
        },
        {
            value: 'GTBR',
            labelcz: 'Condominium Corporation'
        },
        {
            value: '7VKC',
            labelcz: 'Condominium Corporation'
        },
        {
            value: '8KL5',
            labelcz: 'Condominium Corporations'
        },
        {
            value: '8M03',
            labelcz: 'Condominiums'
        },
        {
            value: 'MGE0',
            labelcz: 'cooperative'
        },
        {
            value: 'GM04',
            labelcz: 'Cooperative'
        },
        {
            value: 'QB2W',
            labelcz: 'Coopérative'
        },
        {
            value: 'B3RX',
            labelcz: 'corporation'
        },
        {
            value: 'NONB',
            labelcz: 'corporation'
        },
        {
            value: '44LR',
            labelcz: 'corporation professionnelle'
        },
        {
            value: 'D90J',
            labelcz: 'corporation without share capital'
        },
        {
            value: '6TRA',
            labelcz: 'corporations enacted by an Act of Parliament'
        },
        {
            value: 'BOYK',
            labelcz: 'Corporations formed by an Act of the Ontario Legislative Assembly'
        },
        {
            value: '5EEA',
            labelcz: 'Corporations formed by an Act of the Saskatchewan legislature'
        },
        {
            value: 'XOYI',
            labelcz: 'Credit union'
        },
        {
            value: 'MY4W',
            labelcz: 'credit union'
        },
        {
            value: 'EBYQ',
            labelcz: 'Credit Union'
        },
        {
            value: 'ESVK',
            labelcz: 'Credit Union'
        },
        {
            value: 'Y485',
            labelcz: 'Credit union or Caisse Populaire'
        },
        {
            value: '876U',
            labelcz: 'Credit Unions'
        },
        {
            value: 'FYYY',
            labelcz: 'Credit Unions'
        },
        {
            value: 'M53U',
            labelcz: 'depends on Act of the Legislature'
        },
        {
            value: '1ADH',
            labelcz: 'Extra-Territorial Corporation(for profit and not-for-profit)'
        },
        {
            value: 'TGLV',
            labelcz: 'Extraprovincial corporation (registered foreign entity)'
        },
        {
            value: 'QODJ',
            labelcz: 'Extraprovincial limited liability partnership'
        },
        {
            value: 'OTU7',
            labelcz: 'Extraprovincial non-share corporation'
        },
        {
            value: 'FQJ9',
            labelcz: 'for profit and not-for profit co-operatives'
        },
        {
            value: 'KVC1',
            labelcz: 'general partnership'
        },
        {
            value: 'O13B',
            labelcz: 'General partnership'
        },
        {
            value: 'VAPN',
            labelcz: 'general partnership'
        },
        {
            value: 'HQKE',
            labelcz: 'general partnership'
        },
        {
            value: 'QJ3A',
            labelcz: 'gérant de projet'
        },
        {
            value: 'EIDL',
            labelcz: 'Insurance Corporations incorporated under Part V of the Corporations Act'
        },
        {
            value: 'L2NN',
            labelcz: 'Joint Ventures'
        },
        {
            value: 'LNBY',
            labelcz: 'Limited liability partnership'
        },
        {
            value: 'SYPT',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '85EC',
            labelcz: 'Limited Liability partnership'
        },
        {
            value: 'PCO0',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'G9PJ',
            labelcz: 'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)'
        },
        {
            value: '8OZ0',
            labelcz: 'limited liability partnerships'
        },
        {
            value: '5D9I',
            labelcz: 'Limited Liabilty Partnerships'
        },
        {
            value: '23V9',
            labelcz: 'Limited partnership'
        },
        {
            value: 'OPRT',
            labelcz: 'Limited Partnership'
        },
        {
            value: '7P8Y',
            labelcz: 'limited partnership'
        },
        {
            value: '1E9M',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'TA98',
            labelcz: 'Limited partnership'
        },
        {
            value: '1JGX',
            labelcz: 'Limited Partnership'
        },
        {
            value: '7IKZ',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'F9J3',
            labelcz: 'Limited partnership formed outside of BC'
        },
        {
            value: 'T0CV',
            labelcz: 'limited partnerships formed in NS'
        },
        {
            value: 'EKRT',
            labelcz: 'loan company'
        },
        {
            value: 'LRRN',
            labelcz: 'Mutual fire insurance company'
        },
        {
            value: 'EPFN',
            labelcz: 'New Brunswick limited liability partnership'
        },
        {
            value: '7XZL',
            labelcz: 'New Generation Co-operatives'
        },
        {
            value: 'Y80K',
            labelcz: 'Non-profit Corporations'
        },
        {
            value: '3OVJ',
            labelcz: 'Non-profit Corporations'
        },
        {
            value: '9D1K',
            labelcz: 'non-share corporations'
        },
        {
            value: 'IKGM',
            labelcz: 'non-share corporations'
        },
        {
            value: 'CMB6',
            labelcz: 'Not-For-Profit corporations'
        },
        {
            value: 'PIDT',
            labelcz: 'NT corporation'
        },
        {
            value: 'QN8Y',
            labelcz: 'NT Professional Corporation authorized under the Professional Corporations Act'
        },
        {
            value: 'CS15',
            labelcz: 'NT society'
        },
        {
            value: 'RBBY',
            labelcz: 'Partnership'
        },
        {
            value: '3Q15',
            labelcz: 'partnership'
        },
        {
            value: 'LMSY',
            labelcz: 'Partnership'
        },
        {
            value: '2FHC',
            labelcz: 'partnerships'
        },
        {
            value: 'HLBQ',
            labelcz: 'Pension fund society'
        },
        {
            value: 'M4IF',
            labelcz: 'pension fund society'
        },
        {
            value: 'QNSC',
            labelcz: 'personne morale étrangère résidante'
        },
        {
            value: 'VRVJ',
            labelcz: 'Personne morale sans but lucratif par Code des professions'
        },
        {
            value: 'XS49',
            labelcz:
                'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires'
        },
        {
            value: 'V5IH',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme'
        },
        {
            value: 'F9CT',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’instruction publique'
        },
        {
            value: 'WGEA',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires'
        },
        {
            value: 'NVXN',
            labelcz: "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale"
        },
        {
            value: 'JLE0',
            labelcz: 'Personne morale sans but lucratif par Loi sur la conservation de la faune'
        },
        {
            value: 'J5SC',
            labelcz: 'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune'
        },
        {
            value: 'HVWR',
            labelcz: 'Personne morale sans but lucratif par Loi sur la constitution de certaines Églises'
        },
        {
            value: 'XW5K',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec'
        },
        {
            value: 'S72N',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec'
        },
        {
            value: '6ZCO',
            labelcz:
                'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre'
        },
        {
            value: '16RL',
            labelcz: 'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles'
        },
        {
            value: 'JI4V',
            labelcz:
                'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche'
        },
        {
            value: '3C5P',
            labelcz: 'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention'
        },
        {
            value: 'MQT7',
            labelcz: 'Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail'
        },
        {
            value: 'CG81',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec'
        },
        {
            value: 'V9GU',
            labelcz: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières'
        },
        {
            value: 'ZQQU',
            labelcz: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec'
        },
        {
            value: '9IF2',
            labelcz: 'Personne morale sans but lucratif par Loi sur les associations coopératives'
        },
        {
            value: 'YBMJ',
            labelcz: 'Personne morale sans but lucratif par Loi sur les assurances'
        },
        {
            value: '16GH',
            labelcz: 'Personne morale sans but lucratif par Loi sur les cercles agricoles'
        },
        {
            value: '27WJ',
            labelcz: 'Personne morale sans but lucratif par Loi sur les cités et villes'
        },
        {
            value: 'JBU2',
            labelcz: 'Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche'
        },
        {
            value: 'OMUP',
            labelcz: 'Personne morale sans but lucratif par Loi sur les clubs de récréation'
        },
        {
            value: '87OW',
            labelcz:
                "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel"
        },
        {
            value: 'D2T8',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)'
        },
        {
            value: 'CT3J',
            labelcz:
                "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les soci ..."
        },
        {
            value: 'K08P',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetière'
        },
        {
            value: 'ZX1F',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains'
        },
        {
            value: '3FP6',
            labelcz: 'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité'
        },
        {
            value: 'YIIS',
            labelcz: 'Personne morale sans but lucratif par Loi sur les corporations religieuses'
        },
        {
            value: 'MR95',
            labelcz: 'Personne morale sans but lucratif par Loi sur les décrets de convention collective'
        },
        {
            value: '1VTA',
            labelcz: 'Personne morale sans but lucratif par Loi sur les évêques catholiques romains'
        },
        {
            value: 'VGP6',
            labelcz: 'Personne morale sans but lucratif par Loi sur les fabriques'
        },
        {
            value: '702U',
            labelcz: 'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec'
        },
        {
            value: 'ZGEX',
            labelcz: 'Personne morale sans but lucratif par Loi sur les services correctionnels'
        },
        {
            value: 'I3UX',
            labelcz: 'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux'
        },
        {
            value: '95EN',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris'
        },
        {
            value: '2ODA',
            labelcz: 'Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières'
        },
        {
            value: 'MCY8',
            labelcz: "Personne morale sans but lucratif par Loi sur les sociétés d'agriculture"
        },
        {
            value: 'L3XH',
            labelcz: "Personne morale sans but lucratif par Loi sur les sociétés d'horticulture"
        },
        {
            value: 'GAMO',
            labelcz: 'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance'
        },
        {
            value: 'JQNA',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux'
        },
        {
            value: 'Q8NY',
            labelcz: 'Personne morale sans but lucratif par Loi sur les syndicats professionnels'
        },
        {
            value: 'LN3N',
            labelcz: 'Personne morale sans but lucratif par Loi sur les villages miniers'
        },
        {
            value: 'RC3D',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik'
        },
        {
            value: '52CK',
            labelcz: 'Personne morale sans but lucratif par Loi sur les villes minières'
        },
        {
            value: 'R0KX',
            labelcz: 'private act corporation'
        },
        {
            value: 'TPZ2',
            labelcz: 'private act corporation'
        },
        {
            value: 'RHVP',
            labelcz: 'private act non-profit corp'
        },
        {
            value: 'W126',
            labelcz: 'private act not-for-profit corporation'
        },
        {
            value: 'PXPK',
            labelcz: 'private recreation company'
        },
        {
            value: 'D8UQ',
            labelcz: 'professional corporation'
        },
        {
            value: 'DHGI',
            labelcz: 'project company'
        },
        {
            value: 'VHXN',
            labelcz: 'public non-profit company'
        },
        {
            value: '94UQ',
            labelcz: 'public recreation company'
        },
        {
            value: 'S3K4',
            labelcz: 'Registered extraprovincial non-share corporation'
        },
        {
            value: 'SS1V',
            labelcz: 'registration of extra-provincial corporations'
        },
        {
            value: 'ER0H',
            labelcz: 'registration of extra-provincial corporations'
        },
        {
            value: 'TS9O',
            labelcz: 'religious society'
        },
        {
            value: '5ONY',
            labelcz: 'Religious Society'
        },
        {
            value: 'BH5D',
            labelcz: 'rural utility cooperative'
        },
        {
            value: 'AXW3',
            labelcz: 'selon la loi de la Législature'
        },
        {
            value: 'Z6MF',
            labelcz: 'Selon la loi par Loi spéciale du Québec à caractère privé'
        },
        {
            value: 'A7KA',
            labelcz: 'Selon la loi par Loi spéciale du Québec à caractère public'
        },
        {
            value: 'ASWX',
            labelcz: 'share corporations'
        },
        {
            value: 'FN6X',
            labelcz: 'Share corporations (including professional corporations)'
        },
        {
            value: '8MEC',
            labelcz: 'société à responsabilité limitée du Nouveau-Brunswick'
        },
        {
            value: 'WI0P',
            labelcz: 'société agricole'
        },
        {
            value: '40JO',
            labelcz: 'société en commandite'
        },
        {
            value: 'RQIC',
            labelcz: 'Société en commandite'
        },
        {
            value: 'IKSU',
            labelcz: 'société en nom collectif'
        },
        {
            value: 'YRUJ',
            labelcz: 'Société en nom collectif'
        },
        {
            value: '2U3G',
            labelcz: 'Société en nom collectif à responsabilité limitée'
        },
        {
            value: '814Y',
            labelcz: 'Société en participation'
        },
        {
            value: '50Z9',
            labelcz: 'Société par actions constitué par Loi sur les assurances'
        },
        {
            value: 'JLZW',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de fidéicommis'
        },
        {
            value: 'TA7J',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de flottage'
        },
        {
            value: 'AS7L',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité'
        },
        {
            value: 'RPGT',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone'
        },
        {
            value: '30IT',
            labelcz: 'Société par actions constitué par Loi sur les compagnies minières'
        },
        {
            value: 'MK1I',
            labelcz: "Société par actions constitué par Loi sur les sociétés d'entraide économique"
        },
        {
            value: '9CEN',
            labelcz: "Société par actions constitué par Loi sur les sociétés d'exploration minière"
        },
        {
            value: 'UVCG',
            labelcz: 'Société par actions constitué par Loi sur les sociétés de construction'
        },
        {
            value: 'TKAB',
            labelcz:
                "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise"
        },
        {
            value: 'JXO5',
            labelcz: "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne"
        },
        {
            value: '4B4B',
            labelcz:
                'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers'
        },
        {
            value: '9CB2',
            labelcz: "Société par actions constitué par Loi sur les syndicats d'élevage"
        },
        {
            value: 'L26C',
            labelcz: 'Société par actions par Fonds mutuel constitué par acte de fiducie'
        },
        {
            value: 'JVMD',
            labelcz:
                "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage"
        },
        {
            value: 'UG3Z',
            labelcz: 'Société par actions par Loi sur les sociétés par actions'
        },
        {
            value: 'WFPH',
            labelcz: 'Society (includes member-funded society)'
        },
        {
            value: 'W8XG',
            labelcz: 'sole proprietors'
        },
        {
            value: 'I8VP',
            labelcz: 'Sole Proprietors'
        },
        {
            value: '1CML',
            labelcz: 'Sole proprietorship'
        },
        {
            value: 'MXLT',
            labelcz: 'Sole Proprietorship'
        },
        {
            value: '10UR',
            labelcz: 'Syndicat coopératif'
        },
        {
            value: 'T1LR',
            labelcz: 'Syndicat de copropriété'
        },
        {
            value: 'KZDW',
            labelcz: 'Syndicates'
        },
        {
            value: '1EQC',
            labelcz: 'trade name/sole proprietorship'
        },
        {
            value: 'ZACY',
            labelcz: 'trust company'
        },
        {
            value: 'HBCT',
            labelcz: 'Ukrainian Catholic Parish'
        },
        {
            value: '42GN',
            labelcz: 'unlimited company'
        }
    ],
    CH: [
        {
            value: 'H781',
            labelcz: 'Association'
        },
        {
            value: 'FFTN',
            labelcz: 'Cantonal administration'
        },
        {
            value: 'HX77',
            labelcz: 'Cantonal public company'
        },
        {
            value: 'MVII',
            labelcz: 'Company limited by shares'
        },
        {
            value: 'M848',
            labelcz: 'Corpororate public company'
        },
        {
            value: 'YRGM',
            labelcz: 'District administration'
        },
        {
            value: 'VPRH',
            labelcz: 'District public company'
        },
        {
            value: '2XJA',
            labelcz: 'Federal administration'
        },
        {
            value: 'BF9N',
            labelcz: 'Federal public company'
        },
        {
            value: 'FLNB',
            labelcz: 'Fonds'
        },
        {
            value: 'R9TC',
            labelcz: 'Foreign enterprise'
        },
        {
            value: '2WFG',
            labelcz: 'Foreign public company'
        },
        {
            value: '2JZ4',
            labelcz: 'Foundation'
        },
        {
            value: 'DP2E',
            labelcz: 'International organisation'
        },
        {
            value: '54WI',
            labelcz: 'Investment company with fixed capital'
        },
        {
            value: 'XJOT',
            labelcz: 'Investment company with variable capital'
        },
        {
            value: 'TL87',
            labelcz: 'Limited partnership for collective investments'
        },
        {
            value: 'GP8M',
            labelcz: 'Local administration'
        },
        {
            value: 'L5DU',
            labelcz: 'Local public company'
        },
        {
            value: 'KJ9Q',
            labelcz: 'Non-commercial power of attorney'
        },
        {
            value: 'E0NE',
            labelcz: 'Public corporation'
        },
        {
            value: '7MNN',
            labelcz: 'Public sector institution'
        },
        {
            value: 'OBFU',
            labelcz: 'Representative of an ownership in undivided shares'
        },
        {
            value: '2B81',
            labelcz: 'Simple partnership'
        },
        {
            value: '3EKS',
            labelcz: 'Società a garanzia limitata'
        },
        {
            value: 'QSI2',
            labelcz: 'Società cooperativa'
        },
        {
            value: 'CQMY',
            labelcz: 'Società in accomandita'
        },
        {
            value: 'W6A7',
            labelcz: 'Società in accomandita per azioni'
        },
        {
            value: 'MRSY',
            labelcz: 'Società in nome collettivo'
        },
        {
            value: 'AZA0',
            labelcz: 'Sole proprietorship'
        },
        {
            value: '5BEZ',
            labelcz: 'Special legal form'
        },
        {
            value: 'JB25',
            labelcz: 'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer'
        },
        {
            value: 'UNA9',
            labelcz: 'Swiss branch registered at the registry of commerce'
        },
        {
            value: 'FJG4',
            labelcz: 'Trust'
        }
    ],
    CK: [
        {
            value: 'Z3Y2',
            labelcz: 'Foreign Company'
        },
        {
            value: 'N00R',
            labelcz: 'Foundation'
        },
        {
            value: '70NZ',
            labelcz: 'International Company'
        },
        {
            value: 'KNIC',
            labelcz: 'International Partnership'
        },
        {
            value: 'YCQM',
            labelcz: 'International Trust'
        },
        {
            value: 'A7G6',
            labelcz: 'Limited Liability Company'
        }
    ],
    CN: [
        {
            value: 'BDTI',
            labelcz: 'bian ban zhi jie guan li ji gou bian zhi de qun zhong tuan ti'
        },
        {
            value: '5GXA',
            labelcz: 'cun ji ji ti jing ji zu zhi'
        },
        {
            value: 'E4YV',
            labelcz: 'gang ao tai di qu lv you bu men chang zhu nei di ( da lu ) dai biao ji gou'
        },
        {
            value: 'RV48',
            labelcz: 'ge ti gong shang hu'
        },
        {
            value: 'E88S',
            labelcz: 'gong zheng chu'
        },
        {
            value: 'IBEM',
            labelcz: 'ji ceng fa lv fu wu suo'
        },
        {
            value: 'OH9O',
            labelcz: 'ji ceng gong hui'
        },
        {
            value: 'I39S',
            labelcz: 'ji guan'
        },
        {
            value: '2M6Y',
            labelcz: 'ji jin hui'
        },
        {
            value: '5A9K',
            labelcz: 'jun dui shi ye dan wei'
        },
        {
            value: '6NSC',
            labelcz: 'lv shi zhi ye ji gou'
        },
        {
            value: 'E4FG',
            labelcz: 'min ban fei qi ye dan wei'
        },
        {
            value: 'UMCR',
            labelcz: 'nong min zhuan ye he zuo she'
        },
        {
            value: 'R3O0',
            labelcz: 'qi ta（ gong hui ）'
        },
        {
            value: 'SH05',
            labelcz: 'qi ta（ ji gou bian zhi ）'
        },
        {
            value: 'OMUD',
            labelcz: 'qi ta（ lv you ）'
        },
        {
            value: 'WEUX',
            labelcz: 'qi ta（ min zheng ）'
        },
        {
            value: 'ESZ8',
            labelcz: 'qi ta（ nong ye ）'
        },
        {
            value: 'LURL',
            labelcz: 'qi ta（ shi yong yu wu deng ji ji gou de de qing kuang ）'
        },
        {
            value: 'NWJX',
            labelcz: 'qi ta（ si fa xing zheng ）'
        },
        {
            value: 'C38B',
            labelcz: 'qi ta（ wai jiao ）'
        },
        {
            value: 'GPHT',
            labelcz: 'qi ta（ wen hua ）'
        },
        {
            value: 'CYV6',
            labelcz: 'qi ta（ zhong yang jun wei gai ge he bian zhi ban gong shi ）'
        },
        {
            value: 'T0KK',
            labelcz: 'qi ta（ zong jiao ）'
        },
        {
            value: 'ECAK',
            labelcz: 'qi ye'
        },
        {
            value: 'GGZ5',
            labelcz: 'she hui tuan ti'
        },
        {
            value: 'B5UZ',
            labelcz: 'shi ye dan wei'
        },
        {
            value: 'S9UH',
            labelcz: 'si fa jian ding ji gou'
        },
        {
            value: '1IWK',
            labelcz: 'wai guo chang zhu xin wen ji gou'
        },
        {
            value: 'TBG2',
            labelcz: 'wai guo lv you bu men chang zhu dai biao ji gou'
        },
        {
            value: '8XAW',
            labelcz: 'wai guo zai hua wen hua zhong xin'
        },
        {
            value: 'DLEK',
            labelcz: 'xiang zhen ji ji ti jing ji zu zhi'
        },
        {
            value: 'V251',
            labelcz: 'zhong cai wei yuan hui'
        },
        {
            value: 'YXJ5',
            labelcz: 'zong jiao huo dong chang suo'
        },
        {
            value: '6KC0',
            labelcz: 'zong jiao yuan xiao'
        },
        {
            value: 'V816',
            labelcz: 'zu ji ji ti jing ji zu zhi'
        },
        {
            value: 'J7SF',
            labelcz: '有限合伙企业'
        }
    ],
    CO: [
        {
            value: 'D2T3',
            labelcz: 'Empresa Asociativa de Trabajo'
        },
        {
            value: '1PAD',
            labelcz: 'Empresa Unipersonal'
        },
        {
            value: '4OYE',
            labelcz: 'Persona natural comerciante'
        },
        {
            value: '3RHN',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'DEJ0',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: 'KC51',
            labelcz: 'Sociedad de Economía Mixta'
        },
        {
            value: 'WX45',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'N1TE',
            labelcz: 'Sociedad en comandita por acciones'
        },
        {
            value: 'IUIY',
            labelcz: 'Sociedad en comandita simple'
        },
        {
            value: 'KYVO',
            labelcz: 'Sociedad por Acciones Simplificada'
        },
        {
            value: 'SJB8',
            labelcz: 'Sociedades Agrarias de Transformación'
        },
        {
            value: '6Z8B',
            labelcz: 'Sucursal de Sociedad Extranjera'
        }
    ],
    CR: [
        {
            value: 'O4X3',
            labelcz: 'Asociación civil, Asociación deportiva, Federación'
        },
        {
            value: 'YYZO',
            labelcz: 'Asociación Cooperativa'
        },
        {
            value: 'M0X8',
            labelcz: 'Condominio'
        },
        {
            value: 'YW6W',
            labelcz: 'Empresa Individual de Responsabilidad Limitada'
        },
        {
            value: '4Y4D',
            labelcz: 'Entidad Creada por Ley Especial'
        },
        {
            value: 'YFZL',
            labelcz: 'Fideicomiso de Partidos Políticos'
        },
        {
            value: 'G5RR',
            labelcz: 'Fundación'
        },
        {
            value: '4SFS',
            labelcz: 'Institución Autónoma'
        },
        {
            value: 'DUXT',
            labelcz: 'Junta de Educación y Junta Administrativa de Patronatos Escolares'
        },
        {
            value: 'EFE3',
            labelcz: 'Municipalidad'
        },
        {
            value: 'Q4J1',
            labelcz: 'Mutual de Ahorro y Préstamo'
        },
        {
            value: '72BT',
            labelcz: 'Organismo Internacional'
        },
        {
            value: 'SMWM',
            labelcz: 'Sindicato y su Federación'
        },
        {
            value: 'YOIW',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'H2BW',
            labelcz: 'Sociedad civil'
        },
        {
            value: 'SBQF',
            labelcz: 'Sociedad colectiva'
        },
        {
            value: 'P864',
            labelcz: 'Sociedad de Responsabilidad Limitada o Sociedad Limitada'
        },
        {
            value: 'KZMF',
            labelcz: 'Sociedad de usuarios de aguas'
        },
        {
            value: 'YP63',
            labelcz: 'Sociedad en comandita'
        },
        {
            value: 'E26K',
            labelcz: 'Sociedad Profesional'
        },
        {
            value: 'LQVG',
            labelcz: 'Sucesión Indivisa'
        },
        {
            value: 'HSX9',
            labelcz: 'Temporalidad de la Iglesia'
        }
    ],
    CW: [
        {
            value: 'MZB1',
            labelcz: 'Besloten Vennootschap'
        },
        {
            value: '9E0Q',
            labelcz: 'Commanditaire vennootschap'
        },
        {
            value: 'ADF8',
            labelcz: 'Coöperatie'
        },
        {
            value: '5OZV',
            labelcz: 'Eenmanszaak'
        },
        {
            value: '36AO',
            labelcz: 'Naamloze Vennootschap'
        },
        {
            value: 'SS3A',
            labelcz: 'Onderlinge waarborgmaatschappij'
        },
        {
            value: 'KM1T',
            labelcz: 'Openbare vennootschap'
        },
        {
            value: 'IHD0',
            labelcz: 'Rederij'
        },
        {
            value: '1T06',
            labelcz: 'Stichting'
        },
        {
            value: '2J66',
            labelcz: 'Stichting Particulier Fonds'
        },
        {
            value: '1SVL',
            labelcz: 'Stille vennootschap'
        },
        {
            value: 'ZKTC',
            labelcz: 'Trust'
        },
        {
            value: 'WV3I',
            labelcz: 'Vereniging'
        }
    ],
    CY: [
        {
            value: 'I8RE',
            labelcz: 'Aftotelos ergazomenos'
        },
        {
            value: 'MYKG',
            labelcz: 'Dimosia Etaireia'
        },
        {
            value: 'BCF5',
            labelcz: 'Dimosia Etaireia Periorismenis Efthynis me metoches'
        },
        {
            value: 'W86L',
            labelcz: 'Etaireia Periorismenis Efthynis me engyisi, choris metochiko kefalaio'
        },
        {
            value: 'INTY',
            labelcz: 'Etaireia Periorismenis Efthynis me engyisi, kai pou echei metochiko kefalaio'
        },
        {
            value: '8BL9',
            labelcz: 'Evropaiki Dimosia Etaireia Periorismenis Efthynis'
        },
        {
            value: 'RCPI',
            labelcz: 'Idiotiki Etaireia'
        },
        {
            value: 'K9L6',
            labelcz: 'Idiotiki Etaireia Periorismenis Efthynis me metoches'
        },
        {
            value: 'T1JS',
            labelcz: 'Ontotites pou diepontai apo to dimosio dikaio'
        },
        {
            value: 'GLCH',
            labelcz: 'Somateia kai Idrymata'
        },
        {
            value: 'U24X',
            labelcz: 'Synergatika Pistotika Idrymata'
        },
        {
            value: '233U',
            labelcz: 'Synetairismos'
        },
        {
            value: 'P12B',
            labelcz: 'Tameia Pronoias/ Syntaxeos'
        },
        {
            value: '8VZ0',
            labelcz: 'Trust'
        },
        {
            value: 'P5JT',
            labelcz: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού'
        }
    ],
    CZ: [
        {
            value: '6CQN',
            labelcz: 'Akciová společnost'
        },
        {
            value: 'FIPS',
            labelcz: 'Banka-státní peněžní ústav'
        },
        {
            value: 'T3Q1',
            labelcz: 'Bytové družstvo'
        },
        {
            value: 'FY1B',
            labelcz: 'Církve a náboženské společnosti'
        },
        {
            value: '2N9X',
            labelcz: 'Česká konsolidační agentura'
        },
        {
            value: 'NPH3',
            labelcz: 'Česká národní banka'
        },
        {
            value: '917C',
            labelcz: 'Česká tisková kancelář'
        },
        {
            value: 'LJ92',
            labelcz: 'Československé státní dráhy-státní organizace'
        },
        {
            value: 'MAVU',
            labelcz: 'Dobrovolný svazek obcí'
        },
        {
            value: 'RHFQ',
            labelcz: 'Družstevní podnik (s 1 zakladatelem)'
        },
        {
            value: 'WJ30',
            labelcz: 'Družstevní podnik zemědělský'
        },
        {
            value: '9RVC',
            labelcz: 'Družstvo'
        },
        {
            value: 'JCAD',
            labelcz: 'Evidované církevní právnické osoby'
        },
        {
            value: 'T1FT',
            labelcz: 'Evropská družstevní společnost'
        },
        {
            value: 'ZQO8',
            labelcz: 'Evropská společnost'
        },
        {
            value: 'RBGQ',
            labelcz: 'Evropské hospodářské zájmové sdružení'
        },
        {
            value: '3BX3',
            labelcz: 'Evropské seskupení pro územní spolupráci'
        },
        {
            value: '4UB2',
            labelcz: 'Garanční fond obchodníků s cennými papíry'
        },
        {
            value: 'LEDI',
            labelcz: 'Honební společenstvo'
        },
        {
            value: 'ZU32',
            labelcz: 'Jiné družstvo'
        },
        {
            value: 'NQHQ',
            labelcz: 'Komoditní burza'
        },
        {
            value: 'HQPK',
            labelcz: 'Komora (hospodářská, agrární)'
        },
        {
            value: 'QIEL',
            labelcz: 'Kraj'
        },
        {
            value: 'PFE5',
            labelcz: 'Městská část, městský obvod'
        },
        {
            value: 'PQJE',
            labelcz: 'Mezinárodní nevládní organizace'
        },
        {
            value: 'LPCQ',
            labelcz: 'Mezinárodní odborová organizace'
        },
        {
            value: 'CUKQ',
            labelcz: 'Mezinárodní organizace zaměstnavatelů'
        },
        {
            value: '3G3D',
            labelcz: 'Nadace'
        },
        {
            value: 'QS6A',
            labelcz: 'Nadační fond'
        },
        {
            value: 'UFDA',
            labelcz: 'Národní podnik'
        },
        {
            value: '9XDB',
            labelcz: 'Občanské sdružení'
        },
        {
            value: 'J8PB',
            labelcz: 'Obec'
        },
        {
            value: 'BL4B',
            labelcz: 'Obecně prospěšná společnost'
        },
        {
            value: 'RP0E',
            labelcz: 'Obecní podnik'
        },
        {
            value: 'INIG',
            labelcz: 'Odborová organizace'
        },
        {
            value: 'WUFK',
            labelcz: 'Odštěpný závod'
        },
        {
            value: 'U95A',
            labelcz: 'Odštěpný závod zahraniční fyzické osoby'
        },
        {
            value: 'R2XE',
            labelcz: 'Organizační jednotka mezinárodní nevládní organizace'
        },
        {
            value: '6OMW',
            labelcz: 'Organizační jednotka občanského sdružení'
        },
        {
            value: 'I68R',
            labelcz:
                'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích'
        },
        {
            value: 'LJL0',
            labelcz: 'Organizační složka státu'
        },
        {
            value: 'VQU7',
            labelcz: 'Organizační složka zahraniční nadace'
        },
        {
            value: 'HY6K',
            labelcz: 'Organizační složka zahraničního nadačního fondu'
        },
        {
            value: '5AP3',
            labelcz: 'Pobočná mezinárodní organizace zaměstnavatelů'
        },
        {
            value: 'G2I3',
            labelcz: 'Pobočný spolek'
        },
        {
            value: 'SNWJ',
            labelcz: 'Podílový, penzijní fond'
        },
        {
            value: '2DK3',
            labelcz: 'Podnik nebo hospodářské zařízení politické strany'
        },
        {
            value: '971Y',
            labelcz: 'Podnik nebo hospodářské zařízení sdružení'
        },
        {
            value: 'CHJR',
            labelcz: 'Podnik se zahraniční majetkovou účastí'
        },
        {
            value: 'HSNC',
            labelcz: 'Podnik zahraničního obchodu'
        },
        {
            value: '95G8',
            labelcz: 'Podnikající fyzická osoba tuzemská'
        },
        {
            value: 'XRK7',
            labelcz: 'Politická strana, politické hnutí'
        },
        {
            value: 'XG70',
            labelcz: 'Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku'
        },
        {
            value: 'MBUU',
            labelcz: 'Příspěvková organizace zřízená územním samosprávným celkem'
        },
        {
            value: 'QJWK',
            labelcz: 'Rada pro veřejný dohled nad auditem'
        },
        {
            value: '4OTK',
            labelcz: 'Regionální rada regionu soudržnosti'
        },
        {
            value: 'O9PW',
            labelcz: 'Samosprávná stavovská organizace (profesní komora)'
        },
        {
            value: 'C5FE',
            labelcz: 'Samostatná drobná provozovna (obecního úřadu)'
        },
        {
            value: 'I32F',
            labelcz: 'Sdružení mezinárodního obchodu'
        },
        {
            value: 'IQ9O',
            labelcz: 'Společenství vlastníků jednotek'
        },
        {
            value: 'V6YH',
            labelcz: 'Společná zájmová organizace družstev'
        },
        {
            value: 'CD28',
            labelcz: 'Společnost komanditní'
        },
        {
            value: '747U',
            labelcz: 'Společnost komanditní na akcie'
        },
        {
            value: '9HLU',
            labelcz: 'Společnost s ručením omezeným'
        },
        {
            value: 'Y18E',
            labelcz: 'Společný podnik'
        },
        {
            value: 'NJ87',
            labelcz: 'Společný podnik (s více zakladateli)'
        },
        {
            value: 'CATU',
            labelcz: 'Spolek'
        },
        {
            value: '8K5T',
            labelcz: 'Spotřební družstvo'
        },
        {
            value: 'APEN',
            labelcz: 'Správa železniční dopravní cesty, státní organizace'
        },
        {
            value: '4YAK',
            labelcz: 'Stálý rozhodčí soud'
        },
        {
            value: 'KM6Z',
            labelcz: 'Státní banka československá'
        },
        {
            value: '3RMA',
            labelcz: 'Státní fond ze zákona'
        },
        {
            value: 'AM3T',
            labelcz: 'Státní fond ze zákona nezapisující se do obchodního rejstříku'
        },
        {
            value: '84J8',
            labelcz: 'Státní hospodářská organizace řízená okresním úřadem'
        },
        {
            value: '6FAI',
            labelcz: 'Státní podnik'
        },
        {
            value: 'H6WW',
            labelcz: 'Státní příspěvková organizace'
        },
        {
            value: '74W6',
            labelcz: 'Státní příspěvková organizace ostatní'
        },
        {
            value: 'ET6Z',
            labelcz: 'Svazy církví a náboženských společností'
        },
        {
            value: '1JK6',
            labelcz: 'Svépomocné zemědělské družstvo'
        },
        {
            value: '6D9L',
            labelcz: 'Svěřenský fond'
        },
        {
            value: 'D1VK',
            labelcz: 'Školská právnická osoba'
        },
        {
            value: 'WVZF',
            labelcz: 'Účelová zahraničně obchodní organizace'
        },
        {
            value: 'QJ0F',
            labelcz: 'Ústav'
        },
        {
            value: '5KU5',
            labelcz: 'Veřejná obchodní společnost'
        },
        {
            value: 'CIO8',
            labelcz: 'Veřejná výzkumná instituce'
        },
        {
            value: 'H4XQ',
            labelcz: 'Veřejné neziskové ústavní zdravotnické zařízení'
        },
        {
            value: 'NI3I',
            labelcz: 'Veřejnoprávní instituce'
        },
        {
            value: 'HS5W',
            labelcz: 'Vnitřní organizační jednotka organizační složky státu'
        },
        {
            value: 'C4Q2',
            labelcz: 'Všeobecná zdravotní pojišťovna'
        },
        {
            value: 'C7GZ',
            labelcz: 'Výrobní družstvo'
        },
        {
            value: 'OVKW',
            labelcz: 'Vysoká škola (veřejná, státní)'
        },
        {
            value: 'CZUA',
            labelcz: 'Zahraniční fyzická osoba'
        },
        {
            value: 'JJYB',
            labelcz: 'Zahraniční pobočný spolek'
        },
        {
            value: 'D35X',
            labelcz: 'Zahraniční spolek'
        },
        {
            value: '4A26',
            labelcz: 'Zájmová organizace družstev'
        },
        {
            value: '7OZQ',
            labelcz: 'Zájmové sdružení'
        },
        {
            value: 'VIE3',
            labelcz: 'Zájmové sdružení právnických osob'
        },
        {
            value: 'QQ49',
            labelcz: 'Zdravotní pojišťovna (mimo VZP)'
        },
        {
            value: 'Z3BF',
            labelcz: 'Zemědělské družstvo'
        },
        {
            value: 'WL83',
            labelcz: 'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích'
        }
    ],
    DE: [
        {
            value: '6QQB',
            labelcz: 'Aktiengesellschaft'
        },
        {
            value: 'XLWA',
            labelcz: 'Anstalt des öffentlichen Rechts'
        },
        {
            value: 'AZFE',
            labelcz: 'Eingetragene Genossenschaft'
        },
        {
            value: 'PDNU',
            labelcz: 'eingetragene Gesellschaft bürgerlichen Rechts'
        },
        {
            value: 'QZ3L',
            labelcz: 'eingetragener Verein'
        },
        {
            value: 'OL20',
            labelcz: 'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau'
        },
        {
            value: 'SGST',
            labelcz: 'Europäische Aktiengesellschaft'
        },
        {
            value: 'SUA1',
            labelcz: 'Europäische Genossenschaft'
        },
        {
            value: 'JNDX',
            labelcz: 'Europäische wirtschaftliche Interessenvereinigung'
        },
        {
            value: 'YA01',
            labelcz: 'Gemeinnützige Aktiengesellschaft'
        },
        {
            value: 'SCE1',
            labelcz: 'Gemeinnützige Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'US8E',
            labelcz: 'Genossenschaft'
        },
        {
            value: 'FR3V',
            labelcz: 'Gesellschaft bürgerlichen Rechts'
        },
        {
            value: '2HBR',
            labelcz: 'Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'JMVF',
            labelcz: 'Investmentaktiengesellschaft'
        },
        {
            value: 'YJ4C',
            labelcz: 'Kirchliche Stiftung des öffentlichen Rechts'
        },
        {
            value: '8Z6G',
            labelcz: 'Kommanditgesellschaft'
        },
        {
            value: 'T0YJ',
            labelcz: 'Kommanditgesellschaft auf Aktien'
        },
        {
            value: 'SQKS',
            labelcz: 'Körperschaft des öffentlichen Rechts'
        },
        {
            value: '9JGX',
            labelcz: 'Landesinnungsverband'
        },
        {
            value: '79H0',
            labelcz: 'Nicht eingetragener Verein'
        },
        {
            value: '40DB',
            labelcz: 'Offene Handelsgesellschaft'
        },
        {
            value: '8CM0',
            labelcz: 'Partnerschaftsgesellschaft'
        },
        {
            value: '2YZO',
            labelcz: 'Partnerschaftsgesellschaft mit beschränkter Berufshaftung'
        },
        {
            value: 'AMKW',
            labelcz: 'REIT-Aktiengesellschaft'
        },
        {
            value: 'FEBD',
            labelcz: 'Stiftung des öffentlichen Rechts'
        },
        {
            value: 'V2YH',
            labelcz: 'Stiftung des privaten Rechts'
        },
        {
            value: '63KS',
            labelcz: 'Unternehmergesellschaft'
        },
        {
            value: 'D40E',
            labelcz: 'Verein alten Rechts'
        },
        {
            value: '13AV',
            labelcz: 'Versicherungsverein auf Gegenseitigkeit'
        },
        {
            value: '7J3S',
            labelcz: 'Wirtschaftlicher Verein'
        }
    ],
    DK: [
        {
            value: 'ZRPO',
            labelcz: 'Aktieselskab'
        },
        {
            value: 'PZ6Y',
            labelcz: 'Andelsselskab med begrænset ansvar'
        },
        {
            value: 'H8VP',
            labelcz: 'Anpartsselskab'
        },
        {
            value: 'FUKI',
            labelcz: 'Enkeltmandsvirksomhed'
        },
        {
            value: 'FW7S',
            labelcz: 'Europæisk andelsselskab'
        },
        {
            value: 'TB2C',
            labelcz: 'Europæisk økonomisk firmagruppe'
        },
        {
            value: 'UA1O',
            labelcz: 'Europæisk selskab'
        },
        {
            value: '1MWR',
            labelcz: 'Fond'
        },
        {
            value: 'WU7R',
            labelcz: 'Forening med begrænset ansvar'
        },
        {
            value: '7WRN',
            labelcz: 'Interessentskab'
        },
        {
            value: '5QS7',
            labelcz: 'Iværksætterselskab'
        },
        {
            value: 'NUL8',
            labelcz: 'Kommanditselskab'
        },
        {
            value: 'LWOD',
            labelcz: 'Medarbejderinvesteringsselskab'
        },
        {
            value: '9KSX',
            labelcz: 'Partnerselskab'
        },
        {
            value: 'UX9X',
            labelcz: 'Personligt ejet Mindre Virksomhed '
        },
        {
            value: 'GULL',
            labelcz: 'Selskab med begrænset ansvar'
        }
    ],
    DO: [
        {
            value: 'K4CD',
            labelcz: 'Empresa Individual de Responsabilidad Limitada '
        },
        {
            value: '3ZBR',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'DQAU',
            labelcz: 'Sociedad Anónima Simplificada'
        },
        {
            value: 'SWO8',
            labelcz: 'Sociedad de Responsaibilidad Limitada'
        },
        {
            value: 'T4LC',
            labelcz: 'Sociedad en Comandita por Acciones'
        },
        {
            value: '8WQ9',
            labelcz: 'Sociedad en Comandita Simple'
        },
        {
            value: 'LSWY',
            labelcz: 'Sociedad en Nombre Colectivo'
        },
        {
            value: 'B35X',
            labelcz: 'Sociedad en Participación(sin personalidad jurídica)'
        }
    ],
    EC: [
        {
            value: 'J3T2',
            labelcz: 'Compañía Anónima'
        },
        {
            value: 'N9QH',
            labelcz: 'Compañía de Economía Mixta'
        },
        {
            value: 'XOAD',
            labelcz: 'Compañía de Responsabilidad Limitada'
        },
        {
            value: 'FKVG',
            labelcz: 'Compañía en Comandita Simple y dividida por acciones'
        },
        {
            value: '6TPE',
            labelcz: 'Compañía en nombre colectivo'
        },
        {
            value: 'AVFT',
            labelcz: 'Cooperativa'
        },
        {
            value: 'ZUDG',
            labelcz: 'Fundacion'
        },
        {
            value: 'GKUL',
            labelcz: 'Sociedad por Acciones Simplificada'
        }
    ],
    EE: [
        {
            value: '9LJA',
            labelcz: 'Aktsiaselts'
        },
        {
            value: 'J34T',
            labelcz: 'Ametiühing'
        },
        {
            value: 'BE56',
            labelcz: 'Avalik-õiguslik juriidiline isik'
        },
        {
            value: 'GA3A',
            labelcz: 'Erakond'
        },
        {
            value: '752Q',
            labelcz: 'Euroopa äriühing'
        },
        {
            value: 'LA47',
            labelcz: 'Euroopa majandushuviühing'
        },
        {
            value: 'RXTT',
            labelcz: 'Euroopa ühistu'
        },
        {
            value: '3UPJ',
            labelcz: 'Füüsilisest isikust ettevõtja'
        },
        {
            value: '6I0P',
            labelcz: 'Hooneühistu'
        },
        {
            value: '8ZQE',
            labelcz: 'Korteriühistu'
        },
        {
            value: 'PMOF',
            labelcz: 'Loomeliit'
        },
        {
            value: 'PRTB',
            labelcz: 'Mittetulundusühing'
        },
        {
            value: 'JC0Y',
            labelcz: 'Osaühing'
        },
        {
            value: '1NKP',
            labelcz: 'Sihtasutus'
        },
        {
            value: 'I1UP',
            labelcz: 'Täisühing'
        },
        {
            value: 'VSEV',
            labelcz: 'Tulundusühistu'
        },
        {
            value: 'LVEQ',
            labelcz: 'Usaldusühing'
        },
        {
            value: 'CKOS',
            labelcz: 'Usuline ühendus'
        }
    ],
    ES: [
        {
            value: 'I2WU',
            labelcz: 'Agrupacion de Interes Economico'
        },
        {
            value: 'BI3B',
            labelcz: 'Agrupacion Europea de Interes Economico'
        },
        {
            value: 'A0J6',
            labelcz: 'Asociación'
        },
        {
            value: '4S57',
            labelcz: 'Caja de Ahorros'
        },
        {
            value: 'UFBW',
            labelcz: 'Comunidad de Bienes'
        },
        {
            value: 'S6MS',
            labelcz: 'Congregación'
        },
        {
            value: 'SS0L',
            labelcz: 'Cooperativa de Credito'
        },
        {
            value: 'TUHS',
            labelcz: 'Corporación de Derecho Público'
        },
        {
            value: 'IT6N',
            labelcz: 'Emprendedor de Responsabilidad Limitada'
        },
        {
            value: '1SL4',
            labelcz: 'Empresario Individual'
        },
        {
            value: 'NFHN',
            labelcz: 'Entidades de Previsión Social Voluntaria'
        },
        {
            value: 'JTV5',
            labelcz: 'Fondo de Capital-Riesgo'
        },
        {
            value: 'XYGP',
            labelcz: 'Fondo de Capital-Riesgo-Pyme'
        },
        {
            value: 'S0Z5',
            labelcz: 'Fondo de Inversion'
        },
        {
            value: 'FCJF',
            labelcz: 'Fondo de Inversion en activos del Mercado Monetario'
        },
        {
            value: 'UJ35',
            labelcz: 'Fondo de Inversion Mobiliaria'
        },
        {
            value: 'FH4R',
            labelcz: 'Fondo de Pensiones'
        },
        {
            value: 'QMUM',
            labelcz: 'Fondos de Inversion Inmobiliaria'
        },
        {
            value: 'MDOL',
            labelcz: 'Fundación'
        },
        {
            value: 'K0RI',
            labelcz: 'Institucion de Inversion Colectiva'
        },
        {
            value: 'CUIH',
            labelcz: 'Mutua'
        },
        {
            value: 'A97B',
            labelcz: 'Mutualidad de Prevision Social'
        },
        {
            value: '4SJR',
            labelcz: 'Sociedad Agraría de Trasformación'
        },
        {
            value: '5RDO',
            labelcz: 'Sociedad Anonima'
        },
        {
            value: '9FPZ',
            labelcz: 'Sociedad Anonima Europea'
        },
        {
            value: 'R2L8',
            labelcz: 'Sociedad Anonima Laboral'
        },
        {
            value: 'AJ9U',
            labelcz: 'Sociedad Anonima Profesional'
        },
        {
            value: '2W1A',
            labelcz: 'Sociedad Civil'
        },
        {
            value: 'K6L9',
            labelcz: 'Sociedad Civil Profesional'
        },
        {
            value: 'S6X7',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: '1ZHJ',
            labelcz: 'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)'
        },
        {
            value: 'GJL1',
            labelcz: 'Sociedad Comanditaria por Acciones'
        },
        {
            value: 'GJTL',
            labelcz: 'Sociedad Comanditaria por Acciones Profesional'
        },
        {
            value: 'TDD5',
            labelcz: 'Sociedad Comanditaria Simple'
        },
        {
            value: 'VFIU',
            labelcz: 'Sociedad Comanditaria Simple Profesional'
        },
        {
            value: '1QU8',
            labelcz: 'Sociedad Cooperativa'
        },
        {
            value: 'HRQA',
            labelcz: 'Sociedad Cooperativa Europea'
        },
        {
            value: 'B0V5',
            labelcz: 'Sociedad Cooperativa Profesional'
        },
        {
            value: 'AXS5',
            labelcz: 'Sociedad de Capital-Riesgo'
        },
        {
            value: 'DDES',
            labelcz: 'Sociedad de Capital-Riesgo-Pyme'
        },
        {
            value: 'IAS6',
            labelcz: 'Sociedad de Garantia Reciproca'
        },
        {
            value: '8EHB',
            labelcz: 'Sociedad de Inversión de Capital Variable'
        },
        {
            value: 'DP3Q',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: '1G29',
            labelcz: 'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)'
        },
        {
            value: 'JB2M',
            labelcz: 'Sociedad Limitada Profesional'
        },
        {
            value: 'R6UT',
            labelcz: 'Sociedad Limitada Unipersonal'
        },
        {
            value: '7U8O',
            labelcz: 'Sociedades de Inversion Inmobiliaria'
        }
    ],
    EU: [],
    FI: [
        {
            value: 'UXEW',
            labelcz: 'Aatteellinen yhdistys'
        },
        {
            value: 'XGKW',
            labelcz: 'Ahvenanmaan liikelaitos'
        },
        {
            value: 'SQS1',
            labelcz: 'Ahvenanmaan maakunta ja sen virastot'
        },
        {
            value: 'IX7U',
            labelcz: 'Asukashallintoalue'
        },
        {
            value: 'MBPY',
            labelcz: 'Asumisoikeusyhdistys'
        },
        {
            value: 'V0TJ',
            labelcz: 'Asunto-osakeyhtiö'
        },
        {
            value: 'PPMX',
            labelcz: 'Avoin yhtiö'
        },
        {
            value: '5WI2',
            labelcz: 'Eläkesäätiö'
        },
        {
            value: '37GR',
            labelcz: 'Elinkeinoyhtymä'
        },
        {
            value: 'HTT9',
            labelcz: 'Erillishallinnollinen valtion laitos'
        },
        {
            value: '8HGS',
            labelcz: 'Erityislainsäädäntöön perustuva yhdistys'
        },
        {
            value: 'HNWB',
            labelcz: 'Eurooppalainen taloudellinen etuyhtymä'
        },
        {
            value: 'C51L',
            labelcz: 'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka'
        },
        {
            value: 'R5ZC',
            labelcz: 'Eurooppaosuuskunnan kiinteä toimipaikka'
        },
        {
            value: 'UAV1',
            labelcz: 'Eurooppaosuuskunta'
        },
        {
            value: 'VKKN',
            labelcz: 'Eurooppaosuuspankki'
        },
        {
            value: 'XJH3',
            labelcz: 'Eurooppayhtiö'
        },
        {
            value: 'IYF9',
            labelcz: 'Evankelis-luterilainen kirkko'
        },
        {
            value: 'HBR3',
            labelcz: 'Julkinen keskinäinen vakuutusyhtiö'
        },
        {
            value: 'K6VE',
            labelcz: 'Julkinen osakeyhtiö'
        },
        {
            value: 'KHI5',
            labelcz: 'Julkinen vakuutusosakeyhtiö'
        },
        {
            value: 'R39F',
            labelcz: 'Kauppakamari'
        },
        {
            value: '8WJ7',
            labelcz: 'Keskinäinen kiinteistöosakeyhtiö'
        },
        {
            value: 'JI3A',
            labelcz: 'Keskinäinen vahinkovakuutusyhdistys'
        },
        {
            value: '4H61',
            labelcz: 'Keskinäinen vakuutusyhtiö'
        },
        {
            value: 'HEOB',
            labelcz: 'Kommandiittiyhtiö'
        },
        {
            value: 'UMF0',
            labelcz: 'Konkurssipesä'
        },
        {
            value: '2RK5',
            labelcz: 'Kunta'
        },
        {
            value: 'T31U',
            labelcz: 'Kuntainliiton liikelaitos'
        },
        {
            value: 'VOTI',
            labelcz: 'Kuntayhtymä'
        },
        {
            value: 'ZMTL',
            labelcz: 'Kuolinpesä'
        },
        {
            value: 'BQ19',
            labelcz: 'Laivanisännistöyhtiö'
        },
        {
            value: '1YIR',
            labelcz: 'Metsänhoitoyhdistys'
        },
        {
            value: 'MRW9',
            labelcz: 'Muu julkisoikeudellinen oikeushenkilö'
        },
        {
            value: 'NV7C',
            labelcz: 'Muu säätiö'
        },
        {
            value: 'EMC8',
            labelcz: 'Muu taloudellinen yhdistys'
        },
        {
            value: 'SUHV',
            labelcz: 'Muu verotuksen yksikkö'
        },
        {
            value: '760X',
            labelcz: 'Muu yhdistys'
        },
        {
            value: 'LBQS',
            labelcz: 'Muu yhteisvastuullinen pidätysvelvollinen'
        },
        {
            value: '1AFG',
            labelcz: 'Muu yhtiö'
        },
        {
            value: 'K2G8',
            labelcz: 'Muut oikeushenkilöt'
        },
        {
            value: 'V42B',
            labelcz: 'Ortodoksinen kirkko'
        },
        {
            value: 'DKUW',
            labelcz: 'Osakeyhtiö'
        },
        {
            value: 'EE90',
            labelcz: 'Osuuskunta'
        },
        {
            value: 'SJL9',
            labelcz: 'Osuuspankki'
        },
        {
            value: '6PEQ',
            labelcz: 'Paikallisyhteisö'
        },
        {
            value: 'L7XJ',
            labelcz: 'Paliskunta'
        },
        {
            value: 'N3LC',
            labelcz: 'Rekisteröity uskonnollinen yhdyskunta'
        },
        {
            value: 'Z38E',
            labelcz: 'Säästöpankki'
        },
        {
            value: 'YK5G',
            labelcz: 'Säätiö'
        },
        {
            value: '883O',
            labelcz: 'Sivuliike'
        },
        {
            value: 'EDN7',
            labelcz: 'Taloudellinen yhdistys'
        },
        {
            value: 'DMT8',
            labelcz: 'Työeläkekassa'
        },
        {
            value: 'SDPE',
            labelcz: 'Työttömyyskassa'
        },
        {
            value: 'DL9Z',
            labelcz: 'Ulkomainen yhteisö'
        },
        {
            value: '97PB',
            labelcz: 'Vakuutuskassa'
        },
        {
            value: 'DAFV',
            labelcz: 'Vakuutusosakeyhtiö'
        },
        {
            value: '9AUC',
            labelcz: 'Vakuutusyhdistys'
        },
        {
            value: 'OXLO',
            labelcz: 'Valtion liikelaitos'
        },
        {
            value: 'R6UB',
            labelcz: 'Verotusyhtymä'
        },
        {
            value: 'SKGX',
            labelcz: 'Yhteisetuudet'
        },
        {
            value: 'K09E',
            labelcz: 'Yksityinen elinkeinonharjoittaja'
        },
        {
            value: 'EDZP',
            labelcz: 'Ylioppilaskunta tai osakunta'
        }
    ],
    FJ: [
        {
            value: 'ND7S',
            labelcz: 'Co-operative'
        },
        {
            value: 'YN9X',
            labelcz: 'Government Owned Trading Entity'
        },
        {
            value: 'XHWP',
            labelcz: 'Non-Profit Organisation'
        },
        {
            value: 'QP3O',
            labelcz: 'Partnership'
        },
        {
            value: 'IOFN',
            labelcz: 'Private Limited Company'
        },
        {
            value: '7AWY',
            labelcz: 'Public Limited Company'
        },
        {
            value: '43JO',
            labelcz: 'Sole Trader'
        },
        {
            value: 'JRTH',
            labelcz: 'Trusts and Estates'
        }
    ],
    FO: [
        {
            value: 'UCR1',
            labelcz: 'Alment partafelag'
        },
        {
            value: 'KJ1S',
            labelcz: 'Fyritøkugrunnur'
        },
        {
            value: 'E0FR',
            labelcz: 'Partafelag'
        },
        {
            value: 'MMBP',
            labelcz: 'Samstarv'
        },
        {
            value: '09K3',
            labelcz: 'Samstarvsfelag við ábyrgd'
        }
    ],
    FR: [
        {
            value: '2N4L',
            labelcz: '(Autre) Collectivité territoriale'
        },
        {
            value: 'NQCT',
            labelcz: '(Autre) Établissement public administratif local'
        },
        {
            value: '8G07',
            labelcz: '(Autre) Personne physique'
        },
        {
            value: '8GTU',
            labelcz: "(Autre) Service déconcentré de l'État à compétence territoriale"
        },
        {
            value: 'RT6Y',
            labelcz: 'Agent commercial'
        },
        {
            value: 'KFR1',
            labelcz: 'Artisan'
        },
        {
            value: 'CNXL',
            labelcz: 'Artisan-commerçant'
        },
        {
            value: 'NFCV',
            labelcz: 'Association coopérative inscrite (droit local Alsace Moselle)'
        },
        {
            value: 'Z9K8',
            labelcz: "Association d'avocats à responsabilité professionnelle individuelle"
        },
        {
            value: 'HF2L',
            labelcz: 'Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)'
        },
        {
            value: 'BEWI',
            labelcz: 'Association déclarée'
        },
        {
            value: 'DWYD',
            labelcz: "Association déclarée d'insertion par l'économique"
        },
        {
            value: 'XH8C',
            labelcz: "Association déclarée, reconnue d'utilité publique"
        },
        {
            value: 'P714',
            labelcz: 'Association fonciére de remembrement'
        },
        {
            value: '9O0S',
            labelcz: 'Association fonciére urbaine'
        },
        {
            value: 'HATI',
            labelcz: 'Association intermédiaire'
        },
        {
            value: '491H',
            labelcz: 'Association non déclarée'
        },
        {
            value: '4JS0',
            labelcz: 'Association syndicale autorisée'
        },
        {
            value: 'ZPEZ',
            labelcz: 'Association syndicale libre'
        },
        {
            value: 'LU8S',
            labelcz: 'Associé gérant de Société'
        },
        {
            value: 'MOUL',
            labelcz: 'Assurance mutuelle agricole'
        },
        {
            value: 'YADL',
            labelcz: 'Autorité administrative ou publique indépendante'
        },
        {
            value: 'AMFI',
            labelcz: 'Autorité constitutionnelle'
        },
        {
            value: '4H0F',
            labelcz: 'Autre établissement public local de coopération non spécialisé ou entente'
        },
        {
            value: 'NBA8',
            labelcz: 'Autre établissement public national administratif à compétence territoriale limitée'
        },
        {
            value: 'GXL6',
            labelcz: "Autre établissement public national d'enseignement"
        },
        {
            value: '7SZH',
            labelcz: 'Autre groupement de droit privé non doté de la personnalité morale'
        },
        {
            value: 'DTAX',
            labelcz: 'Autre organisme mutualiste'
        },
        {
            value: 'OIQA',
            labelcz: 'Autre organisme professionnel'
        },
        {
            value: '3NJL',
            labelcz: 'Autre personne de droit privé inscrite au registre du commerce et des sociétés'
        },
        {
            value: '2WMP',
            labelcz: 'Autre personne morale de droit administratif'
        },
        {
            value: '8WH8',
            labelcz: 'Autre personne morale de droit étranger'
        },
        {
            value: '34QS',
            labelcz: 'Autre personne morale de droit privé'
        },
        {
            value: '8LX5',
            labelcz: 'Autre régime de prévoyance sociale'
        },
        {
            value: '8II5',
            labelcz: "Autre SA coopérative à conseil d'administration"
        },
        {
            value: '8TYA',
            labelcz: 'Autre SA coopérative à directoire'
        },
        {
            value: '4DZU',
            labelcz: 'Autre SARL coopérative'
        },
        {
            value: '1L24',
            labelcz: 'Autre société civile'
        },
        {
            value: 'HMEI',
            labelcz: 'Autre société civile coopérative'
        },
        {
            value: 'HSYZ',
            labelcz: 'Autre société civile professionnelle'
        },
        {
            value: 'E6YB',
            labelcz: 'Caisse (fédérale) de crédit mutuel'
        },
        {
            value: '5AJO',
            labelcz: "Caisse d'Épargne et de Prévoyance"
        },
        {
            value: 'MQPZ',
            labelcz: "Caisse d'épargne et de prévoyance à forme coopérative"
        },
        {
            value: 'S0X8',
            labelcz: 'Caisse de crédit agricole mutuel'
        },
        {
            value: 'EVYY',
            labelcz: 'Caisse de crédit maritime mutuel'
        },
        {
            value: 'HA3N',
            labelcz: 'Caisse de crédit municipal'
        },
        {
            value: 'TGRE',
            labelcz: 'Caisse des écoles'
        },
        {
            value: 'Y7G8',
            labelcz: 'Caisse locale de crédit mutuel'
        },
        {
            value: 'P3J5',
            labelcz: "Centre communal d'action sociale"
        },
        {
            value: 'GLN8',
            labelcz: "Centre Intercommunal d'action sociale (CIAS)"
        },
        {
            value: 'EYRI',
            labelcz: 'Centre technique industriel ou comité professionnel du développement économique'
        },
        {
            value: '7UHA',
            labelcz: "Collectivité et territoire d'Outre Mer"
        },
        {
            value: 'XK4T',
            labelcz: 'Comité social économique d’entreprise'
        },
        {
            value: 'K99N',
            labelcz: 'Comité social économique d’établissement'
        },
        {
            value: '5H68',
            labelcz: 'Commerçant'
        },
        {
            value: 'JMO0',
            labelcz: 'Commission syndicale pour la gestion des biens indivis des communes'
        },
        {
            value: 'NOI8',
            labelcz: "Communauté d'agglomération"
        },
        {
            value: 'OWUN',
            labelcz: 'Communauté de communes'
        },
        {
            value: 'RWMC',
            labelcz: 'Communauté de villes'
        },
        {
            value: 'R1JO',
            labelcz: 'Communauté urbaine'
        },
        {
            value: '8IWA',
            labelcz: 'Commune associée et commune déléguée'
        },
        {
            value: 'FFQL',
            labelcz: 'Commune et commune nouvelle'
        },
        {
            value: 'PWKL',
            labelcz: 'Congrégation'
        },
        {
            value: '3AZY',
            labelcz: "Coopérative d'utilisation de matériel agricole en commun (CUMA)"
        },
        {
            value: 'Y4VA',
            labelcz: 'Département'
        },
        {
            value: '94WO',
            labelcz: 'District urbain'
        },
        {
            value: 'UQRY',
            labelcz: 'Ecole nationale non dotée de la personnalité morale'
        },
        {
            value: 'C4D7',
            labelcz: 'Ensemble urbain'
        },
        {
            value: 'ZY9X',
            labelcz: 'Entrepreneur individuel'
        },
        {
            value: 'UZY3',
            labelcz: "Établissement d'hospitalisation"
        },
        {
            value: 'KCN5',
            labelcz: 'Etablissement public administratif, cercle et foyer dans les armées'
        },
        {
            value: 'ZZ0X',
            labelcz: "Établissement public des cultes d'Alsace-Lorraine"
        },
        {
            value: 'VO18',
            labelcz: 'Établissement public local à caractére industriel ou commercial'
        },
        {
            value: 'PL6V',
            labelcz: 'Établissement public local culturel'
        },
        {
            value: '487E',
            labelcz: "Établissement public local d'enseignement"
        },
        {
            value: '5K0Q',
            labelcz: 'Établissement public local social et médico-social'
        },
        {
            value: 'KMPN',
            labelcz: 'Établissement public national à caractére administratif'
        },
        {
            value: 'F72Z',
            labelcz: "Établissement public national à caractére industriel ou commercial doté d'un comptable public"
        },
        {
            value: 'Z0JP',
            labelcz: "Établissement public national à caractére industriel ou commercial non doté d'un comptable public"
        },
        {
            value: 'K7XQ',
            labelcz: 'Établissement public national à caractére scientifique culturel et professionnel'
        },
        {
            value: 'FEEA',
            labelcz: "Établissement public national ayant fonction d'administration centrale"
        },
        {
            value: '2NL6',
            labelcz: 'État, collectivité ou établissement public étranger'
        },
        {
            value: 'TNPO',
            labelcz: 'Exploitant agricole'
        },
        {
            value: 'ZQ9B',
            labelcz: 'Exploitant public'
        },
        {
            value: 'BAK2',
            labelcz: 'Exploitation agricole à responsabilité limitée'
        },
        {
            value: 'RD0Z',
            labelcz: 'Fiducie'
        },
        {
            value: '9T5S',
            labelcz: 'Fondation'
        },
        {
            value: 'X78I',
            labelcz: "Fonds à forme sociétale à conseil d'administration"
        },
        {
            value: 'VBQP',
            labelcz: 'Fonds à forme sociétale à directoire'
        },
        {
            value: 'QCWO',
            labelcz: "Groupement agricole d'exploitation en commun (GAEC)"
        },
        {
            value: 'W3LD',
            labelcz: 'Groupement agricole foncier'
        },
        {
            value: 'WGCY',
            labelcz: "Groupement d'employeurs"
        },
        {
            value: 'R0B6',
            labelcz: "Groupement d'intérêt économique (GIE)"
        },
        {
            value: 'Z2FQ',
            labelcz: "Groupement d'intérêt public (GIP)"
        },
        {
            value: 'Y8WC',
            labelcz: 'Groupement de coopération sanitaire à gestion privée'
        },
        {
            value: 'R6WQ',
            labelcz: 'Groupement de coopération sanitaire à gestion publique'
        },
        {
            value: '6RUE',
            labelcz: "Groupement européen d'intérêt économique (GEIE)"
        },
        {
            value: '59F9',
            labelcz: 'Groupement foncier agricole'
        },
        {
            value: 'RFWH',
            labelcz: 'Groupement foncier et rural'
        },
        {
            value: '7O94',
            labelcz: 'Groupement forestier'
        },
        {
            value: 'Z5WG',
            labelcz: 'Groupement pastoral'
        },
        {
            value: 'PESN',
            labelcz: 'Indivision avec personne morale'
        },
        {
            value: 'Q634',
            labelcz: 'Indivision entre personnes physiques'
        },
        {
            value: 'VBC7',
            labelcz: 'Institution Banque de France'
        },
        {
            value: 'JBIQ',
            labelcz: 'Institution de prévoyance'
        },
        {
            value: 'YUCL',
            labelcz: 'Institution de retraite complémentaire'
        },
        {
            value: '61WE',
            labelcz: 'Institution de retraite supplémentaire'
        },
        {
            value: 'MG2O',
            labelcz: 'Institution interdépartementale ou entente'
        },
        {
            value: '29FA',
            labelcz: 'Institution interrégionale ou entente'
        },
        {
            value: 'PZLG',
            labelcz: 'Métropole'
        },
        {
            value: 'JU82',
            labelcz: 'Ministére'
        },
        {
            value: 'CF56',
            labelcz: 'Mutualité sociale agricole'
        },
        {
            value: '2XIK',
            labelcz: 'Mutuelle'
        },
        {
            value: 'TUE5',
            labelcz: "Office public d'habitation à loyer modéré (OPHLM)"
        },
        {
            value: 'YJM5',
            labelcz: 'Officier public ou ministériel'
        },
        {
            value: 'G98S',
            labelcz: 'Ordre professionnel ou assimilé'
        },
        {
            value: 'FKG2',
            labelcz: 'Organisation internationale'
        },
        {
            value: 'QUB4',
            labelcz: 'Organisme consulaire'
        },
        {
            value: 'MQU9',
            labelcz: 'Organisme de placement collectif en valeurs mobilières sans personnalité morale'
        },
        {
            value: 'BYZF',
            labelcz: 'Paroisse hors zone concordataire'
        },
        {
            value: '4VD7',
            labelcz: "Pôle d'équilibre territorial et rural (PETR)"
        },
        {
            value: 'YHI5',
            labelcz: 'Pôle métropolitain'
        },
        {
            value: '4TNX',
            labelcz: 'Profession libérale'
        },
        {
            value: '157O',
            labelcz: "Régie d'une collectivité locale à caractère administratif"
        },
        {
            value: 'K5KA',
            labelcz: "Régie d'une collectivité locale à caractère industriel ou commercial"
        },
        {
            value: 'SSHN',
            labelcz: "Régime d'assurance chômage"
        },
        {
            value: 'CAX5',
            labelcz: 'Régime général de la Sécurité Sociale'
        },
        {
            value: 'V6G1',
            labelcz: 'Régime maladie des non-salariés non agricoles'
        },
        {
            value: 'L6QO',
            labelcz: 'Régime spécial de Sécurité Sociale'
        },
        {
            value: 'OAGA',
            labelcz: 'Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale'
        },
        {
            value: 'CQJI',
            labelcz: 'Région'
        },
        {
            value: 'FBYB',
            labelcz: "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS"
        },
        {
            value: 'K65D',
            labelcz: "SA à conseil d'administration (s.a.i.)"
        },
        {
            value: '5VCF',
            labelcz: 'SA à directoire (s.a.i.)'
        },
        {
            value: 'LGME',
            labelcz: "SA à participation ouvrière à conseil d'administration"
        },
        {
            value: 'AHBR',
            labelcz: 'SA à participation ouvrière à directoire'
        },
        {
            value: '6IIE',
            labelcz: "SA coopérative (d'intérêt) maritime à conseil d'administration"
        },
        {
            value: 'B7I7',
            labelcz: "SA coopérative artisanale à conseil d'administration"
        },
        {
            value: 'NUMY',
            labelcz: 'SA coopérative artisanale à directoire'
        },
        {
            value: 'E0YF',
            labelcz: "SA coopérative d'intérêt maritime à directoire"
        },
        {
            value: 'GFN6',
            labelcz: "SA coopérative de commerçants-détaillants à conseil d'administration"
        },
        {
            value: 'MX8J',
            labelcz: 'SA coopérative de commerçants-détaillants à directoire'
        },
        {
            value: 'IF7H',
            labelcz: "SA coopérative de consommation à conseil d'administration"
        },
        {
            value: 'ZQIT',
            labelcz: 'SA coopérative de consommation à directoire'
        },
        {
            value: 'DRQM',
            labelcz: "SA coopérative de construction à conseil d'administration"
        },
        {
            value: 'UFM7',
            labelcz: 'SA coopérative de construction à directoire'
        },
        {
            value: 'QU3G',
            labelcz: "SA coopérative de production de HLM à conseil d'administration"
        },
        {
            value: 'SWPX',
            labelcz: "SA coopérative de transport à conseil d'administration"
        },
        {
            value: 'H3Z4',
            labelcz: 'SA coopérative de transport à directoire'
        },
        {
            value: 'XPX6',
            labelcz: "SA coopérative ouvrière de production (SCOP) à conseil d'administration"
        },
        {
            value: 'F6SZ',
            labelcz: 'SA coopérative ouvrière de production (SCOP) à directoire'
        },
        {
            value: '8XDK',
            labelcz: "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration"
        },
        {
            value: 'B645',
            labelcz: "SA d'attribution à conseil d'administration"
        },
        {
            value: '2ONM',
            labelcz: "SA d'attribution à directoire"
        },
        {
            value: '8VWR',
            labelcz: "SA d'économie mixte à conseil d'administration"
        },
        {
            value: 'ZM5P',
            labelcz: "SA d'économie mixte à directoire"
        },
        {
            value: '9N1F',
            labelcz: "SA d'intérêt collectif agricole (SICA)"
        },
        {
            value: '6YHU',
            labelcz: "SA d'intérêt collectif agricole (SICA) à conseil d'administration"
        },
        {
            value: 'BAUQ',
            labelcz: "SA de crédit immobilier à conseil d'administration"
        },
        {
            value: 'K69X',
            labelcz: 'SA de crédit immobilier à directoire'
        },
        {
            value: '4RT7',
            labelcz: "SA de HLM à conseil d'administration"
        },
        {
            value: '6SYJ',
            labelcz: 'SA de HLM à directoire'
        },
        {
            value: 'BRGA',
            labelcz: "SA immobilière d'investissement à conseil d'administration"
        },
        {
            value: 'NM07',
            labelcz: "SA immobilière d'investissement à directoire"
        },
        {
            value: 'F93F',
            labelcz: "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration"
        },
        {
            value: 'GQV4',
            labelcz: "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire"
        },
        {
            value: 'I8TE',
            labelcz: "SA mixte d'intérêt agricole (SMIA)"
        },
        {
            value: '1NF1',
            labelcz: "SA nationale à conseil d'administration"
        },
        {
            value: 'TOL2',
            labelcz: 'SA nationale à directoire'
        },
        {
            value: 'K39X',
            labelcz: "SA union de sociétés coopératives à conseil d'administration"
        },
        {
            value: 'MMA4',
            labelcz: 'SA union de sociétés coopératives à directoire'
        },
        {
            value: '87VO',
            labelcz: 'Safer anonyme à directoire'
        },
        {
            value: 'VTFS',
            labelcz: 'SARL coopérative artisanale'
        },
        {
            value: '97PZ',
            labelcz: "SARL coopérative d'intérêt maritime"
        },
        {
            value: '3XTE',
            labelcz: 'SARL coopérative de consommation'
        },
        {
            value: 'G7Z2',
            labelcz: 'SARL coopérative de construction'
        },
        {
            value: 'W4G1',
            labelcz: 'SARL coopérative de transport'
        },
        {
            value: 'V1Z5',
            labelcz: 'SARL coopérative ouvrière de production (SCOP)'
        },
        {
            value: 'CVH6',
            labelcz: "SARL d'aménagement foncier et d'équipement rural (SAFER)"
        },
        {
            value: '1Y0C',
            labelcz: "SARL d'attribution"
        },
        {
            value: 'VJV5',
            labelcz: "SARL d'économie mixte"
        },
        {
            value: 'H3ZD',
            labelcz: "SARL d'intérêt collectif agricole (SICA)"
        },
        {
            value: 'C42J',
            labelcz: 'SARL immobilière de gestion'
        },
        {
            value: 'LUIN',
            labelcz: "SARL immobilière pour le commerce et l'industrie (SICOMI)"
        },
        {
            value: 'FYBN',
            labelcz: "SARL mixte d'intérêt agricole (SMIA)"
        },
        {
            value: 'JR7T',
            labelcz: 'SARL nationale'
        },
        {
            value: 'HC8N',
            labelcz: 'SARL union de sociétés coopératives'
        },
        {
            value: 'JN2P',
            labelcz: 'SARL unipersonnelle'
        },
        {
            value: '6CHY',
            labelcz: 'SAS, société par actions simplifiée'
        },
        {
            value: 'A0VZ',
            labelcz: "SCP d'architectes"
        },
        {
            value: 'T25Y',
            labelcz: "SCP d'avocats"
        },
        {
            value: 'IC8G',
            labelcz: "SCP d'avocats aux conseils"
        },
        {
            value: 'F8UD',
            labelcz: "SCP d'avoués d'appel"
        },
        {
            value: 'WXNU',
            labelcz: "SCP d'huissiers"
        },
        {
            value: 'BDDP',
            labelcz: "SCP d'infirmiers"
        },
        {
            value: 'FOUY',
            labelcz: 'SCP de commissaires aux comptes'
        },
        {
            value: 'IC98',
            labelcz: 'SCP de commissaires-priseurs'
        },
        {
            value: '8FZW',
            labelcz: 'SCP de conseils juridiques'
        },
        {
            value: 'JM1W',
            labelcz: 'SCP de dentistes'
        },
        {
            value: 'UUT8',
            labelcz: "SCP de directeurs de laboratoire d'analyse médicale"
        },
        {
            value: '6CJJ',
            labelcz: 'SCP de géomètres experts'
        },
        {
            value: 'GZCQ',
            labelcz: 'SCP de greffiers de tribunal de commerce'
        },
        {
            value: 'KWI4',
            labelcz: 'SCP de masseurs-kinésithérapeutes'
        },
        {
            value: '1B88',
            labelcz: 'SCP de médecins'
        },
        {
            value: '3OK3',
            labelcz: 'SCP de notaires'
        },
        {
            value: '74HH',
            labelcz: 'SCP de vétérinaires'
        },
        {
            value: 'ECUL',
            labelcz: 'Secteur de commune'
        },
        {
            value: 'Y1W1',
            labelcz: 'Section de commune'
        },
        {
            value: 'UV02',
            labelcz: "Service central d'un ministère"
        },
        {
            value: '8OKM',
            labelcz: "Service déconcentré à compétence nationale d'un ministère (hors Défense)"
        },
        {
            value: '82QO',
            labelcz: "Service déconcentré de l'État à compétence (inter) départementale"
        },
        {
            value: 'SZ63',
            labelcz: "Service déconcentré de l'État à compétence (inter) régionale"
        },
        {
            value: '3S6E',
            labelcz: "Service départemental d'incendie et de secours (SDIS)"
        },
        {
            value: 'CBO2',
            labelcz: 'Service du ministère de la Défense'
        },
        {
            value: 'V9QP',
            labelcz: 'Société à responsabilité limitée (sans autre indication)'
        },
        {
            value: 'QVPB',
            labelcz: 'Société anonyme'
        },
        {
            value: 'L25Z',
            labelcz: "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration"
        },
        {
            value: 'V5SV',
            labelcz: "Société civile coopérative d'intérêt maritime"
        },
        {
            value: 'H4VR',
            labelcz: 'Société civile coopérative de consommation'
        },
        {
            value: 'I0MH',
            labelcz: 'Société civile coopérative de construction'
        },
        {
            value: 'EABD',
            labelcz: 'Société civile coopérative entre médecins'
        },
        {
            value: 'KQH7',
            labelcz: "Société civile d'attribution"
        },
        {
            value: 'M673',
            labelcz: "Société civile d'exploitation agricole"
        },
        {
            value: 'IQR2',
            labelcz: "Société civile d'intérêt collectif agricole (SICA)"
        },
        {
            value: 'M1BJ',
            labelcz: 'Société civile de moyens'
        },
        {
            value: 'YX4E',
            labelcz: 'Société civile de placement collectif immobilier (SCPI)'
        },
        {
            value: 'DXQH',
            labelcz: 'Société civile foncière'
        },
        {
            value: 'FY0F',
            labelcz: 'Société civile immobilière'
        },
        {
            value: 'KBEQ',
            labelcz: "Société civile immobilière d' accession progressive à la propriété"
        },
        {
            value: '8R2G',
            labelcz: 'Société civile immobilière de construction-vente'
        },
        {
            value: 'IGSV',
            labelcz: 'Société civile laitière'
        },
        {
            value: 'Q2A1',
            labelcz: 'Société commerciale étrangère immatriculée au RCS'
        },
        {
            value: '211B',
            labelcz: 'Société coopérative agricole'
        },
        {
            value: 'OSLZ',
            labelcz: 'Société coopérative de banque populaire'
        },
        {
            value: 'EAC8',
            labelcz: 'Société coopérative de production de HLM anonyme à directoire'
        },
        {
            value: 'RT39',
            labelcz: 'Société créée de fait avec personne morale'
        },
        {
            value: '1Q16',
            labelcz: 'Société créée de fait entre personnes physiques'
        },
        {
            value: '8VDW',
            labelcz: "Société d'assurance à forme mutuelle"
        },
        {
            value: 'ZXHJ',
            labelcz: "Société d'exercice libéral à forme anonyme à conseil d'administration"
        },
        {
            value: 'QV2O',
            labelcz: "Société d'exercice libéral à forme anonyme à directoire"
        },
        {
            value: 'J9OZ',
            labelcz: "Société d'exercice libéral à responsabilité limitée"
        },
        {
            value: 'GJJJ',
            labelcz: "Société d'exercice libéral à responsabilité limitée à associé unique"
        },
        {
            value: '6KWU',
            labelcz: "Société d'exercice libéral en commandite par actions"
        },
        {
            value: '3FCU',
            labelcz: "Société d'exercice libéral par action simplifiée"
        },
        {
            value: 'UHKH',
            labelcz: 'Société de caution mutuelle'
        },
        {
            value: '6DYI',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)'
        },
        {
            value: 'SMZ6',
            labelcz:
                "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)"
        },
        {
            value: 'JFET',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)'
        },
        {
            value: 'RNJZ',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)'
        },
        {
            value: 'S82R',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)'
        },
        {
            value: 'DEG4',
            labelcz: 'Société en commandite par actions'
        },
        {
            value: 'R59A',
            labelcz: 'Société en commandite par actions coopérative'
        },
        {
            value: 'VD7Z',
            labelcz: 'Société en commandite simple'
        },
        {
            value: 'F0B6',
            labelcz: 'Société en commandite simple coopérative'
        },
        {
            value: 'SOXQ',
            labelcz: 'Société en libre partenariat'
        },
        {
            value: 'H1U2',
            labelcz: 'Société en nom collectif'
        },
        {
            value: 'Q8E2',
            labelcz: 'Société en nom collectif coopérative'
        },
        {
            value: 'XQBA',
            labelcz: 'Société en participation avec personne morale'
        },
        {
            value: 'CNSS',
            labelcz: 'Société en participation de professions libérales'
        },
        {
            value: '9HC8',
            labelcz: 'Société en participation entre personnes physiques'
        },
        {
            value: 'RNSB',
            labelcz: 'Société étrangère non immatriculée au RCS'
        },
        {
            value: 'TPNT',
            labelcz: 'Société européenne'
        },
        {
            value: 'LARO',
            labelcz: 'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle'
        },
        {
            value: 'G8LP',
            labelcz: 'Sociétés Interprofessionnelles de Soins Ambulatoires '
        },
        {
            value: '66JQ',
            labelcz: 'Syndicat de copropriété'
        },
        {
            value: '1GNM',
            labelcz: 'Syndicat de salariés'
        },
        {
            value: 'JIYK',
            labelcz: 'Syndicat inter hospitalier'
        },
        {
            value: 'D2I2',
            labelcz: 'Syndicat intercommunal à vocation multiple (SIVOM)'
        },
        {
            value: 'IAP3',
            labelcz: 'Syndicat intercommunal à vocation unique (SIVU)'
        },
        {
            value: 'OLJ1',
            labelcz: 'Syndicat mixte fermé'
        },
        {
            value: 'ZECH',
            labelcz: 'Syndicat mixte ouvert'
        },
        {
            value: 'KS9B',
            labelcz: 'Syndicat patronal'
        },
        {
            value: '9KU7',
            labelcz: 'Union de sociétés coopératives agricoles'
        }
    ],
    GB: [
        {
            value: '8CF0',
            labelcz: 'Assurance Company'
        },
        {
            value: 'E12O',
            labelcz: 'Building Society'
        },
        {
            value: 'ZZGG',
            labelcz: 'Co-operative Society'
        },
        {
            value: '7VVZ',
            labelcz: 'Co-operative Society (Northern Ireland)'
        },
        {
            value: 'IYXU',
            labelcz: 'Community Benefit Society'
        },
        {
            value: 'UTY8',
            labelcz: 'Community Benefit Society (Northern Ireland)'
        },
        {
            value: '17R0',
            labelcz: 'Community Interest Company'
        },
        {
            value: 'WBQU',
            labelcz: 'Credit Union'
        },
        {
            value: 'JTCO',
            labelcz: 'Credit Union (Northern Ireland)'
        },
        {
            value: '55MA',
            labelcz: 'Cwmni Cyfyngedig Cyhoeddus'
        },
        {
            value: 'T61R',
            labelcz: 'cyfyngedig'
        },
        {
            value: 'BX6Y',
            labelcz: 'Friendly Society'
        },
        {
            value: 'AVYY',
            labelcz: 'Government Entity'
        },
        {
            value: '7T8N',
            labelcz: 'Charitable Incorporated Organisation'
        },
        {
            value: 'FVGZ',
            labelcz: 'Industrial and Provident Society'
        },
        {
            value: 'VV0W',
            labelcz: 'Investment Company with Variable Capital'
        },
        {
            value: 'Z0EY',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'ID30',
            labelcz: 'Limited Partnership'
        },
        {
            value: '4A3J',
            labelcz: 'Northern Ireland Company'
        },
        {
            value: 'ZQ6S',
            labelcz: 'Old Public Company'
        },
        {
            value: '5FRT',
            labelcz: 'Other Type of Company (in Northern Ireland)'
        },
        {
            value: '1W62',
            labelcz: 'Oversea Company'
        },
        {
            value: 'WJ0A',
            labelcz: 'Partneriaeth Atebolrwydd Cyfyngedig'
        },
        {
            value: '4HTX',
            labelcz: 'Private Fund Limited Partnership'
        },
        {
            value: 'HX6D',
            labelcz: 'Private Limited'
        },
        {
            value: '4GJI',
            labelcz: 'Private Limited by Guarantee'
        },
        {
            value: 'TYJK',
            labelcz: 'Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)'
        },
        {
            value: 'C605',
            labelcz: 'Private Limited by Shares (Section 30 Exemption)'
        },
        {
            value: 'H0PO',
            labelcz: 'Private Limited Company'
        },
        {
            value: '57V7',
            labelcz: 'Private Unlimited'
        },
        {
            value: '60IF',
            labelcz: 'Private Unlimited/No Share Capital'
        },
        {
            value: 'TT2H',
            labelcz: 'Protected Cell Company'
        },
        {
            value: 'B6ES',
            labelcz: 'Public Limited Company'
        },
        {
            value: 'XLZV',
            labelcz: 'Registered Society'
        },
        {
            value: '9B78',
            labelcz: 'Royal Charter Company'
        },
        {
            value: 'STX7',
            labelcz: 'Scottish Charitable Incorporated Organisation'
        },
        {
            value: 'NBTW',
            labelcz: 'Scottish Partnership'
        },
        {
            value: 'CDOT',
            labelcz: 'UK Establishment'
        },
        {
            value: 'TRWS',
            labelcz: 'Unincorporated Association'
        },
        {
            value: 'VYF8',
            labelcz: 'United Kingdom Economic Interest Grouping'
        },
        {
            value: '468Q',
            labelcz: 'United Kingdom Societas'
        },
        {
            value: 'A2X8',
            labelcz: 'Unregistered Company'
        },
        {
            value: 'Q0M5',
            labelcz: 'Unregistered Company'
        }
    ],
    GG: [
        {
            value: '9XFK',
            labelcz: 'Foundation'
        },
        {
            value: 'BVOE',
            labelcz: 'Limited Company'
        },
        {
            value: 'Q49K',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'UO3D',
            labelcz: 'Limited Partnership'
        }
    ],
    GH: [
        {
            value: 'T69Z',
            labelcz: 'External Company'
        },
        {
            value: 'WP5I',
            labelcz: 'Partnership'
        },
        {
            value: 'J5RC',
            labelcz: 'Private Limited By Guarantee'
        },
        {
            value: '56NA',
            labelcz: 'Private Limited By Share'
        },
        {
            value: 'I0X7',
            labelcz: 'Private Unlimited By Share'
        },
        {
            value: 'W9ZD',
            labelcz: 'Public Limited By Guarantee'
        },
        {
            value: 'VBJW',
            labelcz: 'Public Limited Company'
        },
        {
            value: 'PH5T',
            labelcz: 'Public Unlimited Company'
        },
        {
            value: '4HD1',
            labelcz: 'Sole Proprietorship'
        },
        {
            value: 'XWPT',
            labelcz: 'Subsidiary Business Name'
        }
    ],
    GI: [
        {
            value: '7U4R',
            labelcz: 'European Economic Interest Groupings'
        },
        {
            value: 'CB98',
            labelcz: 'Foundations'
        },
        {
            value: 'GCCT',
            labelcz: 'Limited Liability Partnerships'
        },
        {
            value: 'Y8CL',
            labelcz: 'Limited Partnerships'
        },
        {
            value: 'QFLH',
            labelcz: 'Private Limited by Guarantee'
        },
        {
            value: 'WBKH',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'TKPE',
            labelcz: 'Private Trust Company'
        },
        {
            value: 'VJRL',
            labelcz: 'Private Unlimited Company'
        },
        {
            value: 'UUYB',
            labelcz: 'Public Limited Company '
        },
        {
            value: 'M4TI',
            labelcz: 'Societe Europeas'
        }
    ],
    GR: [
        {
            value: 'L8D6',
            labelcz: 'Afanis Eteria'
        },
        {
            value: 'W2NK',
            labelcz: 'Anónimi Etería'
        },
        {
            value: 'HKVP',
            labelcz: 'Astiki (Proswpiki) Eteria'
        },
        {
            value: 'H6OR',
            labelcz: 'Etería Periorisménis Euthínis'
        },
        {
            value: '54AL',
            labelcz: 'Eterórithmi Etería'
        },
        {
            value: 'QCA0',
            labelcz: 'Idiotiki kefaleouhiki Eteria'
        },
        {
            value: 'MCWR',
            labelcz: 'Kinopraxia'
        },
        {
            value: 'JYKN',
            labelcz: 'Lipa'
        },
        {
            value: '3RHO',
            labelcz: 'Naftiki eteria'
        },
        {
            value: 'L6IY',
            labelcz: 'Nomika Prosopa Dimosiou Dikeou'
        },
        {
            value: 'TIZ2',
            labelcz: 'Omórithmi Etería'
        },
        {
            value: 'VKSR',
            labelcz: 'Simplioktisia'
        },
        {
            value: 'J3VJ',
            labelcz: 'Sinetairismos'
        },
        {
            value: 'QSYQ',
            labelcz: 'Somatia - Idrimata'
        },
        {
            value: 'UCU5',
            labelcz: 'Εterorrythmi kata metoches etaireia'
        },
        {
            value: 'CQ5X',
            labelcz: 'Εvropaiki Εtaireia'
        },
        {
            value: 'KUQO',
            labelcz: 'Ναυτιλιακή Εταιρεία Πλοίων Αναψυχής'
        }
    ],
    GT: [
        {
            value: 'DLUP',
            labelcz: 'Asociacion civil'
        },
        {
            value: 'XDZ7',
            labelcz: 'Fundacion'
        },
        {
            value: 'KPHM',
            labelcz: 'Organizacion No Gubernamental'
        },
        {
            value: 'XH5R',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'GY0L',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: 'YMB7',
            labelcz: 'Sociedad de Emprendimiento'
        },
        {
            value: 'RK88',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'F0IC',
            labelcz: 'Sociedad en Comandita por Acciones'
        },
        {
            value: 'W9T7',
            labelcz: 'Sociedad en Comandita Simple'
        }
    ],
    HK: [
        {
            value: 'S2E3',
            labelcz: 'Dan bao  you xian gong si'
        },
        {
            value: 'KSUS',
            labelcz: 'fei xiang gang gong si'
        },
        {
            value: 'E1SE',
            labelcz: 'gen ju fa li cheng li de shi ti'
        },
        {
            value: 'EPG7',
            labelcz: 'Gong zhong gu fen  you xian gong si'
        },
        {
            value: '254M',
            labelcz: 'Si ren gu fen you xian gong si'
        },
        {
            value: '2QMJ',
            labelcz: 'Trust'
        },
        {
            value: 'N3VO',
            labelcz: 'You gu ben de gong zhong wu xian gong si'
        },
        {
            value: 'UDG6',
            labelcz: 'You gu ben de si ren wu xian gong si'
        },
        {
            value: 'XPE5',
            labelcz: 'you xian ze ren he huo'
        },
        {
            value: '85VD',
            labelcz: 'zhu ce shou tuo ren'
        }
    ],
    HN: [
        {
            value: 'E7JZ',
            labelcz: 'Comerciante Individual'
        },
        {
            value: 'JUDZ',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'O2M6',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: 'XE7O',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: '6ETM',
            labelcz: 'Sociedad en Comandita por Acciones'
        },
        {
            value: 'RF41',
            labelcz: 'Sociedad en Comandita Simple'
        },
        {
            value: '12F9',
            labelcz: 'Sociedades de Capital Variable'
        }
    ],
    HR: [
        {
            value: '6RD2',
            labelcz: 'Agencije I druge samostalne pravne osobe s javnim ovlastima'
        },
        {
            value: 'LUMA',
            labelcz: 'Dioničko društvo'
        },
        {
            value: 'OQWO',
            labelcz: 'Društvo s ograničenom odgovornošću'
        },
        {
            value: '8VRU',
            labelcz: 'Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)'
        },
        {
            value: 'E9CM',
            labelcz: 'Europsko društvo (Societas Europaea, skraćeno SE)'
        },
        {
            value: '3OW3',
            labelcz: 'Europsko gospodarsko interesno udruženje (skraćeno EGIU)'
        },
        {
            value: '28RA',
            labelcz: 'Fond'
        },
        {
            value: '9PZC',
            labelcz: 'Fundacija'
        },
        {
            value: '2FED',
            labelcz: 'Gospodarsko interesno udruženje'
        },
        {
            value: 'KP34',
            labelcz: 'Javno trgovačko društvo'
        },
        {
            value: 'XQLW',
            labelcz: 'Jedinica lokalne ili područne (regionalne) samouprave'
        },
        {
            value: 'MF7P',
            labelcz: 'Komanditno društvo'
        },
        {
            value: '24EG',
            labelcz: 'Kreditna unija'
        },
        {
            value: 'NRTG',
            labelcz: 'Podružnica'
        },
        {
            value: '6Q6D',
            labelcz: 'Pravna osoba Katoličke Crkve'
        },
        {
            value: 'IVVD',
            labelcz: 'Savez zadruga'
        },
        {
            value: 'EYKU',
            labelcz: 'Stečajna masa'
        },
        {
            value: 'TSA0',
            labelcz: 'Tijelo državne uprave'
        },
        {
            value: '9D9U',
            labelcz: 'Trgovac pojedinac'
        },
        {
            value: '274G',
            labelcz: 'Udruga'
        },
        {
            value: 'ZFQS',
            labelcz: 'Ustanova'
        },
        {
            value: 'SPJ7',
            labelcz: 'Vjerska zajednica'
        },
        {
            value: 'G5RH',
            labelcz: 'Zadruge'
        },
        {
            value: 'YA9S',
            labelcz: 'Zajednica ustanova'
        },
        {
            value: 'ZMY8',
            labelcz: 'Zaklada'
        }
    ],
    HU: [
        {
            value: '8VH3',
            labelcz: 'Befektetési alap'
        },
        {
            value: 'S3DA',
            labelcz: 'Betéti társaság'
        },
        {
            value: 'BMYJ',
            labelcz: 'Egyéb alapítvány'
        },
        {
            value: '876R',
            labelcz: 'Egyéb egyesület'
        },
        {
            value: '4WV7',
            labelcz: 'Egyéb köztestület'
        },
        {
            value: 'DPY1',
            labelcz: 'Egyéb szövetkezet'
        },
        {
            value: '2A44',
            labelcz: 'Egyéni cég'
        },
        {
            value: 'OII5',
            labelcz: 'Egyéni ügyvéd'
        },
        {
            value: 'BJ8Q',
            labelcz: 'Egyéni vállalkozás'
        },
        {
            value: 'LNY0',
            labelcz: 'Egyházi szervezetek'
        },
        {
            value: 'V3LT',
            labelcz: 'Erdőbirtokossági Társulat'
        },
        {
            value: '8UMK',
            labelcz: 'Európai gazdasági egyesülés'
        },
        {
            value: 'XW5U',
            labelcz: 'Európai részvénytársaság'
        },
        {
            value: 'DN6F',
            labelcz: 'Kölcsönös biztosító egyesület'
        },
        {
            value: 'QYV5',
            labelcz: 'Költségvetési szerv'
        },
        {
            value: 'P9F2',
            labelcz: 'Korlátolt felelősségű társaság'
        },
        {
            value: 'HTJD',
            labelcz: 'Közhasznú társaság'
        },
        {
            value: 'ZQAQ',
            labelcz: 'Közjegyzői iroda'
        },
        {
            value: 'J6MO',
            labelcz: 'Közkereseti társaság'
        },
        {
            value: '995K',
            labelcz: 'Magánnyugdíjpénztár'
        },
        {
            value: '2LB5',
            labelcz: 'Munkavállalói Résztulajdonosi Program szervezet'
        },
        {
            value: '8UEG',
            labelcz: 'Nyilvánosan működő részvénytársaság'
        },
        {
            value: 'BSK1',
            labelcz: 'Oktatási intézmények'
        },
        {
            value: 'M1DW',
            labelcz: 'Önkéntes kölcsönös biztosítópénztár'
        },
        {
            value: '4QRE',
            labelcz: 'Önkormányzat'
        },
        {
            value: 'Y64R',
            labelcz: 'Országos betétbiztosítási alap'
        },
        {
            value: 'YOMR',
            labelcz: 'Őstermelők családi gazdasága'
        },
        {
            value: 'EO9F',
            labelcz: 'Részvénytársaság'
        },
        {
            value: 'TSVO',
            labelcz: 'Szövetség (kivéve sportszövetség)'
        },
        {
            value: 'X0SX',
            labelcz: 'Takarék- és hitelszövetkezet'
        },
        {
            value: 'ESTU',
            labelcz: 'Társasház'
        },
        {
            value: '4C5L',
            labelcz: 'Ügyvédi Iroda'
        },
        {
            value: 'BKUX',
            labelcz: 'Zártkörűen működő részvénytársaság'
        }
    ],
    IE: [
        {
            value: 'C58S',
            labelcz: 'Company Limited by Guarantee'
        },
        {
            value: '9BPE',
            labelcz: 'Credit Union'
        },
        {
            value: 'LGWG',
            labelcz: 'Designated Activity Company'
        },
        {
            value: '5AX8',
            labelcz: 'Designated Activity Company Limited by Guarantee'
        },
        {
            value: '363J',
            labelcz: 'European Economic Interest Grouping'
        },
        {
            value: '54SK',
            labelcz: 'Friendly Society'
        },
        {
            value: 'DWS3',
            labelcz: 'General Partnership'
        },
        {
            value: 'ZJS8',
            labelcz: 'Industrial and Provident Society'
        },
        {
            value: 'LZIC',
            labelcz: 'Investment Limited Partnership'
        },
        {
            value: '2GV9',
            labelcz: 'Irish Collective Asset-management Vehicle'
        },
        {
            value: 'LMIM',
            labelcz: 'Limited company'
        },
        {
            value: 'HNJK',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'MNQ7',
            labelcz: 'Private Company Limited by Shares'
        },
        {
            value: 'KMFX',
            labelcz: 'Private Unlimited Company'
        },
        {
            value: 'VYAX',
            labelcz: 'Public Limited Company'
        },
        {
            value: 'URQH',
            labelcz: 'Public Unlimited Company'
        },
        {
            value: 'FF1D',
            labelcz: 'Public Unlimited Company that has no share capital'
        },
        {
            value: 'JXDX',
            labelcz: 'Societas Europaea'
        }
    ],
    IL: [
        {
            value: 'BY2Z',
            labelcz: 'Chevra Tziburit'
        },
        {
            value: 'QZP3',
            labelcz: 'shutafut'
        },
        {
            value: 'PDQC',
            labelcz: 'Osek Murshe'
        },
        {
            value: '328X',
            labelcz: 'Aguda Shitufit'
        },
        {
            value: '5Q1W',
            labelcz: "Chevra Pratit Ba'am"
        },
        {
            value: 'THVZ',
            labelcz: 'havra partit lele hagbala'
        },
        {
            value: '3YIH',
            labelcz: 'Osek Patur'
        }
    ],
    IM: [
        {
            value: 'JHC4',
            labelcz: 'Foundation'
        },
        {
            value: 'FI4M',
            labelcz: 'Industrial and Building Society'
        },
        {
            value: 'SP9F',
            labelcz: 'Limited by Guarantee (2006 Act)'
        },
        {
            value: 'TQ3Z',
            labelcz: 'Limited by Shares (2006 Act)'
        },
        {
            value: 'M44Y',
            labelcz: 'Limited by Shares and by Guarantee (2006 Act)'
        },
        {
            value: 'CDXK',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'TE79',
            labelcz: 'Limited Partnership - with Legal Personality'
        },
        {
            value: 'EMLA',
            labelcz: 'Limited Partnership - without Legal Personality'
        },
        {
            value: 'VC3E',
            labelcz: 'Private Limited by Guarantee and having a Share Capital (1931 Act)'
        },
        {
            value: 'FMPL',
            labelcz: 'Private Limited by Guarantee and not having a Share Capital (1931 Act)'
        },
        {
            value: 'QZTT',
            labelcz: 'Private Limited by shares (1931 Act)'
        },
        {
            value: 'SAI8',
            labelcz: 'Private Unlimited and having a Share Capital (1931 Act)'
        },
        {
            value: 'OESH',
            labelcz: 'Public Limited by Guarantee and having a Share Capital (1931 Act)'
        },
        {
            value: '1G26',
            labelcz: 'Public Limited by Guarantee and not having a Share Capital (1931 Act)'
        },
        {
            value: 'ZGPY',
            labelcz: 'Public Limited by Shares (1931 Act)'
        },
        {
            value: 'G4V6',
            labelcz: 'Public Unlimited and having a Share Capital (1931 Act)'
        },
        {
            value: '5ABK',
            labelcz: 'Unlimited with Shares (2006 Act)'
        },
        {
            value: 'TV5P',
            labelcz: 'Unlimited without Shares (2006 Act)'
        }
    ],
    IN: [
        {
            value: 'HBQK',
            labelcz: 'Alternate Investment Fund - Sub scheme'
        },
        {
            value: 'EX8U',
            labelcz: 'Alternative Investment Fund'
        },
        {
            value: 'XTZG',
            labelcz: 'Banking Company - Nationalised Bank'
        },
        {
            value: 'NBCI',
            labelcz: 'Banking Company - Others'
        },
        {
            value: 'FPZK',
            labelcz: 'Banking Company - Scheduled Urban Cooperative Bank'
        },
        {
            value: 'DW2W',
            labelcz: 'Company Limited by Guarantee'
        },
        {
            value: '2DVA',
            labelcz: 'Cooperative Society'
        },
        {
            value: 'X4IT',
            labelcz: 'Government Company'
        },
        {
            value: '70GJ',
            labelcz: 'Government Organization'
        },
        {
            value: 'FC7L',
            labelcz: 'Housing Finance Company'
        },
        {
            value: 'KJ0B',
            labelcz: 'Insurance Company'
        },
        {
            value: 'U5S6',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'QCSO',
            labelcz: 'Multistate Cooperative Society'
        },
        {
            value: 'U8NM',
            labelcz: 'Mutual Fund'
        },
        {
            value: 'VX5J',
            labelcz: 'Mutual Fund-Sub Scheme'
        },
        {
            value: '9ME5',
            labelcz: 'Non profit company'
        },
        {
            value: 'NFPC',
            labelcz: 'Non-Banking Finance Company'
        },
        {
            value: 'I47Z',
            labelcz: 'One Person Company'
        },
        {
            value: 'A0PS',
            labelcz: 'Partnership Firm'
        },
        {
            value: 'OYDA',
            labelcz: 'Pension Funds'
        },
        {
            value: 'W0G7',
            labelcz: 'Pension Funds-Sub Scheme'
        },
        {
            value: 'YSP9',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'JKJX',
            labelcz: 'Provident fund / Superannuation fund / Gratuity fund / Insurance Fund'
        },
        {
            value: '3VSP',
            labelcz: 'Public Financial Institutions'
        },
        {
            value: 'DDKQ',
            labelcz: 'Public Limited Company'
        },
        {
            value: '4QIE',
            labelcz: 'Sole Proprietorship'
        },
        {
            value: '2Y95',
            labelcz: 'Special Purpose Vehicle - Company'
        },
        {
            value: 'K4OX',
            labelcz: 'Special Purpose Vehicle - Partnership Firm'
        },
        {
            value: '8ZLF',
            labelcz: 'Special Purpose Vehicle - Trust'
        },
        {
            value: 'K361',
            labelcz: 'Special Purpose Vehicle-Coop  / Multistate Coop Society'
        },
        {
            value: '180P',
            labelcz: 'Stand Alone Primary Dealer'
        },
        {
            value: 'W9FI',
            labelcz: 'Trust'
        },
        {
            value: '36YD',
            labelcz: 'Unlimited Company'
        }
    ],
    IS: [
        {
            value: 'M8SS',
            labelcz: 'Einkahlutafélag'
        },
        {
            value: 'CMHQ',
            labelcz: 'Evrópufélag'
        },
        {
            value: 'E4KB',
            labelcz: 'Hlutafélag'
        },
        {
            value: '8T79',
            labelcz: 'Samlagsfélag'
        },
        {
            value: '2OJP',
            labelcz: 'Samlagshlutafélag'
        }
    ],
    IT: [
        {
            value: 'RWZD',
            labelcz: 'Altre Forme'
        },
        {
            value: '1TON',
            labelcz: 'Associazione'
        },
        {
            value: 'WPED',
            labelcz: 'Associazione Impresa'
        },
        {
            value: 'DSSD',
            labelcz: 'Azienda Autonoma Statale'
        },
        {
            value: 'L1ZJ',
            labelcz: 'Azienda Municipale'
        },
        {
            value: 'KXZT',
            labelcz: 'Azienda Speciale'
        },
        {
            value: 'KCHO',
            labelcz: 'Azienda Speciale Di Cui Al Dlgs 267/2000'
        },
        {
            value: 'SSP9',
            labelcz: 'Azienda Speciale Rea'
        },
        {
            value: 'HN75',
            labelcz: 'Consorzio'
        },
        {
            value: '2J7Z',
            labelcz: "Consorzio con attivita' Esterna"
        },
        {
            value: 'X62Z',
            labelcz: 'Consorzio Di Cui Alla Dlgs 267/2000'
        },
        {
            value: 'DCRK',
            labelcz: 'Consorzio Fidi'
        },
        {
            value: 'VDRB',
            labelcz: 'Consorzio Municipale'
        },
        {
            value: 'SBQN',
            labelcz: "Consorzio senza Attivita' Esterna"
        },
        {
            value: 'K021',
            labelcz: "Contratto Di Rete Dotato Di Soggettivita' Giuridica"
        },
        {
            value: 'PHMS',
            labelcz: 'Cooperativa Sociale'
        },
        {
            value: 'K26L',
            labelcz: 'Ente'
        },
        {
            value: '5ODO',
            labelcz: 'Ente Diritto Pubblico'
        },
        {
            value: 'IMHA',
            labelcz: 'Ente Ecclesiastico'
        },
        {
            value: '1RI9',
            labelcz: 'Ente Ecclesiastico Civilmente Riconosciuto'
        },
        {
            value: 'KCSG',
            labelcz: 'Ente Impresa'
        },
        {
            value: 'ARJF',
            labelcz: 'Ente Morale'
        },
        {
            value: 'ZG6S',
            labelcz: 'Ente Pubblico Economico'
        },
        {
            value: '2SZI',
            labelcz: 'Ente Sociale'
        },
        {
            value: '75WC',
            labelcz: 'Fondazione'
        },
        {
            value: '70X0',
            labelcz: 'Fondazione Impresa'
        },
        {
            value: 'OQ8C',
            labelcz: 'Fondo Pensione'
        },
        {
            value: '634M',
            labelcz: 'Gruppo Europeo Di Interesse Economico'
        },
        {
            value: 'LHBB',
            labelcz: 'Impresa Individuale'
        },
        {
            value: 'ADAZ',
            labelcz: 'Istituto Religioso'
        },
        {
            value: 'W9SC',
            labelcz: 'Mutua Assicurazione'
        },
        {
            value: 'ZU9S',
            labelcz: "Piccola Societa' Cooperativa a Responsabilita' Limitata"
        },
        {
            value: 'C1IC',
            labelcz: 'Società Cooperativa Consortile'
        },
        {
            value: 'OV32',
            labelcz: "Societa' A Responsabilita' Limitata"
        },
        {
            value: 'B5TO',
            labelcz: "Societa' a Responsabilita' Limitata con Unico Socio"
        },
        {
            value: '8GU1',
            labelcz: "Societa' A Responsabilita' Limitata Semplificata"
        },
        {
            value: 'BL52',
            labelcz: "Societa' Consortile A Responsabilita' Limitata"
        },
        {
            value: '8AXV',
            labelcz: "Societa' Consortile Cooperativa a Responsabilita' Limitata"
        },
        {
            value: 'WRU2',
            labelcz: "Societa' Consortile in Accomandita Semplice"
        },
        {
            value: 'LZZD',
            labelcz: "Societa' Consortile Per Azioni"
        },
        {
            value: 'QRZJ',
            labelcz: "Societa' Cooperativa"
        },
        {
            value: 'CTNS',
            labelcz: "Societa' Cooperativa a Responsabilita' Limitata"
        },
        {
            value: '9KGS',
            labelcz: "Societa' Cooperativa Europea"
        },
        {
            value: '135L',
            labelcz: "Societa' Costituita In Base A Leggi Di Altro Stato"
        },
        {
            value: 'VA1V',
            labelcz: "Societa' Di Mutuo Soccorso"
        },
        {
            value: 'VUPE',
            labelcz: "Societa' Europea"
        },
        {
            value: 'DLS4',
            labelcz: "Societa' in Accomandita per Azioni"
        },
        {
            value: 'CGSO',
            labelcz: "Societa' in Accomandita Semplice"
        },
        {
            value: 'T2X1',
            labelcz: "Societa' In Nome Collettivo"
        },
        {
            value: 'W2PE',
            labelcz: "Societa' non prevista dalla Legislazione Italiana"
        },
        {
            value: 'P418',
            labelcz: "Societa' Per Azioni"
        },
        {
            value: 'X32V',
            labelcz: "Societa' per Azioni con Socio Unico"
        },
        {
            value: '2XXH',
            labelcz: "Societa' Semplice"
        },
        {
            value: 'ZZOG',
            labelcz: "Societa' Tra Professionisti"
        },
        {
            value: 'H7D4',
            labelcz: 'Soggetto Estero'
        }
    ],
    JE: [
        {
            value: '40A7',
            labelcz: 'Foundation'
        },
        {
            value: '33IP',
            labelcz: 'Incorporated Limited Partnerships'
        },
        {
            value: '7RZH',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'UBWU',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'LO9A',
            labelcz: 'Private Limited by Guarantee'
        },
        {
            value: 'SQXV',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'JOX1',
            labelcz: 'Public Limited Company'
        },
        {
            value: '21F4',
            labelcz: 'Separate Limited Partnerships'
        }
    ],
    JO: [
        {
            value: 'BL60',
            labelcz: 'alsharika almusahama aleama'
        },
        {
            value: 'FZAC',
            labelcz: 'alsharika almusahama alkhasa'
        },
        {
            value: 'SAST',
            labelcz: 'alsharika alty la tahdof litahqiq alribh'
        },
        {
            value: '6B39',
            labelcz: 'alsharika zat almasuwliat almahduda'
        },
        {
            value: '9NBN',
            labelcz: 'sharikat altadamun'
        },
        {
            value: '6KSC',
            labelcz: 'sharikat altawsia albasita'
        },
        {
            value: 'IXQK',
            labelcz: "sharikat altawsia bial'ashum"
        },
        {
            value: '2R82',
            labelcz: 'sharikat raas almal almughamir'
        }
    ],
    JP: [
        {
            value: 'MXMH',
            labelcz: 'gaikokugaisyatou'
        },
        {
            value: '7QQ0',
            labelcz: 'goudougaisya'
        },
        {
            value: 'IUVI',
            labelcz: 'goumeigaisya'
        },
        {
            value: '5MVV',
            labelcz: 'gousigaisya'
        },
        {
            value: '2NRQ',
            labelcz: 'chihokokyoudantai'
        },
        {
            value: 'T417',
            labelcz: 'kabusikigaisya'
        },
        {
            value: 'R4LR',
            labelcz: 'kuninokikan'
        },
        {
            value: 'N3JU',
            labelcz: 'sonotaseturitutoukihouzin'
        },
        {
            value: 'DYQK',
            labelcz: 'yugengaisya'
        }
    ],
    KH: [
        {
            value: 'ZCFU',
            labelcz: 'Foreign Company'
        },
        {
            value: 'Z4YC',
            labelcz: 'General Partnership'
        },
        {
            value: 'D3UY',
            labelcz: 'Limited Partnership'
        },
        {
            value: '15BP',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'BQ0P',
            labelcz: 'Public Limited Company'
        },
        {
            value: 'KD84',
            labelcz: 'Sole Proprietorship'
        }
    ],
    KR: [
        {
            value: 'GF7G',
            labelcz: 'HoeSaHyeong fund'
        },
        {
            value: 'WUJC',
            labelcz: 'JuSikHoeSa'
        },
        {
            value: 'QU16',
            labelcz: 'JoHabHyeong fund'
        },
        {
            value: 'W61J',
            labelcz: 'JaeDanBeobIn'
        },
        {
            value: 'EO0G',
            labelcz: 'HabMyeongHoeSa'
        },
        {
            value: 'VTH4',
            labelcz: 'HabJaHoeSa'
        },
        {
            value: 'UGVB',
            labelcz: 'ByeonAcBoHeom'
        },
        {
            value: 'UDJG',
            labelcz: 'GaeInSaEopJa'
        },
        {
            value: 'J3U5',
            labelcz: 'YuHanHoeSa'
        },
        {
            value: 'P2B9',
            labelcz: 'Ilban beobin jaedan'
        },
        {
            value: 'S1IS',
            labelcz: 'GukGa(JeoungBu)'
        },
        {
            value: 'AKF5',
            labelcz: 'Ilban beobin hyeophoe'
        },
        {
            value: 'AHJG',
            labelcz: 'YuHanChaekImHoeSa'
        },
        {
            value: '5RCH',
            labelcz: 'SinTakHyeong fund'
        },
        {
            value: 'AXEQ',
            labelcz: 'BiYeongRi SaDanBeobIn'
        },
        {
            value: 'BW92',
            labelcz: 'Gita beobin'
        },
        {
            value: '12KO',
            labelcz: 'GongGongDanChe'
        }
    ],
    KY: [
        {
            value: 'SNUK',
            labelcz: 'association'
        },
        {
            value: '4XP8',
            labelcz: 'company limited by guarantee'
        },
        {
            value: 'OSBR',
            labelcz: 'company limited by shares'
        },
        {
            value: 'UE3G',
            labelcz: 'exempt company'
        },
        {
            value: 'T5UM',
            labelcz: 'exempted limited duration company'
        },
        {
            value: '6XB7',
            labelcz: 'exempted limited partnership'
        },
        {
            value: 'K575',
            labelcz: 'foundation company'
        },
        {
            value: 'MPUG',
            labelcz: 'limited liability company'
        },
        {
            value: 'XAQA',
            labelcz: 'limited partnership'
        },
        {
            value: 'MP7S',
            labelcz: 'segregated portfolio company'
        },
        {
            value: 'JDX6',
            labelcz: 'special economic zone company'
        },
        {
            value: '8HR7',
            labelcz: 'unlimited company'
        }
    ],
    LI: [
        {
            value: '7RRP',
            labelcz: 'Aktiengesellschaft'
        },
        {
            value: 'TMU1',
            labelcz: 'Anstalt'
        },
        {
            value: 'GZN4',
            labelcz: 'Anteilsgesellschaft'
        },
        {
            value: '1SOY',
            labelcz: 'Europäische Genossenschaft'
        },
        {
            value: 'WAK8',
            labelcz: 'Europäische Gesellschaft'
        },
        {
            value: 'K98U',
            labelcz: 'Europäische Wirtschaftliche Interessenvereinigung'
        },
        {
            value: 'IF49',
            labelcz: 'Genossenschaft'
        },
        {
            value: 'Y8LH',
            labelcz: 'Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'NDID',
            labelcz: 'Kollektivgesellschaft'
        },
        {
            value: 'TV8Y',
            labelcz: 'Kollektivtreuhänderschaft'
        },
        {
            value: 'ANSR',
            labelcz: 'Kommanditgesellschaft'
        },
        {
            value: 'BSZ8',
            labelcz: 'Stiftung'
        },
        {
            value: '53QF',
            labelcz: 'Treuhänderschaft'
        },
        {
            value: '1DGT',
            labelcz: 'Treuunternehmen'
        },
        {
            value: '32HC',
            labelcz: 'Verein'
        }
    ],
    LS: [
        {
            value: 'S02Y',
            labelcz: 'External Company'
        },
        {
            value: 'CD8F',
            labelcz: 'Non-profit Company'
        },
        {
            value: 'S779',
            labelcz: 'Private Company'
        },
        {
            value: 'K6G7',
            labelcz: 'Public Company'
        }
    ],
    LT: [
        {
            value: '5CIE',
            labelcz: 'Advokatų profesinės bendrijos'
        },
        {
            value: '81KA',
            labelcz: 'Akcinės bendrovės'
        },
        {
            value: 'F2ZF',
            labelcz: 'Asociacijos'
        },
        {
            value: 'SFK9',
            labelcz: 'Bendras valdymo ir pranešimų centras'
        },
        {
            value: 'HJ1Y',
            labelcz: 'Bendrijos'
        },
        {
            value: 'K4GR',
            labelcz: 'Biudžetinės įstaigos'
        },
        {
            value: 'WQRG',
            labelcz: 'Centrinis bankas'
        },
        {
            value: '13T9',
            labelcz: 'Europos bendrovės'
        },
        {
            value: 'BGPJ',
            labelcz: 'Europos ekonominių interesų grupės'
        },
        {
            value: '5BY2',
            labelcz: 'Europos kooperatinės bendrovės'
        },
        {
            value: 'QRXD',
            labelcz: 'Europos teritorinio bendradarbiavimo grupės'
        },
        {
            value: 'A338',
            labelcz: 'Individualios įmonės'
        },
        {
            value: 'LUOA',
            labelcz: 'Komanditinės ūkinės bendrijos'
        },
        {
            value: 'LUGM',
            labelcz: 'Kooperatinės bendrovės (kooperatyvai)'
        },
        {
            value: 'HGMH',
            labelcz: 'Labdaros ir paramos fondai'
        },
        {
            value: 'E4HU',
            labelcz: 'Lietuvos prekybos, pramonės ir amatų rūmų asociacija'
        },
        {
            value: 'SFYA',
            labelcz: 'Mažosios bendrijos'
        },
        {
            value: 'Q8UI',
            labelcz: 'Nuolatinės arbitražo institucijos'
        },
        {
            value: 'X8J8',
            labelcz: 'Politinės partijos'
        },
        {
            value: 'Q4A3',
            labelcz: 'Prekybos, pramonės ir amatų rūmai'
        },
        {
            value: 'NVPY',
            labelcz: 'Privačių detektyvų bendrijos'
        },
        {
            value: '6JDN',
            labelcz: 'Profesinės sąjungos ir jų susivienijimai'
        },
        {
            value: 'A2GC',
            labelcz: 'Religines bendruomenes, bendrijos ir centrai'
        },
        {
            value: 'YRXK',
            labelcz: 'Savivaldybių įmonės'
        },
        {
            value: 'QG9Y',
            labelcz: 'Sodininkų bendrijos'
        },
        {
            value: '5TA8',
            labelcz: 'Šeimynos'
        },
        {
            value: 'DLCX',
            labelcz: 'Tikrosios ūkinės bendrijos'
        },
        {
            value: 'F2TQ',
            labelcz: 'Tradicinės religinės bendruomenės ar bendrijos'
        },
        {
            value: 'BPLS',
            labelcz: 'Uždarosios akcinės bendrovės'
        },
        {
            value: '4ZF3',
            labelcz: 'Valstybės įmonės'
        },
        {
            value: 'KWBA',
            labelcz: 'Viešosios įstaigos'
        },
        {
            value: 'UHNL',
            labelcz: 'Žemės ūkio bendrovės'
        }
    ],
    LU: [
        {
            value: '68J6',
            labelcz: 'Association agricole'
        },
        {
            value: 'BKAB',
            labelcz: "Association d'assurances mutuelles"
        },
        {
            value: '2S2U',
            labelcz: "Association d'épargne pension"
        },
        {
            value: '2JEI',
            labelcz: 'Association sans but lucratif'
        },
        {
            value: 'JIWD',
            labelcz:
                "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises"
        },
        {
            value: '2IGL',
            labelcz: 'Entreprise individuelle'
        },
        {
            value: 'ZFFA',
            labelcz: 'Etablissement public'
        },
        {
            value: 'AIR5',
            labelcz: 'Fond commun de placement'
        },
        {
            value: 'V19Y',
            labelcz: 'Fondation'
        },
        {
            value: 'LCR0',
            labelcz: "Groupement d'intérêt économique"
        },
        {
            value: 'V7QY',
            labelcz: 'Groupement européen d’intérêt économique'
        },
        {
            value: '7SIZ',
            labelcz: 'Mutuelle'
        },
        {
            value: 'FG84',
            labelcz: 'Societas Cooperativa Europaea'
        },
        {
            value: 'DVXS',
            labelcz: 'Société à responsabilité limitée'
        },
        {
            value: 'EUT4',
            labelcz: 'Société à responsabilité limitée simplifiée'
        },
        {
            value: '5GGB',
            labelcz: 'Société anonyme'
        },
        {
            value: 'SQ1A',
            labelcz: 'Société civile'
        },
        {
            value: 'V5OS',
            labelcz: 'Société coopérative'
        },
        {
            value: 'STBC',
            labelcz: 'Société coopérative organisée sous forme de société anonyme'
        },
        {
            value: '9C91',
            labelcz: 'Société d’épargne-pension à capital variable'
        },
        {
            value: 'BEAN',
            labelcz: "Société d'investissement à capital fixe"
        },
        {
            value: 'UDY2',
            labelcz: "Société d'investissement à capital variable"
        },
        {
            value: '81G5',
            labelcz: 'Société en commandite par actions'
        },
        {
            value: '63P9',
            labelcz: 'Société en commandite simple'
        },
        {
            value: 'U8KA',
            labelcz: 'Société en commandite spéciale'
        },
        {
            value: 'ATQY',
            labelcz: 'Société en nom collectif'
        },
        {
            value: 'WCEP',
            labelcz: 'société européenne'
        },
        {
            value: 'HHR4',
            labelcz: 'Société par actions simplifiée'
        }
    ],
    LV: [
        {
            value: 'VJBO',
            labelcz: 'Akciju sabiedrība'
        },
        {
            value: '5ULL',
            labelcz: 'Eiropas Ekonomisko interešu grupa'
        },
        {
            value: 'AZTM',
            labelcz: 'Eiropas komercsabiedrība'
        },
        {
            value: 'BS22',
            labelcz: 'Individuālais komersants'
        },
        {
            value: '1IPK',
            labelcz: 'Komandītsabiedrība'
        },
        {
            value: '3LCY',
            labelcz: 'Pilnsabiedrība'
        },
        {
            value: 'ES2D',
            labelcz: 'Sabiedrība ar ierobežotu atbildību'
        }
    ],
    MC: [
        {
            value: 'KPG6',
            labelcz: 'Association'
        },
        {
            value: 'PIL2',
            labelcz: 'Société en Commandite par Actions'
        },
        {
            value: 'TFXK',
            labelcz: 'Société Unipersonelle à Responsabilité Limitée'
        }
    ],
    MH: [
        {
            value: 'DSII',
            labelcz: 'Corporation'
        },
        {
            value: 'EZL8',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'S69C',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'UW1C',
            labelcz: 'Partnership'
        }
    ],
    MK: [
        {
            value: 'DTIU',
            labelcz: 'Akcionersko drustvo'
        },
        {
            value: 'KHAB',
            labelcz: 'Drustvo so ogranicena odgvornost'
        },
        {
            value: 'HEXO',
            labelcz: 'Javno trgovsko pretprijatie'
        },
        {
            value: 'XH7Z',
            labelcz: 'Komanditno drustvo'
        },
        {
            value: '149O',
            labelcz: 'Komanditno drustvo so akcii'
        },
        {
            value: 'KXDY',
            labelcz: 'Podruznica na stransko trgovsko drustvo, odnosno na stranski trgovec poedinec'
        },
        {
            value: 'JCK1',
            labelcz: 'Stopanska interesna zaednica'
        },
        {
            value: 'VPFY',
            labelcz: 'Trgovec poedinec'
        }
    ],
    MT: [
        {
            value: 'J4S1',
            labelcz: 'association'
        },
        {
            value: 'F5X7',
            labelcz: 'cooperative'
        },
        {
            value: 'CR7N',
            labelcz: 'European Company'
        },
        {
            value: 'YB0U',
            labelcz: 'European Economic Interest Grouping'
        },
        {
            value: '3U3Y',
            labelcz: 'foundation'
        },
        {
            value: '9QHJ',
            labelcz: 'government entity'
        },
        {
            value: 'BVJ0',
            labelcz: 'Partnership en commendite or limited partnership'
        },
        {
            value: 'JOZN',
            labelcz: 'Partnership en nom collectif'
        },
        {
            value: 'V89C',
            labelcz: 'Private Limited Liability Company'
        },
        {
            value: 'C061',
            labelcz: 'Public Limited Liability Company'
        },
        {
            value: 'DJ2D',
            labelcz: 'sole trader'
        }
    ],
    MU: [
        {
            value: 'ZTUI',
            labelcz: 'Associations'
        },
        {
            value: '4AJY',
            labelcz: 'Business'
        },
        {
            value: 'BVPF',
            labelcz: 'Cooperatives'
        },
        {
            value: 'JWWT',
            labelcz: 'Foundations'
        },
        {
            value: 'RTVE',
            labelcz: 'Limited Liability Partnerships'
        },
        {
            value: 'J76S',
            labelcz: 'Limited Partnerships'
        },
        {
            value: 'B0LD',
            labelcz: 'Ministries And Parastal Bodies'
        },
        {
            value: 'S2J1',
            labelcz: 'Others'
        },
        {
            value: 'G7H0',
            labelcz: 'Private Companies'
        },
        {
            value: 'AOS4',
            labelcz: 'Private Companies Limited By Guarantee'
        },
        {
            value: 'XXCZ',
            labelcz: 'Public Companies'
        },
        {
            value: '6M6Z',
            labelcz: 'Public Companies Limited By Guarantee'
        },
        {
            value: 'O786',
            labelcz: 'Société'
        },
        {
            value: 'RJYT',
            labelcz: 'Trade Unions'
        }
    ],
    MX: [
        {
            value: 'JRAQ',
            labelcz: 'Agrupaciones financieras'
        },
        {
            value: '5AWU',
            labelcz: 'Asociación civil'
        },
        {
            value: 'X9J8',
            labelcz: 'Asociación ganadera local especializada'
        },
        {
            value: 'CU5R',
            labelcz: 'Asociación ganadera local general'
        },
        {
            value: 'NA09',
            labelcz: 'Asociación religiosa'
        },
        {
            value: 'C4Z4',
            labelcz: 'Asociación rural de interés colectivo'
        },
        {
            value: '2NAI',
            labelcz: 'Comunidad'
        },
        {
            value: 'PG49',
            labelcz: 'Confederación de sindicatos'
        },
        {
            value: 'RCJS',
            labelcz: 'Corporaciones de carácter público reconocidos por la legislación mexicana'
        },
        {
            value: 'MB35',
            labelcz: 'Ejido'
        },
        {
            value: 'W9WS',
            labelcz: 'Empresa productiva del estado'
        },
        {
            value: 'VIOQ',
            labelcz: 'Estado'
        },
        {
            value: 'ANXC',
            labelcz: 'Federación de sindicatos'
        },
        {
            value: 'YRI0',
            labelcz: 'Fideicomiso público de fomento económico'
        },
        {
            value: 'F3L5',
            labelcz: 'Fondos de Aseguramiento Agropecuario y Rural'
        },
        {
            value: 'MAM6',
            labelcz: 'Institución de asistencia privada'
        },
        {
            value: 'U901',
            labelcz: 'Instituciones de Seguros'
        },
        {
            value: 'M0SL',
            labelcz: 'Municipio'
        },
        {
            value: 'COVJ',
            labelcz: 'Organismo de integración financiera rural'
        },
        {
            value: '31N9',
            labelcz: 'Partido político'
        },
        {
            value: 'JZ1I',
            labelcz: 'Sindicato'
        },
        {
            value: 'B8CE',
            labelcz: 'Sociedad anónima'
        },
        {
            value: 'DBU3',
            labelcz: 'Sociedad anónima  de capital variable, financiera comunitaria'
        },
        {
            value: 'LBPW',
            labelcz: 'Sociedad anónima  de capital variable, financiera popular'
        },
        {
            value: 'GW1T',
            labelcz: 'Sociedad anónima bursátil'
        },
        {
            value: 'L9JC',
            labelcz: 'Sociedad anónima bursátil de capital variable'
        },
        {
            value: 'QZB4',
            labelcz: 'Sociedad anónima bursátil de capital variable, bolsa de valores'
        },
        {
            value: '5K70',
            labelcz: 'Sociedad anónima bursátil de capital variable, casa de bolsa'
        },
        {
            value: 'TYW0',
            labelcz: 'Sociedad anónima bursátil de capital variable, sociedad controladora'
        },
        {
            value: 'TTIF',
            labelcz:
                'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'RQDD',
            labelcz: 'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'JGV1',
            labelcz: 'Sociedad anónima de capital variable'
        },
        {
            value: 'GNNT',
            labelcz: 'Sociedad anónima de capital variable, administradora de fondos para el retiro'
        },
        {
            value: 'Q7WY',
            labelcz:
                'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito'
        },
        {
            value: 'R8PY',
            labelcz: 'Sociedad anónima de capital variable, bolsa de valores'
        },
        {
            value: 'QM7Z',
            labelcz: 'Sociedad anónima de capital variable, casa de bolsa'
        },
        {
            value: 'O15R',
            labelcz: 'Sociedad anónima de capital variable, casa de cambio'
        },
        {
            value: 'M44Q',
            labelcz: 'Sociedad anónima de capital variable, centro cambiario'
        },
        {
            value: 'G73Q',
            labelcz: 'Sociedad anónima de capital variable, contraparte central de valores'
        },
        {
            value: 'EHWD',
            labelcz: 'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro'
        },
        {
            value: 'NHBK',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de capitales'
        },
        {
            value: 'H725',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de objeto limitado'
        },
        {
            value: 'RCE0',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de renta variable'
        },
        {
            value: 'UBV0',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda'
        },
        {
            value: 'U77P',
            labelcz: 'Sociedad anónima de capital variable, institución de fianzas'
        },
        {
            value: 'IWNQ',
            labelcz: 'Sociedad anónima de capital variable, institución de financiamiento colectivo'
        },
        {
            value: 'N124',
            labelcz: 'Sociedad anónima de capital variable, institución de fondos de pago electrónico'
        },
        {
            value: '2LNV',
            labelcz: 'Sociedad anónima de capital variable, institución de seguros'
        },
        {
            value: 'ICXT',
            labelcz: 'Sociedad anónima de capital variable, institución para el depósito de valores'
        },
        {
            value: 'G3JV',
            labelcz: 'Sociedad anónima de capital variable, operadora de fondos de inversión'
        },
        {
            value: '784B',
            labelcz: 'Sociedad anónima de capital variable, sociedad controladora'
        },
        {
            value: '23XJ',
            labelcz: 'Sociedad anónima de capital variable, sociedad de información crediticia'
        },
        {
            value: 'HKWO',
            labelcz: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'P28E',
            labelcz: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'B3WQ',
            labelcz: 'Sociedad anónima de capital variable, unión de crédito'
        },
        {
            value: '8MY7',
            labelcz: 'Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión'
        },
        {
            value: 'DHY2',
            labelcz: 'Sociedad anónima financiera comunitaria'
        },
        {
            value: 'XSZY',
            labelcz: 'Sociedad anónima financiera popular'
        },
        {
            value: 'P8D7',
            labelcz: 'Sociedad anónima institución de banca múltiple'
        },
        {
            value: 'P7VS',
            labelcz: 'Sociedad anónima institución de fianzas'
        },
        {
            value: 'S8DM',
            labelcz: 'Sociedad anónima institución de seguros'
        },
        {
            value: 'TPJZ',
            labelcz: 'Sociedad anónima promotora de inversión'
        },
        {
            value: 'OZ3O',
            labelcz: 'Sociedad anónima promotora de inversión bursátil'
        },
        {
            value: 'RR3L',
            labelcz: 'Sociedad anónima promotora de inversión bursátil de capital variable'
        },
        {
            value: 'VATV',
            labelcz: 'Sociedad anónima promotora de inversión de capital variable'
        },
        {
            value: '2RVP',
            labelcz:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'GXBE',
            labelcz:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'LVRX',
            labelcz: 'Sociedad anónima, almacén general de depósito, organización auxiliar del crédito'
        },
        {
            value: 'N0JF',
            labelcz: 'Sociedad anónima, bolsa de valores'
        },
        {
            value: 'BFIV',
            labelcz: 'Sociedad anónima, casa de cambio'
        },
        {
            value: 'CAF9',
            labelcz: 'Sociedad anónima, centro cambiario'
        },
        {
            value: 'RKLI',
            labelcz: 'Sociedad anónima, sociedad de información crediticia'
        },
        {
            value: 'DNF1',
            labelcz: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: '8ZUV',
            labelcz: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: '7H63',
            labelcz: 'Sociedad civil'
        },
        {
            value: '96OC',
            labelcz: 'Sociedad cooperativa'
        },
        {
            value: '8RRB',
            labelcz: 'Sociedad cooperativa de ahorro y préstamo'
        },
        {
            value: '4HBI',
            labelcz: 'Sociedad cooperativa de ahorro y préstamo de capital variable'
        },
        {
            value: 'JN6Y',
            labelcz: 'Sociedad cooperativa de capital variable'
        },
        {
            value: 'G522',
            labelcz: 'Sociedad cooperativa de consumidores de bienes y/o servicios'
        },
        {
            value: 'DU8H',
            labelcz: 'Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable'
        },
        {
            value: 'VN3F',
            labelcz: 'Sociedad cooperativa de productores de bienes y/o servicios'
        },
        {
            value: '8M3D',
            labelcz: 'Sociedad cooperativa de productores de bienes y/o servicios de capital variable'
        },
        {
            value: '8QZA',
            labelcz: 'Sociedad cooperativa de responsabilidad limitada de capital variable'
        },
        {
            value: 'XDGC',
            labelcz: 'Sociedad cooperativa limitada'
        },
        {
            value: 'CU68',
            labelcz: 'Sociedad cooperativa limitada de capital variable'
        },
        {
            value: '776G',
            labelcz: 'Sociedad de producción rural de responsabilidad ilimitada'
        },
        {
            value: 'QAUY',
            labelcz: 'Sociedad de producción rural de responsabilidad limitada'
        },
        {
            value: '761Z',
            labelcz: 'Sociedad de producción rural de responsabilidad limitada de capital variable'
        },
        {
            value: 'E0YZ',
            labelcz: 'Sociedad de producción rural de responsabilidad suplementada'
        },
        {
            value: '449I',
            labelcz: 'Sociedad de responsabilidad limitada'
        },
        {
            value: 'XLVZ',
            labelcz: 'Sociedad de responsabilidad limitada de capital variable'
        },
        {
            value: 'L2MQ',
            labelcz: 'Sociedad de responsabilidad limitada de interés público de capital variable'
        },
        {
            value: '3WVI',
            labelcz: 'Sociedad de Responsabilidad Limitada Microindustrial'
        },
        {
            value: 'JSTL',
            labelcz: 'Sociedad de solidaridad social'
        },
        {
            value: 'A2A8',
            labelcz: 'Sociedad en comandita por acciones'
        },
        {
            value: 'ZXVG',
            labelcz: 'Sociedad en comandita por acciones de capital variable'
        },
        {
            value: 'XEN5',
            labelcz: 'Sociedad en comandita simple'
        },
        {
            value: '7PKK',
            labelcz: 'Sociedad en comandita simple de capital variable'
        },
        {
            value: 'BOF1',
            labelcz: 'Sociedad en nombre colectivo'
        },
        {
            value: 'ZAIS',
            labelcz: 'Sociedad en nombre colectivo de capital variable'
        },
        {
            value: 'SKO4',
            labelcz: 'Sociedad mutualista'
        },
        {
            value: '7G15',
            labelcz: 'Sociedad Nacional de Crédito'
        },
        {
            value: 'S6M8',
            labelcz: 'Sociedad nacional de crédito institución de banca de desarrollo'
        },
        {
            value: 'LJTR',
            labelcz: 'Sociedad por acciones simplificada'
        },
        {
            value: '6EYT',
            labelcz: 'Sociedad por acciones simplificada de capital variable'
        },
        {
            value: 'LOB9',
            labelcz: 'Sociedad propietaria de tierras agrícolas, ganaderas o forestales'
        },
        {
            value: 'NSZI',
            labelcz: 'Unidad agrícola industrial de la mujer'
        },
        {
            value: 'AOKU',
            labelcz: 'Unión de ejidos'
        },
        {
            value: 'FVTS',
            labelcz: 'Unión de sociedades de producción rural'
        },
        {
            value: '7L83',
            labelcz: 'Unión ganadera regional especializada'
        },
        {
            value: '8AGD',
            labelcz: 'Unión ganadera regional general'
        }
    ],
    MY: [
        {
            value: '7OYN',
            labelcz: 'Berhad'
        },
        {
            value: 'JH78',
            labelcz: 'Labuan Company (Limited By Guarantee)'
        },
        {
            value: 'ZWYK',
            labelcz: 'Labuan Company (Limited By Share)'
        },
        {
            value: 'P0LR',
            labelcz: 'Labuan Company (Unlimited)'
        },
        {
            value: 'NO8C',
            labelcz: 'Labuan Foreign Company'
        },
        {
            value: 'SP0A',
            labelcz: 'Labuan Foundation'
        },
        {
            value: 'T5HS',
            labelcz: 'Labuan Isalmic Trust'
        },
        {
            value: 'PWX8',
            labelcz: 'Labuan Islamic Foundation'
        },
        {
            value: '95AW',
            labelcz: 'Labuan Islamic Charitable Trust'
        },
        {
            value: 'OO14',
            labelcz: 'Labuan Islamic Limited Liability Partnership'
        },
        {
            value: '2SPI',
            labelcz: 'Labuan Islamic Limited Partnership'
        },
        {
            value: 'LA66',
            labelcz: 'Labuan Islamic Other Trust'
        },
        {
            value: 'TGWE',
            labelcz: 'Labuan Islamic Purpose Trust'
        },
        {
            value: 'MEHL',
            labelcz: 'Labuan Islamic Recognized Limited Liability Partnership'
        },
        {
            value: 'NY3P',
            labelcz: 'Labuan Islamic Special Trust'
        },
        {
            value: 'T635',
            labelcz: 'Labuan Islamic Spendthrift/Protective Trust'
        },
        {
            value: 'P0TZ',
            labelcz: 'Labuan Limited Liability Partnerships'
        },
        {
            value: '6HT0',
            labelcz: 'Labuan Limited Partnership'
        },
        {
            value: 'S7R4',
            labelcz: 'Labuan Pre-Incorporated Company'
        },
        {
            value: 'QOO6',
            labelcz: 'Labuan Protected Cell Company'
        },
        {
            value: 'TXCW',
            labelcz: 'Labuan Recognized Limited Liability Partnership'
        },
        {
            value: 'PBQH',
            labelcz: 'Labuan Trust'
        },
        {
            value: 'SP51',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'COZR',
            labelcz: 'Partnership'
        },
        {
            value: 'XEOV',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'QAEW',
            labelcz: 'Society / Association'
        },
        {
            value: 'SV3F',
            labelcz: 'Sole Proprietorship'
        },
        {
            value: 'FRUF',
            labelcz: 'Unlimited Company'
        }
    ],
    NE: [
        {
            value: 'D1IZ',
            labelcz: 'Coopérative'
        },
        {
            value: 'T5MB',
            labelcz: 'Entreprise individuelle'
        },
        {
            value: '2L5O',
            labelcz: "Groupement d'intérêt économique"
        },
        {
            value: 'BNYZ',
            labelcz: 'Organisme mutualiste ou mutuel'
        },
        {
            value: '2GEJ',
            labelcz: 'Société à Responsabilité Limitée'
        },
        {
            value: '9BQH',
            labelcz: 'Société Anonyme'
        },
        {
            value: 'USJP',
            labelcz: 'Société Anonyme à participation publique'
        },
        {
            value: 'RCGI',
            labelcz: 'Société Anonyme Unipersonnelle'
        },
        {
            value: 'Z89H',
            labelcz: 'Société en Commandite par actions'
        },
        {
            value: 'ZOSP',
            labelcz: 'Société en Commandite simple'
        },
        {
            value: 'T3NK',
            labelcz: 'Société en Nom Collectif'
        },
        {
            value: 'VAPL',
            labelcz: 'Société en Participations'
        },
        {
            value: 'CIUP',
            labelcz: 'Société multinationale'
        },
        {
            value: 'EQ7L',
            labelcz: 'Société par Actions Simplifiée'
        },
        {
            value: 'OAPE',
            labelcz: 'Société unipersonnelle à responsabilité limitée'
        }
    ],
    NG: [
        {
            value: 'RIYP',
            labelcz: 'Company limited by guarantee'
        },
        {
            value: 'MT4X',
            labelcz: 'Limited liability partnership'
        },
        {
            value: 'LOJL',
            labelcz: 'Limited partnership'
        },
        {
            value: 'FHZY',
            labelcz: 'Private company limited by shares'
        },
        {
            value: 'PKBG',
            labelcz: 'Public company limited by shares'
        },
        {
            value: 'RG0W',
            labelcz: 'Unlimited company'
        }
    ],
    NL: [
        {
            value: '54M6',
            labelcz: 'besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'CODH',
            labelcz: 'commanditaire vennootschap'
        },
        {
            value: 'NFFH',
            labelcz: 'coöperatie'
        },
        {
            value: '4QXM',
            labelcz: 'eenmanszaak'
        },
        {
            value: '5WU6',
            labelcz: 'Europees Economisch Samenwerkingsverband'
        },
        {
            value: 'BBEB',
            labelcz: 'Europese naamloze vennootschap (Societas Europaea)'
        },
        {
            value: 'JHK5',
            labelcz: 'fonds voor gemene rekening'
        },
        {
            value: 'L7HX',
            labelcz: 'kerkgenootschap'
        },
        {
            value: '9AAK',
            labelcz: 'maatschap'
        },
        {
            value: 'B5PM',
            labelcz: 'naamloze vennootschap'
        },
        {
            value: 'DEO1',
            labelcz: 'onderlinge waarborgmaatschappij'
        },
        {
            value: 'M1IZ',
            labelcz: 'Overige Privaatrechtelijke Rechtspersoon'
        },
        {
            value: 'A0W7',
            labelcz: 'publiekrechtelijke rechtspersoon'
        },
        {
            value: 'UNJ2',
            labelcz: 'rederij'
        },
        {
            value: 'EZQW',
            labelcz: 'rechtspersoon in oprichting'
        },
        {
            value: 'Y3ZB',
            labelcz: 'Societas Cooperativa Europaea'
        },
        {
            value: 'V44D',
            labelcz: 'stichting'
        },
        {
            value: '62Y3',
            labelcz: 'vennootschap onder firma'
        },
        {
            value: '33MN',
            labelcz: 'vereniging'
        },
        {
            value: '8VFX',
            labelcz: 'vereniging met beperkte rechtsbevoegdheid'
        },
        {
            value: 'GNXT',
            labelcz: 'vereniging van eigenaars'
        }
    ],
    NO: [
        {
            value: 'YI42',
            labelcz: 'Aksjeselskap'
        },
        {
            value: 'IQGE',
            labelcz: 'Allmennaksjeselskap'
        },
        {
            value: 'GYY6',
            labelcz: 'Annen juridisk person'
        },
        {
            value: '326Y',
            labelcz: 'Ansvarlig selskap'
        },
        {
            value: 'CF5L',
            labelcz: 'Ansvarlig selskap, delt ansvar'
        },
        {
            value: '9DI1',
            labelcz: 'Boligbyggelag'
        },
        {
            value: 'O0EU',
            labelcz: 'Borettslag'
        },
        {
            value: 'ZQ0Q',
            labelcz: 'Eierseksjonssameie'
        },
        {
            value: 'EXD7',
            labelcz: 'Enkeltpersonforetak'
        },
        {
            value: 'DRPL',
            labelcz: 'Europeisk økonomisk foretaksgruppe'
        },
        {
            value: 'O7LB',
            labelcz: 'Europeisk samvirkeforetak'
        },
        {
            value: 'V06W',
            labelcz: 'Europeisk selskap'
        },
        {
            value: 'FSBD',
            labelcz: 'Forening/lag/innretning (eller bare forening?)'
        },
        {
            value: '5ZTZ',
            labelcz: 'Fylkeskommunalt foretak'
        },
        {
            value: '8S9H',
            labelcz: 'Gjensidig forsikringsselskap'
        },
        {
            value: 'YTMC',
            labelcz: 'Interkommunalt selskap'
        },
        {
            value: 'M9IQ',
            labelcz: 'Kommandittselskap'
        },
        {
            value: '3L58',
            labelcz: 'Kommunalt foretak'
        },
        {
            value: '5V5S',
            labelcz: 'Kommune'
        },
        {
            value: 'PB3V',
            labelcz: 'Konkursbo'
        },
        {
            value: '4ZRR',
            labelcz: 'Norskregistrert utenlandsk foretak'
        },
        {
            value: 'AEV1',
            labelcz: 'Partrederi'
        },
        {
            value: 'BJ65',
            labelcz: 'Pensjonskasse'
        },
        {
            value: 'K5P8',
            labelcz: 'Samvirkeforetak'
        },
        {
            value: 'Q0Q1',
            labelcz: 'Selskap med begrenset ansvar'
        },
        {
            value: 'R71C',
            labelcz: 'Sparebank'
        },
        {
            value: '50TD',
            labelcz: 'Statsforetak'
        },
        {
            value: '3C7U',
            labelcz: 'Stiftelse'
        },
        {
            value: 'LJJW',
            labelcz: 'Verdipapirfond'
        }
    ],

    NP: [
        {
            value: '7PC4',
            labelcz: 'sajhedari farm '
        },
        {
            value: 'MTLX',
            labelcz: 'pablik kampani'
        },
        {
            value: 'VRSU',
            labelcz: 'sajhedari'
        },
        {
            value: 'UZLR',
            labelcz: 'sahakaari sanstha '
        },
        {
            value: 'L4HR',
            labelcz: 'praaibhet kampani'
        },
        {
            value: 'EM3H',
            labelcz: 'sansthaan '
        },
        {
            value: '4EWZ',
            labelcz: 'praibhet farm'
        }
    ],
    NZ: [
        {
            value: 'HX4T',
            labelcz: 'Building society'
        },
        {
            value: 'Z6ZU',
            labelcz: 'Cooperative Company'
        },
        {
            value: 'I8Z8',
            labelcz: 'Credit union'
        },
        {
            value: 'RVWS',
            labelcz: 'Friendly society'
        },
        {
            value: 'TF8L',
            labelcz: 'Charitable Trust'
        },
        {
            value: '3EPR',
            labelcz: 'Incorporated Society'
        },
        {
            value: 'LFSO',
            labelcz: 'Industrial and provident society'
        },
        {
            value: 'P2R9',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'F7KI',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'FCAN',
            labelcz: 'Māori Incorporation'
        },
        {
            value: 'WEIB',
            labelcz: 'Partnership'
        },
        {
            value: 'QF8K',
            labelcz: 'Sole Trader'
        },
        {
            value: '4LEA',
            labelcz: 'Unlimited Liability Company'
        }
    ],
    OM: [
        {
            value: 'EZG2',
            labelcz: 'sharikat almusahamat eamatan'
        },
        {
            value: 'CJO4',
            labelcz: 'alsharikat mahdudat almaswuwlia'
        },
        {
            value: 'LNLA',
            labelcz: 'alsharikat alqabida'
        },
        {
            value: 'SV6U',
            labelcz: 'sharikat alshakhs alwahid'
        },
        {
            value: 'HA2W',
            labelcz: 'sharikat altadamun'
        },
        {
            value: '4H8O',
            labelcz: 'sharikat almusahamat muqfala'
        },
        {
            value: 'NG11',
            labelcz: 'sharikat altawsia'
        },
        {
            value: 'Z9KU',
            labelcz: 'sharikat muhasa'
        }
    ],
    PA: [
        {
            value: 'BSN7',
            labelcz: 'Asociación'
        },
        {
            value: 'NFYA',
            labelcz: 'Consorcio'
        },
        {
            value: 'UNCO',
            labelcz: 'Fundación de Interés Privado'
        },
        {
            value: 'VIMA',
            labelcz: 'Micro-empresa de Responsabilidad Limitada'
        },
        {
            value: '6TPA',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'GDT9',
            labelcz: 'Sociedad Civil'
        },
        {
            value: 'JS13',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'PY5Y',
            labelcz: 'Sociedad en Comandita por acciones'
        },
        {
            value: 'V5VG',
            labelcz: 'Sociedad en Comandita simple'
        }
    ],
    PE: [
        {
            value: 'P53M',
            labelcz: 'Cooperativas'
        },
        {
            value: 'H8G2',
            labelcz: 'Empresa Individual de Responsabilidad Limitada'
        },
        {
            value: '4LCX',
            labelcz: 'Empresas de Derecho Público'
        },
        {
            value: 'AABQ',
            labelcz: 'Empresas Multicomunales'
        },
        {
            value: 'I695',
            labelcz: 'Socieda Anónima'
        },
        {
            value: 'PKRY',
            labelcz: 'Socieda Anónima Abierta'
        },
        {
            value: 'CHX6',
            labelcz: 'Sociedad Anónima Cerrada'
        },
        {
            value: 'QQWG',
            labelcz: 'Sociedad Civil'
        },
        {
            value: '649C',
            labelcz: 'Sociedad Civil de Responsabilidad Limitada'
        },
        {
            value: '3LHF',
            labelcz: 'Sociedad Colectiva'
        },
        {
            value: '73C0',
            labelcz: 'Sociedad Comercial de Responsabilidad Limitada'
        },
        {
            value: '1MQ6',
            labelcz: 'Sociedad en Comandita por Acciones'
        },
        {
            value: 'RFJT',
            labelcz: 'Sociedad en Comandita Simple'
        },
        {
            value: 'YMBC',
            labelcz: 'Sociedad legal'
        },
        {
            value: '37G2',
            labelcz: 'Sociedad por Acciones Cerrada Simplificada'
        }
    ],
    PG: [
        {
            value: 'WHCV',
            labelcz: 'Foreign Enterprise'
        },
        {
            value: '6UED',
            labelcz: 'Local Company'
        },
        {
            value: 'ZE1G',
            labelcz: 'Overseas Company'
        }
    ],
    PK: [
        {
            value: '7IYW',
            labelcz: 'Company Limited by Guarantee( having share capital)'
        },
        {
            value: 'QR25',
            labelcz: 'Company Limited by Guarantee( without share capital)'
        },
        {
            value: 'XBK3',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '4XMS',
            labelcz: 'Private Limited Company(multi member)'
        },
        {
            value: '88OX',
            labelcz: 'Private Limited Company(Single member)'
        },
        {
            value: 'VQV6',
            labelcz: 'Public Limited Company (listed)'
        },
        {
            value: 'MOI8',
            labelcz: 'Public Limited Company(not-for profit association)'
        },
        {
            value: 'RKYF',
            labelcz: 'Public Limited Company(unlisted)'
        },
        {
            value: 'LH0Q',
            labelcz: 'Unlimited Company'
        }
    ],
    PL: [
        {
            value: '5F76',
            labelcz: 'cechy i izby rzemieślnicze, izby gospodarcze'
        },
        {
            value: '85PM',
            labelcz: 'Europejskie Zgrupowanie Interesów Gospodarczych'
        },
        {
            value: '96XK',
            labelcz: 'fundacja'
        },
        {
            value: 'RBHP',
            labelcz: 'fundusz inwestycyjny'
        },
        {
            value: 'SVA3',
            labelcz: 'fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne'
        },
        {
            value: '6LUM',
            labelcz: 'główny oddział zagranicznego zakładu reasekuracji'
        },
        {
            value: 'P1L1',
            labelcz: 'główny oddział zagranicznego zakładu ubezpieczeń'
        },
        {
            value: 'CY1M',
            labelcz: 'instytucje gospodarki budżetowej'
        },
        {
            value: 'KM66',
            labelcz: 'instytuty badawcze'
        },
        {
            value: 'FANM',
            labelcz: 'kółka rolnicze'
        },
        {
            value: 'SP4S',
            labelcz: 'kościoł i związki wyznaniowe'
        },
        {
            value: 'FQ5Y',
            labelcz: 'organizacje społeczne i zawodowe'
        },
        {
            value: '60BG',
            labelcz: 'organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały'
        },
        {
            value: 'ZVVM',
            labelcz: 'osoby fizyczne prowadzące działalność gospodarczą'
        },
        {
            value: 'QUX1',
            labelcz: 'otwarty fundusz emerytalny'
        },
        {
            value: 'JCKO',
            labelcz: 'państwowe jednostki organizacyjne'
        },
        {
            value: 'HOT8',
            labelcz: 'partie polityczne'
        },
        {
            value: 'QYL4',
            labelcz: 'placówki systemu oświaty'
        },
        {
            value: 'B21W',
            labelcz: 'prosta spółka akcyjna'
        },
        {
            value: 'SMIS',
            labelcz: 'przedsiębiorstwo państwowe'
        },
        {
            value: '13ZV',
            labelcz: 'samodzielny publiczny zakład opieki zdrowotnej'
        },
        {
            value: 'AL9T',
            labelcz: 'samorządowe jednostki organizacyjne'
        },
        {
            value: 'F21U',
            labelcz: 'Skarb Państwa'
        },
        {
            value: 'H7OD',
            labelcz: 'spółdzielcza kasa oszczędnościowo-kredytowa'
        },
        {
            value: '8TOF',
            labelcz: 'spółdzielnia'
        },
        {
            value: 'FJ0E',
            labelcz: 'spółka akcyjna'
        },
        {
            value: 'YLZL',
            labelcz: 'spółka cywilna'
        },
        {
            value: 'J3A3',
            labelcz: 'spółka europejska'
        },
        {
            value: '629I',
            labelcz: 'spółka jawna'
        },
        {
            value: 'BSJT',
            labelcz: 'spółka komandytowa'
        },
        {
            value: 'OMX0',
            labelcz: 'spółka komandytowo-akcyjna'
        },
        {
            value: '3BJG',
            labelcz: 'spółka partnerska'
        },
        {
            value: 'O7XB',
            labelcz: 'spółka z ograniczoną odpowiedzialnością'
        },
        {
            value: 'ZZKE',
            labelcz: 'stowarzyszenie i związki stowarzyszeń'
        },
        {
            value: 'EU0T',
            labelcz: 'towarzystwo reasekuracji wzajemnej'
        },
        {
            value: 'WNX1',
            labelcz: 'towarzystwo ubezpieczeń wzajemnych'
        },
        {
            value: 'WUJ2',
            labelcz: 'uczelnia'
        },
        {
            value: 'GZE5',
            labelcz: 'wspólnota mieszkaniowa'
        },
        {
            value: 'T7PB',
            labelcz: 'wspólnoty samorządowe'
        },
        {
            value: '6OYI',
            labelcz: 'zrzeszenie'
        },
        {
            value: 'LT9U',
            labelcz: 'związek zawodowy'
        },
        {
            value: 'WOK7',
            labelcz: 'związki inne niż zawodowe'
        }
    ],
    PR: [
        {
            value: 'TPFL',
            labelcz: 'Bank (Corporation)'
        },
        {
            value: '9EGO',
            labelcz: 'Bank (LLC)'
        },
        {
            value: '6DE6',
            labelcz: 'Close Corporation'
        },
        {
            value: 'T2JS',
            labelcz: 'Close Corporation'
        },
        {
            value: 'D5L6',
            labelcz: 'Consumer Cooperative'
        },
        {
            value: '87N3',
            labelcz: 'Cooperativa de Consumo'
        },
        {
            value: 'INDH',
            labelcz: 'Corporation'
        },
        {
            value: 'YS16',
            labelcz: 'Corporation'
        },
        {
            value: 'SQXC',
            labelcz: 'Insurance Company'
        },
        {
            value: 'VKSV',
            labelcz: 'Insurance Company'
        },
        {
            value: 'A4MM',
            labelcz: 'International Banking Center (Corporation)'
        },
        {
            value: 'GL33',
            labelcz: 'International Banking Center (Corporation)'
        },
        {
            value: 'RA5B',
            labelcz: 'International Banking Center (LLC)'
        },
        {
            value: 'XUYT',
            labelcz: 'International Banking Center (LLC)'
        },
        {
            value: 'W6NI',
            labelcz: 'International Financial Entity (Corporation)'
        },
        {
            value: 'XK6L',
            labelcz: 'International Financial Entity (Corporation)'
        },
        {
            value: '81YI',
            labelcz: 'International Financial Entity (LLC)'
        },
        {
            value: 'GCP3',
            labelcz: 'International Financial Entity (LLC)'
        },
        {
            value: '35RF',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '3QX8',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'E85L',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'O4QG',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '1TG4',
            labelcz: 'Low Profit LLC'
        },
        {
            value: 'Y7LW',
            labelcz: 'Low Profit LLC'
        },
        {
            value: 'D8XQ',
            labelcz: 'Municipal Enterprise'
        },
        {
            value: 'I1WG',
            labelcz: 'Municipal Enterprise'
        },
        {
            value: '194I',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'DE7H',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'ERUM',
            labelcz: 'Public Benefit Corporation'
        },
        {
            value: 'ME4Y',
            labelcz: 'Public Benefit Corporation'
        },
        {
            value: 'I6FV',
            labelcz: 'Savings & Credit Cooperative'
        },
        {
            value: 'UL6C',
            labelcz: 'Savings & Credit Cooperative'
        },
        {
            value: 'TEGV',
            labelcz: 'Special Corporation for Municipal Development'
        },
        {
            value: 'Y3T2',
            labelcz: 'Special Corporation for Municipal Development'
        },
        {
            value: '7JAI',
            labelcz: 'Special Employee Owned Corporation'
        },
        {
            value: 'EQQP',
            labelcz: 'Special Employee Owned Corporation'
        },
        {
            value: 'BQ6L',
            labelcz: 'Sponsored By Municipal Corporation'
        },
        {
            value: 'Y21X',
            labelcz: 'Sponsored By Municipal Corporation'
        },
        {
            value: '4XY9',
            labelcz: 'Trust'
        },
        {
            value: 'JJ1V',
            labelcz: 'Trust'
        },
        {
            value: 'GRH5',
            labelcz: 'Workers Cooperative'
        },
        {
            value: 'SOQ1',
            labelcz: 'Workers Cooperative'
        },
        {
            value: 'C907',
            labelcz: 'Youth Cooperative'
        },
        {
            value: 'O2JM',
            labelcz: 'Youth Cooperative'
        }
    ],
    PT: [
        {
            value: 'YMLD',
            labelcz: 'Agrupamento Complementar de Empresas'
        },
        {
            value: '99JD',
            labelcz: 'Agrupamento Europeu de Interesse Económico'
        },
        {
            value: 'ALPT',
            labelcz: 'Associação'
        },
        {
            value: '1HGD',
            labelcz: 'Cooperativa'
        },
        {
            value: '5KVH',
            labelcz: 'Cooperativa de 2º Grau'
        },
        {
            value: 'IX01',
            labelcz: 'Empresa Intermunicipal'
        },
        {
            value: 'XD16',
            labelcz: 'Empresa Metropolitana'
        },
        {
            value: 'PIDC',
            labelcz: 'Empresa Municipal'
        },
        {
            value: 'ZSWE',
            labelcz: 'Empresa Regional'
        },
        {
            value: '6IK8',
            labelcz: 'Entidade Empresarial Intermunicipal'
        },
        {
            value: 'NIQY',
            labelcz: 'Entidade Empresarial Metropolitana'
        },
        {
            value: 'D7OA',
            labelcz: 'Entidade Empresarial Municipal'
        },
        {
            value: 'A8CT',
            labelcz: 'Entidade Pública Empresarial'
        },
        {
            value: 'ZILA',
            labelcz: 'Estabelecimento Individual de Responsabilidade Limitada'
        },
        {
            value: 'Z0NE',
            labelcz: 'Fundação'
        },
        {
            value: '6L6P',
            labelcz: 'Fundo'
        },
        {
            value: 'XMXM',
            labelcz: 'Fundo'
        },
        {
            value: '7XPP',
            labelcz: 'Fundo de Investimento Alternativo'
        },
        {
            value: 'KUUV',
            labelcz: 'Organismo da Administração Pública'
        },
        {
            value: '6WQ5',
            labelcz: 'Organismos de investimento colectivo em valores mobiliários'
        },
        {
            value: 'P5S3',
            labelcz: 'Pessoa Coletiva de Direito Público'
        },
        {
            value: 'QFXD',
            labelcz: 'Pessoa Coletiva Internacional'
        },
        {
            value: '68PD',
            labelcz: 'Representação Permanente'
        },
        {
            value: 'DFE5',
            labelcz: 'Sociedade Anónima'
        },
        {
            value: 'W9W3',
            labelcz: 'Sociedade Anónima Desportiva'
        },
        {
            value: 'MFHR',
            labelcz: 'Sociedade Anónima Europeia'
        },
        {
            value: 'OXUC',
            labelcz: 'Sociedade em Comandita'
        },
        {
            value: 'N66B',
            labelcz: 'Sociedade em Nome Coletivo'
        },
        {
            value: 'USOG',
            labelcz: 'Sociedade por Quotas'
        },
        {
            value: 'VF4C',
            labelcz: 'Sociedade Unipessoal por Quotas'
        },
        {
            value: 'Z7ZX',
            labelcz: 'Sucursal Financeira Exterior'
        },
        {
            value: 'IKBN',
            labelcz: 'Trust'
        }
    ],
    PY: [
        {
            value: '78SG',
            labelcz: 'Empresa Unipersonal'
        },
        {
            value: '48X2',
            labelcz: 'Empresa Unipersonal De Responsabilidad Limitada'
        },
        {
            value: 'IJAO',
            labelcz: 'Sociedad Anonima'
        },
        {
            value: 'K08V',
            labelcz: 'Sociedad De Responsabilidad Limitada'
        },
        {
            value: 'LNG8',
            labelcz: 'Sociedad En Comandita Por Acciones'
        },
        {
            value: '4QBB',
            labelcz: 'Sociedad En Comandita Simple'
        }
    ],
    RO: [
        {
            value: 'CTBD',
            labelcz: 'Alte forme de proprietate'
        },
        {
            value: 'TH8A',
            labelcz: 'Asociatie familiala'
        },
        {
            value: 'W7HT',
            labelcz: 'Autoritatea Administratiei Publice Locale'
        },
        {
            value: 'I15K',
            labelcz: 'Cooperativă agricolă'
        },
        {
            value: '8FD2',
            labelcz: 'Cooperativă de consum'
        },
        {
            value: 'GT4V',
            labelcz: 'Cooperativă de credit'
        },
        {
            value: '37II',
            labelcz: 'Cooperativă meșteșugărească'
        },
        {
            value: 'PE9A',
            labelcz: 'Federatja'
        },
        {
            value: 'EFBR',
            labelcz: 'Grupul de interes economic'
        },
        {
            value: '4V0A',
            labelcz: 'Grupul european de interes economic'
        },
        {
            value: 'DUGD',
            labelcz: 'Intreprindere individuala'
        },
        {
            value: '5NCK',
            labelcz: 'Organizație non-guvernamentală'
        },
        {
            value: '7W9B',
            labelcz: 'Organizații cooperatiste de credit și casele centrale ale acestora'
        },
        {
            value: 'FJQ8',
            labelcz: 'Persoana fizica autorizata'
        },
        {
            value: 'AI01',
            labelcz: 'Persoana fizica independentă'
        },
        {
            value: 'SFZM',
            labelcz: 'Persoană juridică de drept public'
        },
        {
            value: 'CUGP',
            labelcz: 'Regie autonomă'
        },
        {
            value: 'NFRJ',
            labelcz: 'Reprezentant fiscal'
        },
        {
            value: '85K5',
            labelcz: 'Reprezentanta'
        },
        {
            value: 'Q89X',
            labelcz: 'Sindicatul'
        },
        {
            value: 'F0BK',
            labelcz: 'Societate agricolă'
        },
        {
            value: '7B9H',
            labelcz: 'Societate cooperativă'
        },
        {
            value: 'UWEE',
            labelcz: 'Societate Cooperativă Europeană'
        },
        {
            value: 'XHN1',
            labelcz: 'Societate cu răspundere limitată'
        },
        {
            value: '1CDX',
            labelcz: 'Societate europeană'
        },
        {
            value: 'SWMK',
            labelcz: 'Societate în comandită pe acţiuni'
        },
        {
            value: 'V0FL',
            labelcz: 'Societate în comandită simplă'
        },
        {
            value: 'F68H',
            labelcz: 'Societate în nume colectiv'
        },
        {
            value: 'ANDT',
            labelcz: 'Societate pe acţiuni'
        }
    ],
    RS: [
        {
            value: 'YVPW',
            labelcz: 'Akcionarsko društvo'
        },
        {
            value: '88TX',
            labelcz: 'Društveno preduzeće'
        },
        {
            value: 'KIU5',
            labelcz: 'Društvo sa ograničenom odgovornošću'
        },
        {
            value: 'DEF6',
            labelcz: 'Javno preduzeće'
        },
        {
            value: '73PZ',
            labelcz: 'Komanditno društvo'
        },
        {
            value: 'ZPOY',
            labelcz: 'Ortačko društvo'
        },
        {
            value: '9O67',
            labelcz: 'Preduzetnik'
        },
        {
            value: 'E7W8',
            labelcz: 'Zadruga'
        },
        {
            value: '6UPM',
            labelcz: 'Zadružni savez'
        }
    ],
    RU: [
        {
            value: 'AS78',
            labelcz: 'Advokatskiye byuro'
        },
        {
            value: 'H4NY',
            labelcz: 'Advokatskiye palaty'
        },
        {
            value: '5VMR',
            labelcz: 'Advokaty, uchredivshiye advokatskiy kabinet'
        },
        {
            value: 'R71T',
            labelcz: 'Aktsionernyye obshchestva'
        },
        {
            value: '4VTZ',
            labelcz: 'Assotsiatsii (soyuzy)'
        },
        {
            value: 'PA5X',
            labelcz: 'Assotsiatsii (soyuzy) ekonomicheskogo vzaimodeystviya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: 'C7TI',
            labelcz: 'Assotsiatsii (soyuzy) sadovodcheskikh, ogorodnicheskikh i dachnykh nekommercheskikh ob"yedineniy'
        },
        {
            value: '1RJ2',
            labelcz: 'Avtonomnyye nekommercheskiye organizatsii'
        },
        {
            value: 'LYTH',
            labelcz: "Blagotvoritel'nyye fondy"
        },
        {
            value: '1U7Y',
            labelcz: "Blagotvoritel'nyye uchrezhdeniya"
        },
        {
            value: '9M15',
            labelcz: "Central'nyj bank"
        },
        {
            value: 'D094',
            labelcz: 'Ekologicheskiye fondy'
        },
        {
            value: 'HKKL',
            labelcz: "Federal'nyye gosudarstvennyye avtonomnyye uchrezhdeniya"
        },
        {
            value: '8NF7',
            labelcz: "Federal'nyye gosudarstvennyye byudzhetnyye uchrezhdeniya"
        },
        {
            value: 'TMIG',
            labelcz: "Federal'nyye gosudarstvennyye kazennyye uchrezhdeniya"
        },
        {
            value: 'OCIS',
            labelcz: "Federal'nyye gosudarstvennyye unitarnyye predpriyatiya"
        },
        {
            value: '37YG',
            labelcz: "Federal'nyye kazennyye predpriyatiya"
        },
        {
            value: 'VIGZ',
            labelcz: 'Filialy yuridicheskikh lits'
        },
        {
            value: 'KZC6',
            labelcz: 'Fondy'
        },
        {
            value: 'CN7I',
            labelcz: 'Fondy prokata'
        },
        {
            value: 'BQ3A',
            labelcz: "Garazhnyye i garazhno-stroitel'nyye kooperativy"
        },
        {
            value: 'KOYR',
            labelcz: "Glavy krest'yanskikh (fermerskikh) khozyaystv"
        },
        {
            value: '8JWV',
            labelcz: 'Gosudarstvennyye akademii nauk'
        },
        {
            value: 'MG22',
            labelcz: 'Gosudarstvennyye avtonomnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: '8MQM',
            labelcz: 'Gosudarstvennyye byudzhetnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: 'ZNHF',
            labelcz: 'Gosudarstvennyye kazennyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: 'DO25',
            labelcz: 'Gosudarstvennyye kompanii'
        },
        {
            value: 'E0VI',
            labelcz: 'Gosudarstvennyye korporatsii'
        },
        {
            value: '9RQZ',
            labelcz: 'Gosudarstvennyye unitarnyye predpriyatiya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: 'YA7H',
            labelcz: 'Chastnyye uchrezhdeniya'
        },
        {
            value: 'P9CF',
            labelcz: "Individual'nyye predprinimateli"
        },
        {
            value: 'B5GH',
            labelcz:
                "Kazach'i obshchestva, vnesennyye v gosudarstvennyy reyestr kazach'ikh obshchestv v Rossiyskoy Federatsii"
        },
        {
            value: 'DZSY',
            labelcz: 'Kazennyye predpriyatiya sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: 'QCRH',
            labelcz: 'Khozyaystvennyye obshchestva'
        },
        {
            value: 'ZH3O',
            labelcz: 'Khozyaystvennyye partnerstva'
        },
        {
            value: 'KLA2',
            labelcz: 'Khozyaystvennyye tovarishchestva'
        },
        {
            value: 'UTBN',
            labelcz: 'Kollegii advokatov'
        },
        {
            value: 'XINV',
            labelcz: 'Kooperativnyye khozyaystva (koopkhozy)'
        },
        {
            value: 'H2P4',
            labelcz: 'Kreditnyye kooperativy vtorogo urovnya'
        },
        {
            value: 'BLVV',
            labelcz: "Kreditnyye potrebitel'skiye kooperativy"
        },
        {
            value: 'XNKN',
            labelcz: "Kreditnyye potrebitel'skiye kooperativy grazhdan"
        },
        {
            value: '1MJ0',
            labelcz: "Krest'yanskiye (fermerskiye) khozyaystva"
        },
        {
            value: 'Q9FA',
            labelcz: "Mezhpravitel'stvennyye mezhdunarodnyye organizatsii"
        },
        {
            value: '2OTW',
            labelcz: "Munitsipal'nyye avtonomnyye uchrezhdeniya"
        },
        {
            value: 'FWGK',
            labelcz: "Munitsipal'nyye byudzhetnyye uchrezhdeniya"
        },
        {
            value: 'XIGI',
            labelcz: "Munitsipal'nyye kazennyye predpriyatiya"
        },
        {
            value: 'VEX5',
            labelcz: "Munitsipal'nyye kazennyye uchrezhdeniya"
        },
        {
            value: 'Z3SH',
            labelcz: "Munitsipal'nyye unitarnyye predpriyatiya"
        },
        {
            value: 'Z2AQ',
            labelcz: 'Negosudarstvennyye pensionnyye fondy'
        },
        {
            value: 'CKTA',
            labelcz: 'Nekommercheskiye partnerstva'
        },
        {
            value: 'XBRI',
            labelcz: "Nepravitel'stvennyye mezhdunarodnyye organizatsii"
        },
        {
            value: 'JZBN',
            labelcz: 'Nepublichnyye aktsionernyye obshchestva'
        },
        {
            value: 'PJRZ',
            labelcz: "Notarial'nyye palaty"
        },
        {
            value: 'QSXT',
            labelcz: 'Notariusy, zanimayushchiyesya chastnoy praktikoy'
        },
        {
            value: '15A2',
            labelcz: 'Ob"yedineniya (assotsiatsii i soyuzy) blagotvoritel\'nykh organizatsiy'
        },
        {
            value: 'MVSF',
            labelcz: 'Ob"yedineniya fermerskikh khozyaystv'
        },
        {
            value: 'SDVV',
            labelcz: 'Ob"yedineniya rabotodateley'
        },
        {
            value: 'VAB6',
            labelcz: 'Obosoblennyye podrazdeleniya yuridicheskikh lits'
        },
        {
            value: '17R7',
            labelcz: "Obshchestva s ogranichennoy otvetstvennost'yu"
        },
        {
            value: 'QMEH',
            labelcz: 'Obshchestva vzaimnogo strakhovaniya'
        },
        {
            value: 'YJ6A',
            labelcz: 'Obshchestvennyye dvizheniya'
        },
        {
            value: 'EH3M',
            labelcz: 'Obshchestvennyye fondy'
        },
        {
            value: 'D84J',
            labelcz: 'Obshchestvennyye organizatsii'
        },
        {
            value: 'NRK9',
            labelcz: 'Obshchestvennyye uchrezhdeniya'
        },
        {
            value: 'GWHK',
            labelcz: 'Obshchiny korennykh malochislennykh narodov Rossiyskoy Federatsii'
        },
        {
            value: 'BZQL',
            labelcz: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan (fizicheskikh lits)"
        },
        {
            value: 'SIPP',
            labelcz: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan, ne otnesennoy k predprinimatel'stvu"
        },
        {
            value: 'EWQF',
            labelcz: "Organizatsionno-pravovyye formy dlya kommercheskoy deyatel'nosti grazhdan"
        },
        {
            value: 'QQS1',
            labelcz:
                "Organizatsionno-pravovyye formy mezhdunarodnykh organizatsiy, osushchestvlyayushchikh deyatel'nost' na territorii rossiyskoy federatsii"
        },
        {
            value: 'JPMQ',
            labelcz: 'Organizatsionno-pravovyye formy organizatsiy, sozdannykh bez prav yuridicheskogo litsa'
        },
        {
            value: 'VOUU',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi unitarnymi organizatsiyami'
        },
        {
            value: 'VE1P',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi korporativnymi organizatsiyami'
        },
        {
            value: 'I9V2',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi unitarnymi organizatsiyami'
        },
        {
            value: 'KVSH',
            labelcz: "Organy obshchestvennoy samodeyatel'nosti"
        },
        {
            value: 'LLL8',
            labelcz: "Otdeleniya inostrannykh nekommercheskikh nepravitel'stvennykh organizatsiy"
        },
        {
            value: 'MT3A',
            labelcz: 'Otkrytoye aktsionernoye obshchestvo'
        },
        {
            value: 'YGHZ',
            labelcz: 'Payevyye investitsionnyye fondy'
        },
        {
            value: 'NZ85',
            labelcz: 'Politicheskiye partii'
        },
        {
            value: 'ZKAF',
            labelcz: 'Polnyye tovarishchestva'
        },
        {
            value: 'QFGM',
            labelcz: "Potrebitel'skiye kooperativy"
        },
        {
            value: 'MV1C',
            labelcz: "Potrebitel'skiye obshchestva"
        },
        {
            value: 'OPLQ',
            labelcz: "Predstavitel'stva yuridicheskikh lits"
        },
        {
            value: '3TOV',
            labelcz: 'Profsoyuznyye organizatsii'
        },
        {
            value: '3U8X',
            labelcz: 'Prochiye yuridicheskiye litsa, yavlyayushchiyesya kommercheskimi organizatsiyami'
        },
        {
            value: 'FZKX',
            labelcz: 'Proizvodstvennyye kooperativy (arteli)'
        },
        {
            value: '3EAX',
            labelcz: "Proizvodstvennyye kooperativy (krome sel'skokhozyaystvennykh proizvodstvennykh kooperativov)"
        },
        {
            value: 'J7NW',
            labelcz: 'Prostyye tovarishchestva'
        },
        {
            value: '8RIH',
            labelcz: 'Publichno-pravovyye kompanii'
        },
        {
            value: '4TYO',
            labelcz: 'Publichnyye aktsionernyye obshchestva'
        },
        {
            value: 'UY49',
            labelcz: 'Rayonnyye sudy, gorodskiye sudy, mezhrayonnyye sudy (rayonnyye sudy)'
        },
        {
            value: 'HUET',
            labelcz: 'Religioznyye organizatsii'
        },
        {
            value: 'VA0A',
            labelcz: 'Rybolovetskiye arteli (kolkhozy)'
        },
        {
            value: 'Z3Y0',
            labelcz: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye partnerstva'
        },
        {
            value: 'RJUK',
            labelcz: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye tovarishchestva'
        },
        {
            value: '8NZE',
            labelcz: "Sadovodcheskiye, ogorodnicheskiye ili dachnyye potrebitel'skiye kooperativy"
        },
        {
            value: 'ILY0',
            labelcz: 'Samoreguliruyemyye organizatsii'
        },
        {
            value: 'IC46',
            labelcz: "Sel'skokhozyaystvennyye arteli (kolkhozy)"
        },
        {
            value: 'HUR1',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye obsluzhivayushchiye kooperativy"
        },
        {
            value: 'GHC5',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye ogorodnicheskiye kooperativy"
        },
        {
            value: 'I9O1',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye pererabatyvayushchiye kooperativy"
        },
        {
            value: 'PDYW',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye sadovodcheskiye kooperativy"
        },
        {
            value: 'O1KO',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye sbytovyye (torgovyye) kooperativy"
        },
        {
            value: 'IBSS',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye snabzhencheskiye kooperativy"
        },
        {
            value: '6H83',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye zhivotnovodcheskiye kooperativy"
        },
        {
            value: '3AMJ',
            labelcz: "Sel'skokhozyaystvennyye proizvodstvennyye kooperativy"
        },
        {
            value: '8XDD',
            labelcz: 'Sovety munitsipal\'nykh obrazovaniy sub"yektov Rossiyskoy Federatsii'
        },
        {
            value: '2H36',
            labelcz: 'Soyuzy (assotsiatsii) kooperativov'
        },
        {
            value: 'WYNO',
            labelcz: 'Soyuzy (assotsiatsii) kreditnykh kooperativov'
        },
        {
            value: '24TU',
            labelcz: 'Soyuzy (assotsiatsii) obshchestvennykh ob"yedineniy'
        },
        {
            value: 'XJJR',
            labelcz: 'Soyuzy (assotsiatsii) obshchin malochislennykh narodov'
        },
        {
            value: 'TLDB',
            labelcz: "Soyuzy potrebitel'skikh obshchestv"
        },
        {
            value: 'GZF9',
            labelcz: 'Strukturnyye podrazdeleniya obosoblennykh podrazdeleniy yuridicheskikh lits'
        },
        {
            value: 'G2CW',
            labelcz: "Territorial'nyye obshchestvennyye samoupravleniya"
        },
        {
            value: 'ZGYA',
            labelcz: 'Torgovo-promyshlennyye palaty'
        },
        {
            value: 'J18N',
            labelcz: 'Tovarishchestva na vere (kommanditnyye tovarishchestva)'
        },
        {
            value: 'H2AF',
            labelcz: 'Tovarishchestva sobstvennikov nedvizhimosti'
        },
        {
            value: '2R46',
            labelcz: "Tovarishchestva sobstvennikov zhil'ya"
        },
        {
            value: '3F98',
            labelcz: 'Uchrezhdeniya'
        },
        {
            value: 'QKFU',
            labelcz: "Uchrezhdeniya, sozdannyye munitsipal'nym obrazovaniyem (munitsipal'nyye uchrezhdeniya)"
        },
        {
            value: 'GQRJ',
            labelcz: 'Uchrezhdeniya, sozdannyye Rossiyskoy Federatsiyey'
        },
        {
            value: '4PZX',
            labelcz: 'Uchrezhdeniya, sozdannyye sub"yektom Rossiyskoy Federatsii'
        },
        {
            value: 'VEOU',
            labelcz: 'Unitarnyye predpriyatiya'
        },
        {
            value: 'QUMQ',
            labelcz: 'Unitarnyye predpriyatiya, osnovannyye na prave khozyaystvennogo vedeniya'
        },
        {
            value: 'OVLN',
            labelcz: 'Unitarnyye predpriyatiya, osnovannyye na prave operativnogo upravleniya (kazennyye predpriyatiya)'
        },
        {
            value: '8B9A',
            labelcz: "Zhilishchnyye ili zhilishchno-stroitel'nyye kooperativy"
        },
        {
            value: 'WJXS',
            labelcz: "Zhilishchnyye nakopitel'nyye kooperativy"
        },
        {
            value: 'C3RQ',
            labelcz:
                'Организационно-правовые формы юридических лиц, являющихся коммерческими корпоративными организациями'
        }
    ],
    SA: [
        {
            value: 'TTE8',
            labelcz: 'sharakah dhat maswuwliat mahduda'
        },
        {
            value: 'WHCI',
            labelcz: 'sharakah tawsiat basita'
        },
        {
            value: 'Z9IE',
            labelcz: "sharikat 'ajnabia"
        },
        {
            value: 'PT6M',
            labelcz: "sharikat 'amwal"
        },
        {
            value: 'B3JS',
            labelcz: "sharikat 'ashkhas"
        },
        {
            value: 'T2NA',
            labelcz: 'sharikat altadamun'
        },
        {
            value: 'N10C',
            labelcz: 'sharikat dhat ras mal qabil liltaghyir'
        },
        {
            value: 'YVGA',
            labelcz: 'sharikat muhasa'
        },
        {
            value: '78VH',
            labelcz: 'sharikat musahama'
        },
        {
            value: 'DW9N',
            labelcz: "sharikat tawsiat bial'ashum"
        }
    ],
    SB: [
        {
            value: 'A7VA',
            labelcz: 'Community Company'
        },
        {
            value: 'YSBJ',
            labelcz: 'Overseas Company'
        },
        {
            value: '8PIA',
            labelcz: 'Private Company'
        },
        {
            value: 'Z4ZP',
            labelcz: 'Public Company'
        }
    ],
    SC: [
        {
            value: 'CDYY',
            labelcz: 'Company Limited by Guarantee'
        },
        {
            value: '6MS4',
            labelcz: 'Company Limited by Shares'
        },
        {
            value: 'E3YL',
            labelcz: 'Company Limited by Shares and Guarantee'
        },
        {
            value: '3YUS',
            labelcz: 'Foundation'
        },
        {
            value: 'KOFC',
            labelcz: 'International Business Company - Company Limited by Guarantee'
        },
        {
            value: '7QEH',
            labelcz: 'International Business Company - Company Limited by Shares'
        },
        {
            value: 'KGUS',
            labelcz: 'International Business Company - Company Limited by Shares and Guarantee'
        },
        {
            value: 'WKFR',
            labelcz: 'International Business Company - Limited Life Company'
        },
        {
            value: 'G6M8',
            labelcz: 'International Business Company - Protected Cell Company'
        },
        {
            value: 'BB5Y',
            labelcz: 'International Trust'
        },
        {
            value: 'VA1X',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'H987',
            labelcz: 'Proprietary Company'
        },
        {
            value: 'Q9VK',
            labelcz: 'Protected Cell Company'
        },
        {
            value: 'H35I',
            labelcz: 'Public Company'
        },
        {
            value: '7XUS',
            labelcz: 'Special License Company'
        },
        {
            value: 'P3YJ',
            labelcz: 'Unlimited Company'
        }
    ],
    SE: [
        {
            value: 'XJHM',
            labelcz: 'Aktiebolag'
        },
        {
            value: 'BYQJ',
            labelcz: 'Bankaktiebolag'
        },
        {
            value: 'WZDB',
            labelcz: 'Bostadsförening'
        },
        {
            value: 'SSOM',
            labelcz: 'Bostadsrättsförening'
        },
        {
            value: 'C61P',
            labelcz: 'Ekonomisk förening'
        },
        {
            value: 'UKOL',
            labelcz: 'enkelt bolag'
        },
        {
            value: '54P7',
            labelcz: 'Europabolag'
        },
        {
            value: '9YIP',
            labelcz: 'Europakooperativ'
        },
        {
            value: 'RLJO',
            labelcz: 'Europeisk ekonomisk intressegruppering'
        },
        {
            value: 'RYFP',
            labelcz: 'Europeisk gruppering för territoriellt samarbete'
        },
        {
            value: 'OJ9I',
            labelcz: 'Försäkringsaktiebolag'
        },
        {
            value: 'M0Y0',
            labelcz: 'Försäkringsförening'
        },
        {
            value: 'BEAY',
            labelcz: 'Handelsbolag'
        },
        {
            value: '1TN0',
            labelcz: 'Ideell förening (som bedriver näringsverksamhet)'
        },
        {
            value: 'CX05',
            labelcz: 'Kommanditbolag'
        },
        {
            value: 'WKFL',
            labelcz: 'Kommun'
        },
        {
            value: 'PDQ0',
            labelcz: 'Kooperativ hyresrättsförening'
        },
        {
            value: '381R',
            labelcz: 'Medlemsbank'
        },
        {
            value: '27AW',
            labelcz: 'offentlig enhet'
        },
        {
            value: 'O1QI',
            labelcz: 'Ömsesidigt försäkringsbolag'
        },
        {
            value: 'AZTO',
            labelcz: 'Sambruksförening'
        },
        {
            value: '44CQ',
            labelcz: 'samfallighetsförening'
        },
        {
            value: 'G04R',
            labelcz: 'Sparbank'
        },
        {
            value: 'E9BI',
            labelcz: 'stiftelse'
        },
        {
            value: '2UAX',
            labelcz: 'Trossamfund (som bedriver näringsverksamhet)'
        }
    ],
    SG: [
        {
            value: 'KEMH',
            labelcz: 'Company (Foreign Branch)'
        },
        {
            value: 'Y8W9',
            labelcz: 'Exempt Private Company'
        },
        {
            value: '5SGV',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '17FJ',
            labelcz: 'Limited Partnership'
        },
        {
            value: '0NYS',
            labelcz: 'Partnership'
        },
        {
            value: 'IWZF',
            labelcz: 'Private Company Limited by Shares'
        },
        {
            value: 'HRKG',
            labelcz: 'Public Company Limited by Guarantee'
        },
        {
            value: 'VVOX',
            labelcz: 'Public Company Limited by Shares'
        },
        {
            value: 'NFDF',
            labelcz: 'Sole-Proprietorship'
        },
        {
            value: 'R997',
            labelcz: 'Unlimited Exempt Private Company'
        },
        {
            value: 'BAMJ',
            labelcz: 'Unlimited Private Company'
        },
        {
            value: 'QGSA',
            labelcz: 'Unlimited Public Company'
        }
    ],
    SI: [
        {
            value: '34PA',
            labelcz: 'Centralna banka'
        },
        {
            value: 'S1UI',
            labelcz: 'Civilna odvetniška družba'
        },
        {
            value: '1OR3',
            labelcz: 'delniška družba'
        },
        {
            value: 'UG0E',
            labelcz: 'Dobrodelna organizacija'
        },
        {
            value: 'HJCS',
            labelcz: 'Društvo, zveza društev'
        },
        {
            value: 'SD81',
            labelcz: 'družba z neomejeno odgovornostjo'
        },
        {
            value: 'KBKD',
            labelcz: 'družba z omejeno odgovornostjo'
        },
        {
            value: 'ICQT',
            labelcz: 'Družba za vzajemno zavarovanje'
        },
        {
            value: 'QYQ5',
            labelcz: 'Družbeno podjetje'
        },
        {
            value: '4A8T',
            labelcz: 'evropska delniška družba'
        },
        {
            value: 'Q2EV',
            labelcz: 'Evropsko gospodarsko interesno združenje'
        },
        {
            value: 'D64E',
            labelcz: 'Gospodarska zbornica'
        },
        {
            value: 'UDQJ',
            labelcz: 'Gospodarsko interesno združenje'
        },
        {
            value: '14AT',
            labelcz: 'Javna agencija'
        },
        {
            value: 'UESF',
            labelcz: 'Javni sklad'
        },
        {
            value: 'I7MN',
            labelcz: 'Javno podjetje'
        },
        {
            value: 'JQA2',
            labelcz: 'Kmetijska zadruga'
        },
        {
            value: 'WZ78',
            labelcz: 'komanditna delniška družba'
        },
        {
            value: 'OPDJ',
            labelcz: 'komanditna družba'
        },
        {
            value: 'LNYR',
            labelcz: 'Obrtna zadruga'
        },
        {
            value: 'X94Z',
            labelcz: 'Republika Slovenija'
        },
        {
            value: 'QW8S',
            labelcz: 'Samostojni podjetnik posameznik'
        },
        {
            value: 'M84A',
            labelcz: 'Sklad'
        },
        {
            value: 'KH4O',
            labelcz: 'Skupnost lastnikov stanovanj'
        },
        {
            value: 'RG9Z',
            labelcz: 'Societas Cooperativa Europaea'
        },
        {
            value: '8ER6',
            labelcz: 'Stanovanjska zadruga'
        },
        {
            value: 'QUEA',
            labelcz: 'Tuja pravna oseba po ZZK-1'
        },
        {
            value: '6MPY',
            labelcz: 'Ustanova'
        },
        {
            value: '5LXY',
            labelcz: 'Verska skupnost in podobne verske organizacije'
        },
        {
            value: '2CTG',
            labelcz: 'zadruga'
        },
        {
            value: 'TMVE',
            labelcz: 'Zadruga brez odgovornosti'
        },
        {
            value: 'E01X',
            labelcz: 'zadruga v zasebni lasti'
        },
        {
            value: 'RAX7',
            labelcz: 'Zadruga z omejeno odgovornostjo'
        }
    ],
    SK: [
        {
            value: '2EEG',
            labelcz: 'Akciová spoločnosť'
        },
        {
            value: 'U3QQ',
            labelcz: 'Banka - akciová spoločnosť'
        },
        {
            value: 'HZI2',
            labelcz: 'Banka-štátny peňažný ústav'
        },
        {
            value: 'E4CI',
            labelcz: 'Bytové družstvo'
        },
        {
            value: 'GY5R',
            labelcz: 'Cirkevná organizácia'
        },
        {
            value: 'ISCZ',
            labelcz: 'Doplnková dôchodková poisťovňa'
        },
        {
            value: '3P3W',
            labelcz: 'Družstevný podnik (s jedným zakladateľom)'
        },
        {
            value: '8RE3',
            labelcz: 'Družstevný podnik poľnohospodársky'
        },
        {
            value: 'I7AS',
            labelcz: 'Družstvo'
        },
        {
            value: 'BUMI',
            labelcz: 'Európska spoločnosť'
        },
        {
            value: '7O89',
            labelcz: 'Európske družstvo'
        },
        {
            value: 'YVE8',
            labelcz: 'Európske zoskupenie hospodárskych záujmov'
        },
        {
            value: 'VATN',
            labelcz: 'Európske zoskupenie územnej spolupráce'
        },
        {
            value: 'L1M7',
            labelcz: 'Fakulta vysokej školy'
        },
        {
            value: '7EG2',
            labelcz: 'Fondy'
        },
        {
            value: 'FDVU',
            labelcz: 'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému'
        },
        {
            value: 'TAV3',
            labelcz: 'Iná organizácia verejnej správy'
        },
        {
            value: 'PX29',
            labelcz: 'Iná právnicka osoba'
        },
        {
            value: 'SQFW',
            labelcz: 'Iné družstvo'
        },
        {
            value: 'FMUC',
            labelcz: 'Iné pracovisko vysokej školy/fakulty'
        },
        {
            value: 'D18J',
            labelcz: 'Jednoduchá spoločnosť na akcie'
        },
        {
            value: 'AGSR',
            labelcz: 'Jednotka štátnej železnično - technickej inšpekcie'
        },
        {
            value: '8KHD',
            labelcz: 'Jednotka zboru ozbrojenej ochrany železníc'
        },
        {
            value: '1GLU',
            labelcz: 'Jednotka železničného správneho úradu'
        },
        {
            value: 'KB52',
            labelcz: 'Komanditná spoločnosť'
        },
        {
            value: '2XNE',
            labelcz: 'Komoditná burza'
        },
        {
            value: 'KWFE',
            labelcz: 'Komora (s výnimkou profesných komôr)'
        },
        {
            value: '4CKX',
            labelcz: 'Krajský úrad'
        },
        {
            value: 'E1VK',
            labelcz: 'Medzinárodné organizácie a združenia'
        },
        {
            value: 'S5E1',
            labelcz: 'Miestna jednotka bez právnej spôsobilosti'
        },
        {
            value: 'U7QK',
            labelcz: 'Nadácia'
        },
        {
            value: 'STUP',
            labelcz: 'Národná banka Slovenska'
        },
        {
            value: '4GX1',
            labelcz: 'Národný výbor'
        },
        {
            value: '9NSV',
            labelcz: 'Neinvestičný fond'
        },
        {
            value: 'O0Y2',
            labelcz: 'Nešpecifikovaná právna forma'
        },
        {
            value: 'YRIU',
            labelcz: 'Nezisková organizácia'
        },
        {
            value: 'VRJP',
            labelcz: 'Nezisková organizácia poskytujúca všeobecne prospešné služby'
        },
        {
            value: 'L9WT',
            labelcz: 'Obec (obecný úrad), mesto (mestský úrad)'
        },
        {
            value: '1CSW',
            labelcz: 'Obecný podnik'
        },
        {
            value: 'OKAZ',
            labelcz: 'Obecný úrad'
        },
        {
            value: 'UCTO',
            labelcz: 'Oblastná organizačná jednotka ČSD'
        },
        {
            value: 'BKEB',
            labelcz: 'Oblastný závod poisťovne'
        },
        {
            value: 'MY1S',
            labelcz: 'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra'
        },
        {
            value: '8UE6',
            labelcz: 'Organizačná jednotka politickej strany, politického hnutia'
        },
        {
            value: 'ER02',
            labelcz: 'Organizačná jednotka združenia'
        },
        {
            value: 'YGN4',
            labelcz: 'Organizačná zložka podniku'
        },
        {
            value: 'N7I1',
            labelcz: 'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou'
        },
        {
            value: '46CD',
            labelcz: 'Pobočka sporiteľne'
        },
        {
            value: 'N9QW',
            labelcz: 'Pobočka štátneho peňažného ústavu'
        },
        {
            value: 'P6XJ',
            labelcz: 'Podnik alebo hospodárske zariadenie politickej strany'
        },
        {
            value: 'JKC5',
            labelcz: 'Podnik alebo hospodárske zariadenie združenia'
        },
        {
            value: 'YB59',
            labelcz: 'Podnik so zahraničnou majetkovou účasťou'
        },
        {
            value: 'Y45Q',
            labelcz: 'Podnik zahraničného obchodu'
        },
        {
            value: 'J8DW',
            labelcz: 'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)'
        },
        {
            value: 'SQ4I',
            labelcz: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním'
        },
        {
            value: 'TG3X',
            labelcz: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník'
        },
        {
            value: 'C4PZ',
            labelcz: 'Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri'
        },
        {
            value: 'WQCR',
            labelcz: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním'
        },
        {
            value: '93WZ',
            labelcz: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník'
        },
        {
            value: 'SPIE',
            labelcz: 'Podnikateľ-fyzická osoba-zapísaný v obchodnom registri'
        },
        {
            value: 'ED84',
            labelcz: 'Poisťovací spolok'
        },
        {
            value: 'GL07',
            labelcz: 'Poisťovňa - akciová spoločnosť'
        },
        {
            value: 'KZ3R',
            labelcz: 'Poisťovňa - štátny podnik'
        },
        {
            value: 'XLXU',
            labelcz: 'Politická strana, politické hnutie'
        },
        {
            value: '9L9V',
            labelcz: 'Poľnohospodárske družstvo'
        },
        {
            value: '43MZ',
            labelcz: 'Príspevková organizácia'
        },
        {
            value: '1HEP',
            labelcz: 'Rozpočtová organizácia'
        },
        {
            value: '14NU',
            labelcz: 'Rozpočtové a príspevkové organizácie'
        },
        {
            value: '73MQ',
            labelcz: 'Samosprávny kraj (úrad samosprávneho kraja)'
        },
        {
            value: 'R9GT',
            labelcz: 'Samostatná drobná prevádzkareň obecného úradu'
        },
        {
            value: '6R72',
            labelcz: 'Samostatne hospodáriaci roľník nezapísaný v obchodnom registri'
        },
        {
            value: '5Z8W',
            labelcz: 'Samostatne hospodáriaci roľník zapísaný v obchodnom registri'
        },
        {
            value: 'N5MX',
            labelcz: 'Samostatne podnikajúca fyzická osoba'
        },
        {
            value: '95MS',
            labelcz: 'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona'
        },
        {
            value: 'MSGT',
            labelcz:
                'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri'
        },
        {
            value: '90YN',
            labelcz: 'Sociálna a zdravotné poisťovne'
        },
        {
            value: 'ZG2I',
            labelcz: 'Spoločenstvá vlastníkov pozemkov, bytov a pod.'
        },
        {
            value: 'F560',
            labelcz: 'Spoločná záujmová organizácia družstiev'
        },
        {
            value: 'QCJ9',
            labelcz: 'Spoločnosť komanditná na akcie'
        },
        {
            value: 'VSZS',
            labelcz: 'Spoločnosť s ručením obmedzeným'
        },
        {
            value: 'O7TC',
            labelcz: 'Spoločný podnik'
        },
        {
            value: 'NL31',
            labelcz: 'Spoločný podnik (s viacerými zakladateľmi)'
        },
        {
            value: 'NLI7',
            labelcz: 'Sporiteľna'
        },
        {
            value: 'QACV',
            labelcz: 'Spotrebné družstvo'
        },
        {
            value: '5YBL',
            labelcz: 'Stavovská organizácia - profesná komora'
        },
        {
            value: '72R7',
            labelcz: 'Stredná škola'
        },
        {
            value: 'T0KQ',
            labelcz: 'Svojpomocné poľnohospodárske družstvo'
        },
        {
            value: '189Q',
            labelcz: 'Špecializovaná organizačná jednotka ČSD'
        },
        {
            value: 'CS8B',
            labelcz: 'Štátna hospodárska organizácia riadená okresným úradom'
        },
        {
            value: 'Y1X5',
            labelcz: 'Štátny podnik'
        },
        {
            value: '2KMA',
            labelcz: 'Štátny podnik v oddieli Pšn'
        },
        {
            value: 'NC88',
            labelcz: 'Účelová organizačná jednotka ČSD'
        },
        {
            value: 'FQRE',
            labelcz: 'Účelová zahranično - obchodná organizácia'
        },
        {
            value: '5J5Y',
            labelcz: 'Verejná obchodná spoločnosť'
        },
        {
            value: 'YF99',
            labelcz: 'Verejnoprávna inštitúcia'
        },
        {
            value: 'IW8Z',
            labelcz: 'Výrobné družstvo'
        },
        {
            value: 'HZG7',
            labelcz: 'Vysoká škola'
        },
        {
            value: '1W8B',
            labelcz: 'Zahraničná osoba'
        },
        {
            value: 'E9SH',
            labelcz: 'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR'
        },
        {
            value: '1K73',
            labelcz: 'Zahraničná osoba, právnická osoba so sídlom mimo územia SR'
        },
        {
            value: 'VSC1',
            labelcz: 'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra'
        },
        {
            value: 'DAQC',
            labelcz: 'Základná škola'
        },
        {
            value: '5AM3',
            labelcz: 'Zastupiteľské orgány iných štátov'
        },
        {
            value: 'NO20',
            labelcz: 'Zatiaľ neurčené'
        },
        {
            value: 'SUH3',
            labelcz: 'Záujmová organizácia družstiev'
        },
        {
            value: 'SMUS',
            labelcz: 'Záujmové združenie'
        },
        {
            value: 'YVWB',
            labelcz: 'Záujmové združenie fyzických osôb bez právnej spôsobilosti'
        },
        {
            value: 'SIRY',
            labelcz: 'Záujmové združenie právnických osôb'
        },
        {
            value: 'RF3D',
            labelcz: 'Združenie (zväz, spolok, spoločnosť, klub ai.)'
        },
        {
            value: 'KVQU',
            labelcz: 'Združenie medzinárodného obchodu'
        },
        {
            value: 'U5IM',
            labelcz: 'Železnice SR'
        }
    ],
    SM: [
        {
            value: '6JS5',
            labelcz: 'Società a responsabilità limitata'
        },
        {
            value: 'YVRM',
            labelcz: 'Società anonima'
        },
        {
            value: '7CKN',
            labelcz: 'Società in nome collettivo'
        },
        {
            value: 'AZ8V',
            labelcz: 'Società per azioni'
        }
    ],
    SR: [
        {
            value: 'OBTO',
            labelcz: 'Commanditaire vennootschap (op aandelen) met een beherende vennoot'
        },
        {
            value: 'QWWY',
            labelcz: 'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot'
        },
        {
            value: 'K4ZA',
            labelcz: 'Cooperatieve Vereniging'
        },
        {
            value: 'R6BI',
            labelcz: 'Eenmanszaak'
        },
        {
            value: 'KJZ3',
            labelcz: 'Filiaal of Bijkantoor'
        },
        {
            value: 'TCVB',
            labelcz: 'Naamloze Vennootschap / Limited Company by Shares'
        },
        {
            value: '8MS6',
            labelcz: 'Stichting'
        },
        {
            value: 'WBWC',
            labelcz: 'Vennootschap onder een firma'
        },
        {
            value: 'QPC9',
            labelcz: 'Vereniging'
        }
    ],
    SX: [
        {
            value: 'FBX9',
            labelcz: 'aandeelhouder-bestuurde vennootschap'
        },
        {
            value: '2CC3',
            labelcz: 'besloten vennootschap'
        },
        {
            value: 'YXX0',
            labelcz: 'commanditaire vennootschap'
        },
        {
            value: '2UBX',
            labelcz: 'commanditaire vennootschap op aandelen'
        },
        {
            value: 'NWT1',
            labelcz: 'coöperatie'
        },
        {
            value: '66T3',
            labelcz: 'eenmanszaak'
        },
        {
            value: 'SXX9',
            labelcz: 'naamloze vennootschap'
        },
        {
            value: 'B4OI',
            labelcz: 'onderlinge waarborgmaatschappij'
        },
        {
            value: '8W32',
            labelcz: 'openbare vennootschap'
        },
        {
            value: 'FI9R',
            labelcz: 'stichting'
        },
        {
            value: '52AV',
            labelcz: 'stichting particulier fonds'
        },
        {
            value: '1CSZ',
            labelcz: 'vereniging'
        }
    ],
    TO: [
        {
            value: 'UZUP',
            labelcz: 'Local Company'
        },
        {
            value: 'ZQEN',
            labelcz: 'Overseas Company'
        }
    ],
    TR: [
        {
            value: 'W2SQ',
            labelcz: 'anonim şirket'
        },
        {
            value: '5T3H',
            labelcz: 'Fonlar'
        },
        {
            value: 'JMQU',
            labelcz: 'kollektif şirket'
        },
        {
            value: 'ONVA',
            labelcz: 'komandit şirket'
        },
        {
            value: 'R5UT',
            labelcz: 'limited şirket'
        },
        {
            value: 'W8V9',
            labelcz: 'şahıs şirketi'
        }
    ],
    TZ: [
        {
            value: 'LVC6',
            labelcz: 'Company limited by guarantee'
        },
        {
            value: 'ND8M',
            labelcz: 'Non-Governmental Organisation'
        },
        {
            value: 'YPG1',
            labelcz: 'Partnership'
        },
        {
            value: '7QWA',
            labelcz: 'Private Limited Company'
        },
        {
            value: 'JZED',
            labelcz: 'Public Limited Company'
        },
        {
            value: 'RDZR',
            labelcz: 'Sole proprietorship'
        },
        {
            value: '5KVT',
            labelcz: 'Unlimited company'
        }
    ],
    UN: [],
    US: [
        {
            value: 'S745',
            labelcz: '(Business) Corporation'
        },
        {
            value: 'GHB2',
            labelcz: '(Business) Limited Liability Company'
        },
        {
            value: '93CA',
            labelcz: 'Agricultural Association'
        },
        {
            value: 'XBKP',
            labelcz: 'Agricultural Association'
        },
        {
            value: 'EZ08',
            labelcz: 'Agricultural Cooperative'
        },
        {
            value: '1XOG',
            labelcz: 'Agricultural Marketing Association'
        },
        {
            value: '4BEM',
            labelcz: 'Assumed Business Name'
        },
        {
            value: 'XUVE',
            labelcz: 'Bank'
        },
        {
            value: 'UFIY',
            labelcz: 'Bank'
        },
        {
            value: 'QUJ5',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'X4EB',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'OOX5',
            labelcz: 'Benefit Corporation'
        },
        {
            value: '9M2Q',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'QMI2',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'PNSZ',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'T0XH',
            labelcz: 'Benefit Corporation'
        },
        {
            value: 'GIN3',
            labelcz: 'Benefit LLC'
        },
        {
            value: '5E0K',
            labelcz: 'Benefit Professional Corporation'
        },
        {
            value: 'RPED',
            labelcz: 'Body Politic and Corporate'
        },
        {
            value: '5AE9',
            labelcz: 'Builidng and Loan Association'
        },
        {
            value: 'BRO8',
            labelcz: 'Business Corporation'
        },
        {
            value: 'AZUK',
            labelcz: 'Business Corporation'
        },
        {
            value: 'TTB3',
            labelcz: 'Business Corporation'
        },
        {
            value: 'S2K8',
            labelcz: 'Business Corporation'
        },
        {
            value: 'XST3',
            labelcz: 'Business Corporation'
        },
        {
            value: '6M6O',
            labelcz: 'Business Corporation'
        },
        {
            value: 'XSNP',
            labelcz: 'Business Corporation'
        },
        {
            value: 'PJ10',
            labelcz: 'Business Corporation'
        },
        {
            value: '1QMT',
            labelcz: 'Business Corporation'
        },
        {
            value: 'T5ZE',
            labelcz: 'Business Corporation'
        },
        {
            value: '3JTE',
            labelcz: 'Business Corporation'
        },
        {
            value: 'Z54A',
            labelcz: 'Business Corporation'
        },
        {
            value: '7QV2',
            labelcz: 'Business Corporation'
        },
        {
            value: 'JZWN',
            labelcz: 'Business Corporation'
        },
        {
            value: '6S32',
            labelcz: 'Business Corporation'
        },
        {
            value: 'CNQ3',
            labelcz: 'Business Corporation (including professional corporation)'
        },
        {
            value: 'D8PB',
            labelcz: 'Business Development Corporation'
        },
        {
            value: 'P24O',
            labelcz: 'Business Trust'
        },
        {
            value: 'EW9A',
            labelcz: 'Business Trust'
        },
        {
            value: 'OFGO',
            labelcz: 'Business Trust'
        },
        {
            value: 'QB0A',
            labelcz: 'Business Trust'
        },
        {
            value: 'SUEQ',
            labelcz: 'Business Trust'
        },
        {
            value: 'T2DF',
            labelcz: 'Business Trust'
        },
        {
            value: 'B12O',
            labelcz: 'Business Trust'
        },
        {
            value: 'BOEX',
            labelcz: 'Business Trust'
        },
        {
            value: 'O9MN',
            labelcz: 'Business Trust'
        },
        {
            value: '8OK2',
            labelcz: 'Business Trusts'
        },
        {
            value: 'N71W',
            labelcz: 'Cable & Video Franchise'
        },
        {
            value: 'U94O',
            labelcz: 'Captive Insurance Company'
        },
        {
            value: 'T4OL',
            labelcz: 'Cemetery associations'
        },
        {
            value: 'VKPN',
            labelcz: 'Close Corporation'
        },
        {
            value: '5MRP',
            labelcz: 'Close Corporation'
        },
        {
            value: 'WP6R',
            labelcz: 'Co-op'
        },
        {
            value: 'Z016',
            labelcz: 'Collection Agency'
        },
        {
            value: 'YOUG',
            labelcz: 'Commercial Registered Agent'
        },
        {
            value: 'ZXZ7',
            labelcz: 'Common Law Trust (Business Trust)'
        },
        {
            value: 'WIU6',
            labelcz: 'Community Development Corporation'
        },
        {
            value: '7OS8',
            labelcz: 'Congressional Chartered Corporation'
        },
        {
            value: 'FTNW',
            labelcz: 'Cooperative'
        },
        {
            value: 'JR3Z',
            labelcz: 'Cooperative'
        },
        {
            value: 'FZMT',
            labelcz: 'Cooperative'
        },
        {
            value: 'ZHZP',
            labelcz: 'Cooperative'
        },
        {
            value: 'LPEE',
            labelcz: 'Cooperative'
        },
        {
            value: 'UJ49',
            labelcz: 'Cooperative (Investor)'
        },
        {
            value: 'LDBS',
            labelcz: 'Cooperative (Producer)'
        },
        {
            value: 'ZCHO',
            labelcz: 'Cooperative Association'
        },
        {
            value: '32AX',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'SU5T',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'B2F4',
            labelcz: 'Cooperative Association'
        },
        {
            value: '7GMS',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'CJ58',
            labelcz: 'Cooperative Association'
        },
        {
            value: '2WJZ',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'QDZK',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'C0CR',
            labelcz: 'Cooperative Association'
        },
        {
            value: 'TRS2',
            labelcz: 'Cooperative Corporation'
        },
        {
            value: '672E',
            labelcz: 'Cooperative Corporation'
        },
        {
            value: 'UQWQ',
            labelcz: 'Cooperative Corporation'
        },
        {
            value: 'EO24',
            labelcz: 'Cooperative Grazing Associations'
        },
        {
            value: 'ST2Q',
            labelcz: 'Cooperative Marketing Association'
        },
        {
            value: 'PNF3',
            labelcz: 'Corporate Credit Union'
        },
        {
            value: 'XTIQ',
            labelcz: 'Corporation'
        },
        {
            value: '9STD',
            labelcz: 'Corporation'
        },
        {
            value: 'DAVB',
            labelcz: 'Corporation ( non-profit)'
        },
        {
            value: 'FGVH',
            labelcz: 'Corporation (Business or for-profit)'
        },
        {
            value: 'IJHI',
            labelcz: 'Corporation (for profit)'
        },
        {
            value: 'U7HC',
            labelcz: 'Corporation (For-Profit)'
        },
        {
            value: 'BTQ1',
            labelcz: 'Corporation (For-Profit)'
        },
        {
            value: 'PXGA',
            labelcz: 'Corporation (non-profit)'
        },
        {
            value: '78H5',
            labelcz: 'Corporation (Nonprofit)'
        },
        {
            value: 'DX2N',
            labelcz: 'Corporation (Nonprofit)'
        },
        {
            value: '47LQ',
            labelcz: 'Corporation (Nonprofit)'
        },
        {
            value: '7VK5',
            labelcz: 'Corporation (Nonprofit)'
        },
        {
            value: '5RRE',
            labelcz: 'Corporation (professional)'
        },
        {
            value: 'L2QV',
            labelcz: 'Corporation (Profit)'
        },
        {
            value: 'QWPR',
            labelcz: 'Corporation (profit)'
        },
        {
            value: 'EVBW',
            labelcz: 'Corporation Nonstock Nonprofit'
        },
        {
            value: 'IVQQ',
            labelcz: 'Corporation Sole'
        },
        {
            value: 'TTTV',
            labelcz: 'Corporation Sole'
        },
        {
            value: '4LKE',
            labelcz: 'County Agricultural Fair'
        },
        {
            value: 'HEMZ',
            labelcz: 'Credit Union'
        },
        {
            value: 'ZULC',
            labelcz: 'Development Corporation'
        },
        {
            value: 'R18M',
            labelcz: 'District Improvement Company'
        },
        {
            value: '1V0I',
            labelcz: 'Domestic Benefit Corporation'
        },
        {
            value: 'QX9N',
            labelcz: 'Domestic Benefit Corporation (including professional corporations)'
        },
        {
            value: 'ZJTK',
            labelcz: 'Domestic Business  Corporation'
        },
        {
            value: 'NI44',
            labelcz: 'Domestic Corporation'
        },
        {
            value: 'RH6N',
            labelcz: 'Domestic Corporation'
        },
        {
            value: 'ECLT',
            labelcz: 'Domestic Corporation Professional Corporation'
        },
        {
            value: 'KFPS',
            labelcz: 'Domestic General Partnership'
        },
        {
            value: '4TMV',
            labelcz: 'Domestic Limited Cooperative Association'
        },
        {
            value: 'CD9O',
            labelcz: 'Domestic Limited Liability Company'
        },
        {
            value: '8APW',
            labelcz: 'Domestic Limited Liability Company'
        },
        {
            value: 'YQDQ',
            labelcz: 'Domestic Limited Liability Partnership'
        },
        {
            value: 'DFPP',
            labelcz: 'Domestic Limited Partnership'
        },
        {
            value: 'ONJ1',
            labelcz: 'Domestic Low-Profit Limited Liability Company'
        },
        {
            value: '6EDK',
            labelcz: 'Domestic Non-Profit Corporation'
        },
        {
            value: 'O6QP',
            labelcz: 'Domestic Partnership'
        },
        {
            value: 'B843',
            labelcz: 'Domestic Professional Limited Liability Company'
        },
        {
            value: 'C1F4',
            labelcz: 'Domestic Public Benefit Corporation'
        },
        {
            value: 'NV9X',
            labelcz: 'Domestic Real Estate Investment Trust'
        },
        {
            value: 'TDBW',
            labelcz: 'Domestic Registered Limited Liability Partnership'
        },
        {
            value: 'MQU4',
            labelcz: 'Domestic Unincorporated Association'
        },
        {
            value: 'NGZJ',
            labelcz: 'Domesticated Foreign Corporation'
        },
        {
            value: 'CXIO',
            labelcz: 'Domesticated Foreign Corporation Professional Corporation'
        },
        {
            value: 'UJZB',
            labelcz: 'Ecclesiastical Corporation'
        },
        {
            value: 'YOB3',
            labelcz: 'Electric Cooperative Corporations'
        },
        {
            value: 'S68T',
            labelcz: 'Electric Cooperative Nonprofit Membership Corporation'
        },
        {
            value: 'F99D',
            labelcz: 'Electric Membership Cooperative'
        },
        {
            value: 'NETO',
            labelcz: 'Employee Cooperative Corporation'
        },
        {
            value: '1ADA',
            labelcz: 'Family Trust Company'
        },
        {
            value: 'LF4E',
            labelcz: 'Farm/Ranch Corporation'
        },
        {
            value: 'FK53',
            labelcz: 'Farm/Ranch Limited Laibility Company'
        },
        {
            value: '3KNT',
            labelcz: 'Federal Government Entity'
        },
        {
            value: '9HKD',
            labelcz: 'Financial Corporations'
        },
        {
            value: '95W7',
            labelcz: 'Financial Institution'
        },
        {
            value: 'MI0H',
            labelcz: 'for profit and not-for profit co-operatives'
        },
        {
            value: 'HFGV',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'EJX1',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'OWR6',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'R0BI',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'KC7Z',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'QJ9F',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: 'C5K7',
            labelcz: 'For-Profit Corporation'
        },
        {
            value: '7CDL',
            labelcz: 'For-Profit Corporation Close'
        },
        {
            value: 'H1UM',
            labelcz: 'For-Profit Corporation General Stock'
        },
        {
            value: 'PZR6',
            labelcz: 'For-Profit Corporation Professional'
        },
        {
            value: 'I3Z9',
            labelcz: 'For-Profit Public Benefit Corporation'
        },
        {
            value: 'Q8RV',
            labelcz: 'Foreign Benefit Corporation'
        },
        {
            value: '6ICB',
            labelcz: 'Foreign Corp Professional Corporation'
        },
        {
            value: 'HQYG',
            labelcz: 'Foreign Corporation'
        },
        {
            value: '8HNT',
            labelcz: 'Foreign Corporation'
        },
        {
            value: 'R3J6',
            labelcz: 'Foreign General Apartnership'
        },
        {
            value: 'ZEZ2',
            labelcz: 'Foreign Limited Cooperative Association'
        },
        {
            value: '9L6B',
            labelcz: 'Foreign Limited Liability Company'
        },
        {
            value: '5OET',
            labelcz: 'Foreign Limited Liability Company'
        },
        {
            value: 'MPFG',
            labelcz: 'Foreign Limited Liability Partnership'
        },
        {
            value: 'YWK0',
            labelcz: 'Foreign Limited Partnership'
        },
        {
            value: 'SJKV',
            labelcz: 'Foreign Non-Profit Corporation'
        },
        {
            value: '6DVA',
            labelcz: 'Foreign Non-Profit Limited Liability Company'
        },
        {
            value: '8PUO',
            labelcz: 'Foreign Partnership'
        },
        {
            value: 'BJ2V',
            labelcz: 'Foreign Professional Limited Liability Company'
        },
        {
            value: 'ZQZW',
            labelcz: 'Foreign Public Benefit'
        },
        {
            value: 'EO9A',
            labelcz: 'Foreign Real Estate Investment Trust'
        },
        {
            value: '520I',
            labelcz: 'Foundation'
        },
        {
            value: 'VYEO',
            labelcz: 'Fraternal Society'
        },
        {
            value: 'U9HL',
            labelcz: 'General Business Corporation'
        },
        {
            value: 'O35K',
            labelcz: 'General Cooperative Association'
        },
        {
            value: 'RSWJ',
            labelcz: 'General Partnership'
        },
        {
            value: 'SQ7B',
            labelcz: 'General Partnership'
        },
        {
            value: 'B38Q',
            labelcz: 'General Partnership'
        },
        {
            value: 'UK9P',
            labelcz: 'General Partnership'
        },
        {
            value: 'EBP8',
            labelcz: 'General Partnership'
        },
        {
            value: 'NK3V',
            labelcz: 'General Partnership'
        },
        {
            value: 'DEMP',
            labelcz: 'General Partnership'
        },
        {
            value: '8YBQ',
            labelcz: 'General Partnership'
        },
        {
            value: '6JCE',
            labelcz: 'General Partnership'
        },
        {
            value: '95OK',
            labelcz: 'General Partnership'
        },
        {
            value: '7TJ1',
            labelcz: 'General Partnership'
        },
        {
            value: '1CZS',
            labelcz: 'General Partnership'
        },
        {
            value: 'LTKC',
            labelcz: 'Home Service Contract Provider'
        },
        {
            value: 'Y7BG',
            labelcz: 'Hospital Authority'
        },
        {
            value: '1XME',
            labelcz: 'Housing Cooperative Corporation'
        },
        {
            value: 'T172',
            labelcz: 'Insurance Company'
        },
        {
            value: '5JAL',
            labelcz: 'Insurance Company'
        },
        {
            value: 'N0YQ',
            labelcz: 'Insurance Corporation'
        },
        {
            value: 'OXAZ',
            labelcz: 'Insurance Corporations'
        },
        {
            value: 'KPH8',
            labelcz: 'Investment Company'
        },
        {
            value: 'S97G',
            labelcz: 'Investment Trust'
        },
        {
            value: 'D2MO',
            labelcz: 'Joint Public Agency'
        },
        {
            value: 'NR96',
            labelcz: 'L3C'
        },
        {
            value: 'Q6EM',
            labelcz: 'L3C'
        },
        {
            value: 'MG8V',
            labelcz: 'L3C Low Profit LLC'
        },
        {
            value: 'A9VQ',
            labelcz: 'Limited Cooperative Assocation'
        },
        {
            value: '81WV',
            labelcz: 'Limited Cooperative Association'
        },
        {
            value: 'IPGV',
            labelcz: 'Limited Cooperative Association'
        },
        {
            value: 'CWRI',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'D4YS',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'O85W',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'M4FO',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'EI4J',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'L10T',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'Y182',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'HZEH',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '8N21',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '6IIM',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'VPBH',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'RU6X',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '8RLE',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'DQBZ',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '7XPF',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '53DC',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'BYFU',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'LJH5',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'BQRL',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'WPCN',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '7F5B',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'AEK0',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'MM8M',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'OJ9K',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'P7RH',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '4YOA',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'SDX0',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'X1EL',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'EZNQ',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'B8XC',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'QK2J',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '9C19',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'DRSE',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'DBGD',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'C276',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'I2XB',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'WYG5',
            labelcz: 'Limited Liability Company'
        },
        {
            value: '4WN7',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'F8DD',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'RC5L',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'M5RM',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'NB58',
            labelcz: 'Limited Liability Company'
        },
        {
            value: 'VNIU',
            labelcz: 'Limited Liability Company (including professional LLC and series LLC)'
        },
        {
            value: '3ZXC',
            labelcz: 'Limited Liability Company (LLC)'
        },
        {
            value: 'OE6T',
            labelcz: 'Limited Liability Company (LLC)'
        },
        {
            value: 'MY61',
            labelcz: 'Limited Liability Company (non-profit)'
        },
        {
            value: '6GEC',
            labelcz: 'Limited Liability Company (professional)'
        },
        {
            value: 'F2QV',
            labelcz: 'Limited Liability Company (profit)'
        },
        {
            value: '3MMY',
            labelcz: 'Limited Liability Limited Partership'
        },
        {
            value: 'WDT2',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'IMDT',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'L2DM',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'WE9D',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'TGMR',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'D155',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: '6MB6',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'IYZI',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: '30PQ',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'MTDW',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'UX5E',
            labelcz: 'Limited Liability Limited Partnership'
        },
        {
            value: 'M886',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'N69M',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'KGZ8',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'M64D',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'T80N',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '1HXP',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'QLWR',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'VUXH',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'D92T',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'T362',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'M9A1',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'CAGH',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '6E4G',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '6ZAR',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'U7GR',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '21OE',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '9OSW',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '7K6U',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'RCNI',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'FFBM',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'XIZI',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'X0MP',
            labelcz: 'limited liability partnership'
        },
        {
            value: 'J1V0',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '52U0',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'OJDX',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'WQLU',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'B8KO',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '7RLC',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'WTWK',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'Z9CH',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '8MBD',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '7H0X',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: '8XN0',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'RRXD',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'TJ6V',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'Z92A',
            labelcz: 'Limited Liability Partnership'
        },
        {
            value: 'M2KR',
            labelcz: 'Limited Liablity Partnership'
        },
        {
            value: 'HN8W',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'VXDE',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'A9AW',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'MJJZ',
            labelcz: 'Limited Partnership'
        },
        {
            value: '5HQ4',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'HLCG',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'LKQ2',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'T91T',
            labelcz: 'Limited Partnership'
        },
        {
            value: '5DS0',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'AD0H',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'AQBO',
            labelcz: 'Limited Partnership'
        },
        {
            value: '530K',
            labelcz: 'Limited Partnership'
        },
        {
            value: '1WZP',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'G4YY',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'HPKC',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'VE28',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'IIZ4',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'GOGQ',
            labelcz: 'Limited Partnership'
        },
        {
            value: '58N0',
            labelcz: 'Limited Partnership'
        },
        {
            value: '43LY',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'NDBR',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'EMLK',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'LPLY',
            labelcz: 'Limited Partnership'
        },
        {
            value: '62L3',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'G66U',
            labelcz: 'Limited Partnership'
        },
        {
            value: '7HY7',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'BO6L',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'ARON',
            labelcz: 'limited partnership'
        },
        {
            value: 'NHGN',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'ZD39',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'PQXK',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'GEE0',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'HSEV',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'FW66',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'G6VI',
            labelcz: 'Limited Partnership'
        },
        {
            value: '15JS',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'DQUB',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'FE1L',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'Q1N4',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'UF6Y',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'DQMV',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'LBJ1',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'SUMS',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'WNV6',
            labelcz: 'Limited Partnership'
        },
        {
            value: 'QR4Y',
            labelcz: 'Limited Partnership'
        },
        {
            value: '74LJ',
            labelcz: 'Limited Partnership (including Limited Liability Limited Partnership)'
        },
        {
            value: 'BC32',
            labelcz: 'Limited Partnership Association'
        },
        {
            value: 'UEKV',
            labelcz: 'Low Profit LLC'
        },
        {
            value: 'R8O9',
            labelcz: 'Low Profit LLC'
        },
        {
            value: '9FD9',
            labelcz: 'Master Limited Liability Company'
        },
        {
            value: 'WY1B',
            labelcz: 'Municipal'
        },
        {
            value: 'CPK1',
            labelcz: 'Mutual Aid Cooperative'
        },
        {
            value: 'Q4F9',
            labelcz: 'Mutual Association'
        },
        {
            value: '40SO',
            labelcz: 'Mutual Benefit Corporation'
        },
        {
            value: 'TCC0',
            labelcz: 'Mutual Benefit Enterprise'
        },
        {
            value: 'Y5L0',
            labelcz: 'Mutual Burial Association'
        },
        {
            value: 'QZDU',
            labelcz: 'National Trust Bank'
        },
        {
            value: 'LQZC',
            labelcz: 'Nebraska Benefit Corporation'
        },
        {
            value: 'R7JP',
            labelcz: 'Non Profit (Dom) Corporation'
        },
        {
            value: 'V4RX',
            labelcz: 'Non Profit Dom Limited Cooperative Association'
        },
        {
            value: '639V',
            labelcz: 'Non Profit Domesticated Foreign Corporation'
        },
        {
            value: 'O256',
            labelcz: 'Non Profit Foreign Corporation'
        },
        {
            value: 'IOWN',
            labelcz: 'Non Profit Foreign Limited Cooperative Association'
        },
        {
            value: '7BQ5',
            labelcz: 'Non Stock Corporation'
        },
        {
            value: 'HV3B',
            labelcz: 'Non Taxable Corporation'
        },
        {
            value: 'V65U',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: 'K2BJ',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: '1K9U',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: 'PDLV',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: '3N55',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: 'R7QO',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: '9I4Y',
            labelcz: 'Non-Profit Corporation'
        },
        {
            value: 'AVLE',
            labelcz: 'Non-profit Corporation'
        },
        {
            value: 'NOBH',
            labelcz: 'Non-profit Corporation'
        },
        {
            value: 'PNZI',
            labelcz: 'Non-profit Corporation'
        },
        {
            value: 'RR8G',
            labelcz: 'Non-profit Corporation'
        },
        {
            value: 'TBN1',
            labelcz: 'Non-Profit Limited Liability Company'
        },
        {
            value: 'BADE',
            labelcz: 'Nonprofit Common Interest Development Association'
        },
        {
            value: 'JF6D',
            labelcz: 'Nonprofit Community Trust'
        },
        {
            value: 'S7VR',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'EVE6',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'HSPI',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'V89I',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'HUSW',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: '2XXG',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'O4NK',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'IY8C',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'P3LZ',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'T4M6',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'W0U4',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: '358I',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'U87X',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'UZ83',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: '9EJ6',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: '11GD',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'RD1T',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'OGSS',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'ZJPG',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'PUJR',
            labelcz: 'Nonprofit Corporation'
        },
        {
            value: 'G1P6',
            labelcz: 'Nonprofit Corporation Mutual Benefit'
        },
        {
            value: 'K7YU',
            labelcz: 'Nonprofit Corporation Public Benefit'
        },
        {
            value: 'CVXK',
            labelcz: 'Nonprofit Corporation Religious'
        },
        {
            value: 'UGE3',
            labelcz: 'Nonprofit Electric Generation and Transmission Cooperative Corporation'
        },
        {
            value: 'DLEW',
            labelcz: 'Nonprofit Limited Liability Company'
        },
        {
            value: '7W53',
            labelcz: 'Nonstock Corporation'
        },
        {
            value: 'PLMC',
            labelcz: 'Nonstock Corporation'
        },
        {
            value: 'R8SH',
            labelcz: 'Not For Profit Corporation'
        },
        {
            value: '51RC',
            labelcz: 'Not-for-profit Corporation'
        },
        {
            value: 'VJXH',
            labelcz: 'Not-for-profit Corporation'
        },
        {
            value: 'QF4W',
            labelcz: 'Partnership'
        },
        {
            value: '456O',
            labelcz: 'Partnership'
        },
        {
            value: 'AEJF',
            labelcz: 'Professional Association'
        },
        {
            value: 'MXWB',
            labelcz: 'Professional Association'
        },
        {
            value: 'V5G5',
            labelcz: 'Professional Benefit Corporation'
        },
        {
            value: 'T91C',
            labelcz: 'Professional Close Corporation'
        },
        {
            value: 'OVBT',
            labelcz: 'Professional Corporation'
        },
        {
            value: '5MNR',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'ASC7',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'S0BB',
            labelcz: 'Professional Corporation'
        },
        {
            value: '78PB',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'L22N',
            labelcz: 'Professional Corporation'
        },
        {
            value: '6I75',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'HQJV',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'A770',
            labelcz: 'Professional Corporation'
        },
        {
            value: '8QMN',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'OGHV',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'V10Q',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'N10D',
            labelcz: 'Professional Corporation'
        },
        {
            value: '9AAS',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'IDFN',
            labelcz: 'Professional Corporation'
        },
        {
            value: 'GZMZ',
            labelcz: 'Professional Corporation'
        },
        {
            value: '37F5',
            labelcz: 'Professional Firms'
        },
        {
            value: 'QEEJ',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: 'VVPD',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: 'IN4H',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: 'MY93',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: '3DXJ',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: '64HG',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: 'K4MF',
            labelcz: 'Professional Limited Liability Company'
        },
        {
            value: 'L1PM',
            labelcz: 'Professional Limited Liability Limited Partnership'
        },
        {
            value: '4U9V',
            labelcz: 'Professional Limited Liabity Partnership'
        },
        {
            value: '1S9L',
            labelcz: 'Professional Series Limited Liability Company'
        },
        {
            value: 'RZ5R',
            labelcz: 'Professional Service Corporation'
        },
        {
            value: 'F5VL',
            labelcz: 'Professional Services Corporation'
        },
        {
            value: 'TRI2',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'MFYJ',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'DU35',
            labelcz: 'Profit Corporation'
        },
        {
            value: '8WM4',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'VG3S',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'BGH4',
            labelcz: 'Profit Corporation'
        },
        {
            value: '2I4P',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'NYUD',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'NHYA',
            labelcz: 'Profit Corporation'
        },
        {
            value: '9GXA',
            labelcz: 'Profit Corporation'
        },
        {
            value: 'SCX8',
            labelcz: 'Public Benefit Corporation'
        },
        {
            value: 'O5PH',
            labelcz: 'Public Benefit Corporation (profit)'
        },
        {
            value: '1ONH',
            labelcz: 'Public Benefit Corporations'
        },
        {
            value: 'SIST',
            labelcz: 'Public Transportation Authority'
        },
        {
            value: 'WMTY',
            labelcz: 'Publicity Rights Name Registration'
        },
        {
            value: 'ER7C',
            labelcz: 'Publicly Traded Corporation'
        },
        {
            value: 'XTOF',
            labelcz: 'Railroad'
        },
        {
            value: '6NI8',
            labelcz: 'Railroad'
        },
        {
            value: 'NJA5',
            labelcz: 'Real Estate Investment Trusts'
        },
        {
            value: 'R22H',
            labelcz: 'Registered Agent Designation'
        },
        {
            value: 'YJZ3',
            labelcz: 'Registered Limited Liability Limited Partnership'
        },
        {
            value: 'CR3H',
            labelcz: 'Registered Limited Liability Partnership'
        },
        {
            value: '8KA4',
            labelcz: 'Registered Limited Liability Partnership'
        },
        {
            value: '71ZI',
            labelcz: 'Registered Limited Liability Partnership'
        },
        {
            value: '9A4Q',
            labelcz: 'Religious Corporation'
        },
        {
            value: 'WRF9',
            labelcz: 'Religious Corporation'
        },
        {
            value: '1ASH',
            labelcz: 'Religious corporations'
        },
        {
            value: 'L7HH',
            labelcz: 'Religious Society or Religious Corporation'
        },
        {
            value: 'JGPP',
            labelcz: 'Rural Cooperative Association'
        },
        {
            value: '3GTV',
            labelcz: 'Sanitary & Improvement District'
        },
        {
            value: 'IHLF',
            labelcz: 'Savings & Loan Association'
        },
        {
            value: 'TZQL',
            labelcz: 'Savings Bank'
        },
        {
            value: 'LGQZ',
            labelcz: 'Savings Bank'
        },
        {
            value: 'VCQZ',
            labelcz: 'Series'
        },
        {
            value: 'XVC6',
            labelcz: 'Series Limited Liability Company'
        },
        {
            value: '982Z',
            labelcz: 'Service Mark'
        },
        {
            value: '88XU',
            labelcz: 'Sole proprietorship'
        },
        {
            value: 'UKX4',
            labelcz: 'State Savings Bank'
        },
        {
            value: 'G0HE',
            labelcz: 'Statutory Close Corporation'
        },
        {
            value: '1YA4',
            labelcz: 'Statutory Foundation'
        },
        {
            value: 'SHCN',
            labelcz: 'Statutory Trust'
        },
        {
            value: '4FSX',
            labelcz: 'Statutory Trust'
        },
        {
            value: '85YQ',
            labelcz: 'Statutory Trust'
        },
        {
            value: 'SQOE',
            labelcz: 'Statutory Trust'
        },
        {
            value: 'RDQZ',
            labelcz: 'Statutory Trust'
        },
        {
            value: 'JKOT',
            labelcz: 'Stock Corporation'
        },
        {
            value: 'HOV4',
            labelcz: 'Stock Corporation'
        },
        {
            value: 'SBF3',
            labelcz: 'Sustainable Business Corporation'
        },
        {
            value: 'L5BO',
            labelcz: 'Trade Name'
        },
        {
            value: 'ZLIW',
            labelcz: 'Trademark'
        },
        {
            value: '30TX',
            labelcz: 'Trust Company'
        },
        {
            value: 'YQLO',
            labelcz: 'Uniform Limited Cooperative Association'
        },
        {
            value: 'LU9O',
            labelcz: 'Unincorporated Non-Profit Assocation'
        },
        {
            value: 'OJBU',
            labelcz: 'Unincorporated Non-Profit Association'
        },
        {
            value: '12N6',
            labelcz: 'Unincorporated Nonprofit Association'
        },
        {
            value: 'DURX',
            labelcz: 'Voluntary Association'
        },
        {
            value: 'Z73Z',
            labelcz: 'Voluntary Association and Business Trusts'
        },
        {
            value: 'N263',
            labelcz: 'Workers Cooperative'
        }
    ],
    UY: [
        {
            value: 'TMHL',
            labelcz: 'Asociacion'
        },
        {
            value: 'QO9Q',
            labelcz: 'Cooperativa'
        },
        {
            value: 'ETZT',
            labelcz: 'Empresa Unipersonal'
        },
        {
            value: 'NXHQ',
            labelcz: 'Establecimiento Comercial'
        },
        {
            value: '1QNZ',
            labelcz: 'Fundacion'
        },
        {
            value: 'ZYQX',
            labelcz: 'Persona Jurídica de Derecho Público No Estatal'
        },
        {
            value: 'J2DN',
            labelcz: 'Sindicato'
        },
        {
            value: 'YRMK',
            labelcz: 'Sociedad Anónima'
        },
        {
            value: 'FKG5',
            labelcz: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: '32J9',
            labelcz: 'Sociedad por Acciones Simplificada'
        }
    ],
    VG: [
        {
            value: 'ZHED',
            labelcz: 'company limited by guarantee that is authorised to issue shares'
        },
        {
            value: 'BST2',
            labelcz: 'company limited by guarantee that is not authorised to issue shares'
        },
        {
            value: '6EH6',
            labelcz: 'company limited by shares'
        },
        {
            value: 'GLCI',
            labelcz: 'restricted purposes company'
        },
        {
            value: 'N28C',
            labelcz: 'restricted purposes company segregated portfolio company'
        },
        {
            value: 'YOP9',
            labelcz: 'segregated portfolio company'
        },
        {
            value: 'Q62B',
            labelcz: 'unlimited company that is authorised to issue shares'
        },
        {
            value: 'JS65',
            labelcz: 'unlimited company that is not authorised to issue shares'
        }
    ],
    VI: [
        {
            value: 'CHWX',
            labelcz: 'Domestic Limited Liability Company'
        },
        {
            value: 'TA9Z',
            labelcz: 'Domestic Limited Liability Partnership'
        },
        {
            value: 'MGUM',
            labelcz: 'Domestic Limited Partnership / Limited Liability Limited Partnership'
        },
        {
            value: 'PKZ2',
            labelcz: 'Domestic Non-Profit Corporation'
        },
        {
            value: 'NNLM',
            labelcz: 'Domestic Profit Corporation'
        },
        {
            value: 'MH3L',
            labelcz: 'Domestic Trade & Labor Corporation'
        },
        {
            value: 'SOX5',
            labelcz: 'Foreign Limited Liability Company'
        },
        {
            value: 'Q367',
            labelcz: 'Foreign Limited Liability Partnership'
        },
        {
            value: 'AN8Z',
            labelcz: 'Foreign Limited Partnership / Limited Liability Limited Partnership'
        },
        {
            value: 'DMNZ',
            labelcz: 'Foreign Non-Profit Corporation'
        },
        {
            value: 'UZ9W',
            labelcz: 'Foreign Profit Corporation'
        },
        {
            value: 'A30N',
            labelcz: 'Foreign Trade & Labor Corporation'
        }
    ],
    VU: [
        {
            value: 'WMJ9',
            labelcz: 'Foundation'
        },
        {
            value: '5Q66',
            labelcz: 'International Company'
        },
        {
            value: 'JTJE',
            labelcz: 'Local Company'
        }
    ],
    WS: [
        {
            value: 'TOMA',
            labelcz: 'Co-operative society'
        },
        {
            value: 'BCM3',
            labelcz: 'Credit Union'
        },
        {
            value: '1RPE',
            labelcz: 'Charitable trust'
        },
        {
            value: 'SXY3',
            labelcz: 'Incorporated society'
        },
        {
            value: 'QWFD',
            labelcz: 'Overseas company'
        },
        {
            value: 'M6YY',
            labelcz: 'Private limited company'
        },
        {
            value: '7WL9',
            labelcz: 'Public limited company'
        }
    ],
    XK: [
        {
            value: 'QZEN',
            labelcz: 'Biznes Individual'
        },
        {
            value: 'OZDY',
            labelcz: 'Dega e Shoqërisë së Huaj Tregtare në Kosovë'
        },
        {
            value: 'CRX3',
            labelcz: 'Kooperativa Bujqësore'
        },
        {
            value: 'W5H8',
            labelcz: 'Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike'
        },
        {
            value: '3YUD',
            labelcz: 'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit'
        },
        {
            value: 'W7KV',
            labelcz: 'Ortakëri e Kufizuar'
        },
        {
            value: 'T2X0',
            labelcz: 'Ortakëri e Përgjithshme'
        },
        {
            value: 'Q22D',
            labelcz: 'Shoqëri aksionare'
        },
        {
            value: 'D37H',
            labelcz: 'Shoqëri me Përgjegjësi të Kufizuar'
        },
        {
            value: 'B56A',
            labelcz: 'Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë'
        }
    ],
    XX: [],
    ZA: [
        {
            value: '4YUU',
            labelcz: 'Close Corporation'
        },
        {
            value: 'MZT6',
            labelcz: 'Co-operatives (Primary)'
        },
        {
            value: 'CXWJ',
            labelcz: 'Co-operatives (Secondary)'
        },
        {
            value: 'ZE81',
            labelcz: 'Co-operatives (Tertiary)'
        },
        {
            value: 'R59V',
            labelcz: 'External Company'
        },
        {
            value: 'J7L0',
            labelcz: 'Non-Profit Company'
        },
        {
            value: 'U89P',
            labelcz: 'Personal Liability Company'
        },
        {
            value: 'GQVQ',
            labelcz: 'Private Company'
        },
        {
            value: 'XE4Z',
            labelcz: 'Public Company'
        },
        {
            value: 'R155',
            labelcz: 'State Owned Company'
        }
    ]
};
